import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  products: [
    {
      id: "f1",
      sortOrder: 800,
      category: "flowers",
      name: "ליליות",
      minQuantity: 10,
      maxQuantity: 3990,
      comment: "נא לציין את הצבע המבוקש",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/flowers/f1.jpg",
    },
    {
      id: "f2",
      sortOrder: 820,
      category: "flowers",
      name: "שושן אוריינטלי רב פעמונים",
      minQuantity: 10,
      maxQuantity: 3990,
      comment: "לבן\\ורוד בהיר\\פוקסיה\\כתום-חדש",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/flowers/f2.jpg",
    },
    {
      id: "f3",
      sortOrder: 830,
      category: "flowers",
      name: "שושן אוריינטלי רב פעמונים כפול",
      minQuantity: 10,
      maxQuantity: 3990,
      comment: "ורוד, לבן, דו-גוני (ורוד ולבן)",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/flowers/f3.jpg",
    },
    {
      id: "f4",
      sortOrder: 910,
      category: "flowers",
      name: "חמניות ואן גוך",
      minQuantity: 10,
      maxQuantity: 3990,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/flowers/f4.jpg",
    },
    {
      id: "f5",
      sortOrder: 920,
      category: "flowers",
      name: "חמניות גדולות חומות\\צהובות",
      minQuantity: 10,
      maxQuantity: 3990,
      comment: "פתוח\\סגור",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/flowers/f5.jpg",
    },
    {
      id: "f6",
      sortOrder: 1390,
      category: "flowers",
      name: "סייפן",
      minQuantity: 10,
      maxQuantity: 3990,
      comment:
        "ורוד / לבן / אדום / צהוב / כתום / סגול / בורדו / אפרסק / דו-גוני",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/flowers/f6.jpg",
    },
    {
      id: "f7",
      sortOrder: 1320,
      category: "flowers",
      name: "חרציות אקסטרה",
      minQuantity: 30,
      maxQuantity: 3990,
      comment: "יש לבחור ראש מלא/מרגרטה/פונפון/סנטיני ולרשום צבע מבוקש",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/flowers/f7.jpg",
    },
    {
      id: "f8",
      sortOrder: 1310,
      category: "flowers",
      name: "חרציות א רגולסקי/ב בן צבי",
      minQuantity: 30,
      maxQuantity: 3990,
      comment: "ראש מלא,מרגרטה,פונפון,סנטיני ולציין צבע בבקשה",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/flowers/f8.jpg",
    },
    {
      id: "f9",
      sortOrder: 1370,
      category: "flowers",
      name: "לימוניום אמילי",
      minQuantity: 1,
      maxQuantity: 3999,
      comment: "סגול / ורוד / לבן, מכיל 15 ענף בממוצע",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/flowers/f9.jpg",
    },
    {
      id: "f10",
      sortOrder: 1260,
      category: "flowers",
      name: "אסטר שורש",
      minQuantity: 10,
      maxQuantity: 3990,
      comment: `סגול\\אדום\\ורוד\\לבן`,
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/flowers/f10.jpg",
    },
    {
      id: "f11",
      sortOrder: 840,
      category: "flowers",
      name: "גרברה כדור",
      minQuantity: 20,
      maxQuantity: 3980,
      comment: 'צבע ירוק-שחור,קוטר ראש בערך 3-4 ס"מ',
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/flowers/f11.jpg",
    },
    {
      id: "f12",
      sortOrder: 850,
      category: "flowers",
      name: "גרברה",
      minQuantity: 20,
      maxQuantity: 3980,
      comment: "נא לציין את הצבע המבוקש",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/flowers/f12.jpg",
    },
    {
      id: "f13",
      sortOrder: 860,
      category: "flowers",
      name: "גרברה מיני",
      minQuantity: 20,
      maxQuantity: 3980,
      comment: "נא לציין את הצבע המבוקש",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/flowers/f13.jpg",
    },
    {
      id: "f14",
      sortOrder: 900,
      category: "flowers",
      name: "גרברה פסטה",
      minQuantity: 20,
      maxQuantity: 3980,
      comment: "נא לציין את הצבע המבוקש",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/flowers/f14.jpg",
    },
    {
      id: "f15",
      sortOrder: 1360,
      category: "flowers",
      name: "לוע ארי",
      minQuantity: 10,
      maxQuantity: 3990,
      comment: "נא לציין את הצבע המבוקש",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/flowers/f15.jpg",
    },
    {
      id: "f16",
      sortOrder: 870,
      category: "flowers",
      name: "גרברה מיקרו",
      minQuantity: 20,
      maxQuantity: 3980,
      comment: "יש לבחור לב שחור\\ירוק ולרשום צבע מבוקש",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/flowers/f16.jpg",
    },
    {
      id: "f17",
      sortOrder: 890,
      category: "flowers",
      name: "גרברה פונפון",
      minQuantity: 20,
      maxQuantity: 3980,
      comment: "יש לציין צבע",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/flowers/f17.jpg",
    },
    {
      id: "f18",
      sortOrder: 880,
      category: "flowers",
      name: "גרברה ספיידר",
      minQuantity: 20,
      maxQuantity: 3980,
      comment: "יש לציין צבע",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/flowers/f18.jpg",
    },
    {
      id: "f19",
      sortOrder: 1080,
      category: "flowers",
      name: "גיפסנית פרח גדול",
      minQuantity: 1,
      maxQuantity: 3999,
      comment: "לבן 25 ענף בממוצע",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/flowers/f19.jpg",
    },
    {
      id: "f20",
      sortOrder: 1280,
      category: "flowers",
      name: "גיפסנית  צבועה",
      minQuantity: 1,
      maxQuantity: 3999,
      comment: "צבע אחיד\\מיקס",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/flowers/f20.jpg",
    },
    {
      id: "f21",
      sortOrder: 1420,
      category: "flowers",
      name: "ציניה פרחים",
      minQuantity: 10,
      maxQuantity: 3990,
      comment: "נא לציין את הצבע המבוקש",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/flowers/f21.jpg",
    },
    {
      id: "f22",
      sortOrder: 1160,
      category: "flowers",
      name: "פלוקס ירוק",
      minQuantity: 20,
      maxQuantity: 3980,
      comment: "ירוק",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/flowers/f22.jpg",
    },
    {
      id: "f23",
      sortOrder: 1410,
      category: "flowers",
      name: "פלוקס פתוח",
      minQuantity: 50,
      maxQuantity: 3950,
      comment: "נא לציין את הצבע המבוקש",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/flowers/f23.jpg",
    },
    {
      id: "f24",
      sortOrder: 1300,
      category: "flowers",
      name: "ורוניקה",
      minQuantity: 20,
      maxQuantity: 3980,
      comment: "נא לציין את הצבע המבוקש",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/flowers/f24.jpg",
    },
    {
      id: "f25",
      sortOrder: 1400,
      category: "flowers",
      name: "פלוקס",
      minQuantity: 50,
      maxQuantity: 3950,
      comment: "לבן / ורוד / סגול / לילך / אדום / דו-גוני",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/flowers/f25.jpg",
    },
    {
      id: "f26",
      sortOrder: 1270,
      category: "flowers",
      name: "גונפרנה",
      minQuantity: 1,
      maxQuantity: 3999,
      comment: "סגול / ורוד / לבן / אדום / כתום, נא לציין צבע",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/flowers/f26.jpg",
    },
    {
      id: "f27",
      sortOrder: 1220,
      category: "flowers",
      name: "אכילאה טבעית",
      minQuantity: 1,
      maxQuantity: 3999,
      comment:
        "שימו לב: נעשה מאמץ לצבע מדויק או קרוב. לאירועים וכמויות גדולות – ודאו זמינות מראש",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/flowers/f27.jpg",
    },
    {
      id: "f28",
      sortOrder: 1090,
      category: "flowers",
      name: "הביסקוס אדום",
      minQuantity: 10,
      maxQuantity: 3990,
      comment: "אדום",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/flowers/f28.jpg",
    },
    {
      id: "f29",
      sortOrder: 1450,
      category: "flowers",
      name: "קאלות צבעוניות",
      minQuantity: 10,
      maxQuantity: 3990,
      comment: "נא לציין את הצבע המבוקש",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/flowers/f29.jpg",
    },
    {
      id: "f30",
      sortOrder: 1480,
      category: "flowers",
      name: "שום גדול",
      minQuantity: 10,
      maxQuantity: 3990,
      comment: "נא לציין את הצבע המבוקש",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/flowers/f30.jpg",
    },
    {
      id: "f31",
      sortOrder: 750,
      category: "flowers",
      name: "שושן יפני זוגות פעמונים",
      minQuantity: 100,
      maxQuantity: 3900,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/flowers/f31.jpg",
    },
    {
      id: "f32",
      sortOrder: 620,
      category: "flowers",
      name: 'ורד - 50 ס"מ גובה',
      minQuantity: 200,
      maxQuantity: 3900,
      comment: "נא לציין את הצבע המבוקש",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/flowers/f32.jpg",
    },
    {
      id: "f33",
      sortOrder: 810,
      category: "flowers",
      name: "ליליות sweet sugar",
      minQuantity: 10,
      maxQuantity: 3990,
      comment: "סגור,לפתיחה נא להזמין מראש שבוע",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/flowers/f33.jpg",
    },
    {
      id: "f34",
      sortOrder: 730,
      category: "flowers",
      name: "שושן אורנטלי צהוב",
      minQuantity: 10,
      maxQuantity: 3990,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/flowers/f34.jpg",
    },
    {
      id: "f35",
      sortOrder: 1020,
      category: "flowers",
      name: "ליזיאנטוס קיטומים לבן",
      minQuantity: 50,
      maxQuantity: 3950,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/flowers/f35.jpg",
    },
    {
      id: "f36",
      sortOrder: 1000,
      category: "flowers",
      name: "ליזיאנטוס קיטומים ורוד",
      minQuantity: 50,
      maxQuantity: 3950,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/flowers/f36.jpg",
    },
    {
      id: "f37",
      sortOrder: 1040,
      category: "flowers",
      name: "ליזיאנטוס קיטומים פוקסיה",
      minQuantity: 50,
      maxQuantity: 3950,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/flowers/f37.jpg",
    },
    {
      id: "f38",
      sortOrder: 1050,
      category: "flowers",
      name: "ליזיאנטוס קיטומים שמפיין",
      minQuantity: 50,
      maxQuantity: 3950,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/flowers/f38.jpg",
    },
    {
      id: "f39",
      sortOrder: 1010,
      category: "flowers",
      name: "ליזיאנטוס קיטומים ורוד בהיר",
      minQuantity: 50,
      maxQuantity: 3950,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/flowers/f39.jpg",
    },
    {
      id: "f40",
      sortOrder: 720,
      category: "flowers",
      name: "ליזיאנטוס קיטומים לילך",
      minQuantity: 50,
      maxQuantity: 3950,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/flowers/f40.jpg",
    },
    {
      id: "f41",
      sortOrder: 1030,
      category: "flowers",
      name: "ליזיאנטוס קיטומים סגול",
      minQuantity: 50,
      maxQuantity: 3950,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/flowers/f41.jpg",
    },
    {
      id: "f42",
      sortOrder: 1350,
      category: "flowers",
      name: "כרבולת",
      minQuantity: 10,
      maxQuantity: 3990,
      comment: "אדום / צהוב / כתום / ורוד / בורדו / לבן",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/flowers/f42.jpg",
    },
    {
      id: "f43",
      sortOrder: 760,
      category: "flowers",
      name: "שושן יפני פעמון בודד",
      minQuantity: 10,
      maxQuantity: 3990,
      comment: "הפרח מגיע סגור וירקרק, ונפתח לפריחה לבנה",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/flowers/f43.jpg",
    },
    {
      id: "f44",
      sortOrder: 780,
      category: "flowers",
      name: "שושן יפני שני פעומונים",
      minQuantity: 10,
      maxQuantity: 3990,
      comment: "הפרח מגיע סגור וירקרק, ונפתח לפריחה לבנה",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/flowers/f44.jpg",
    },
    {
      id: "f45",
      sortOrder: 770,
      category: "flowers",
      name: "שושן יפני רב פעמונים",
      minQuantity: 10,
      maxQuantity: 3990,
      comment: "הפרח מגיע סגור וירקרק, ונפתח לפריחה לבנה",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/flowers/f45.jpg",
    },
    {
      id: "f46",
      sortOrder: 1130,
      category: "flowers",
      name: "מובידיק",
      minQuantity: 1,
      maxQuantity: 3999,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/flowers/f46.jpg",
    },
    {
      id: "f47",
      sortOrder: 1230,
      category: "flowers",
      name: "אלסטרומריה שטח",
      minQuantity: 20,
      maxQuantity: 3980,
      comment: "נא לציין את הצבע המבוקש",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/flowers/f47.jpg",
    },
    {
      id: "f48",
      sortOrder: 1330,
      category: "flowers",
      name: "חרצית ראש",
      minQuantity: 30,
      maxQuantity: 3990,
      comment:
        "צהוב / לבן / ורוד / סגול / בורדו / כתום / ירוק, נא לציין את הצבע המבוקש",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/flowers/f48.jpg",
    },
    {
      id: "f49",
      sortOrder: 1460,
      category: "flowers",
      name: "קורקומה",
      minQuantity: 5,
      maxQuantity: 3995,
      comment: "נא לציין את הגוון המבוקש",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/flowers/f49.jpg",
    },
    {
      id: "f50",
      sortOrder: 1470,
      category: "flowers",
      name: "קורקומה דו צבע",
      minQuantity: 10,
      maxQuantity: 3990,
      comment: "נא לציין את הגוון המבוקש",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/flowers/f50.jpg",
    },
    {
      id: "f51",
      sortOrder: 1060,
      category: "flowers",
      name: 'ליזיאנטוס באלה 50 ס"מ',
      minQuantity: 50,
      maxQuantity: 3950,
      comment: "לבן / ורוד / סגול / שמנת / אפרסק / ירוק-בהיר / דו-גוני",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/flowers/f51.jpg",
    },
    {
      id: "f52",
      sortOrder: 1290,
      category: "flowers",
      name: "דליה",
      minQuantity: 10,
      maxQuantity: 3990,
      comment: "נא לציין צבע מבוקש",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/flowers/f52.jpg",
    },
    {
      id: "f53",
      sortOrder: 1140,
      category: "flowers",
      name: "סגולית",
      minQuantity: 10,
      maxQuantity: 3990,
      comment: "לילך",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/flowers/f53.jpg",
    },
    {
      id: "f54",
      sortOrder: 930,
      category: "flowers",
      name: "חמניות ראש קטן",
      minQuantity: 10,
      maxQuantity: 3990,
      comment: "סגור\\פתוח",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/flowers/f54.jpg",
    },
    {
      id: "f55",
      sortOrder: 1070,
      category: "flowers",
      name: "בבונג שדה(קמומיל)",
      minQuantity: 10,
      maxQuantity: 3990,
      comment: "צהוב-כותרת לבן",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/flowers/f55.jpg",
    },
    {
      id: "f56",
      sortOrder: 1250,
      category: "flowers",
      name: "אמרנטוס זקוף",
      minQuantity: 10,
      maxQuantity: 3990,
      comment: "בורדו/אדום עמוק, ירוק, ברונזה/חום",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/flowers/f56.jpg",
    },
    {
      id: "f57",
      sortOrder: 1240,
      category: "flowers",
      name: "אמרנטוס",
      minQuantity: 10,
      maxQuantity: 3990,
      comment: "בורדו/אדום עמוק, ירוק, ברונזה/חום",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/flowers/f57.jpg",
    },
    {
      id: "f58",
      sortOrder: 1170,
      category: "flowers",
      name: "פרח ירקה",
      minQuantity: 50,
      maxQuantity: 3950,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/flowers/f58.jpg",
    },
    {
      id: "f59",
      sortOrder: 790,
      category: "flowers",
      name: "שושן פתוח",
      minQuantity: 10,
      maxQuantity: 3990,
      comment:
        "נפתח לפריחה לבנה ונשאר נקי מאבקנים. חובה להזמין לפחות 4 ימים מראש",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/flowers/f59.jpg",
    },
    {
      id: "f60",
      sortOrder: 1180,
      category: "flowers",
      name: "קורקומה לבנה",
      minQuantity: 10,
      maxQuantity: 3990,
      comment: "לבן",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/flowers/f60.jpg",
    },
    {
      id: "f61",
      sortOrder: 740,
      category: "flowers",
      name: "שושן ורוד כפול\\רב פעמוני",
      minQuantity: 10,
      maxQuantity: 3990,
      comment: "מגיע סגור בלבד. לפתיחה בזמן יש להזמין שבוע מראש",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/flowers/f61.jpg",
    },
    {
      id: "f62",
      sortOrder: 1190,
      category: "flowers",
      name: "קורקומה שוקולד",
      minQuantity: 10,
      maxQuantity: 3990,
      comment: "חום-לבן",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/flowers/f62.jpg",
    },
    {
      id: "f63",
      sortOrder: 1210,
      category: "flowers",
      name: "רימון שחור",
      minQuantity: 1,
      maxQuantity: 3999,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/flowers/f63.jpg",
    },
    {
      id: "f64",
      sortOrder: 1200,
      category: "flowers",
      name: "רימון אדום",
      minQuantity: 1,
      maxQuantity: 3999,
      comment: "גוון ירוק-אדום",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/flowers/f64.jpg",
    },
    {
      id: "f65",
      sortOrder: 1110,
      category: "flowers",
      name: "טווידה לבן",
      minQuantity: 25,
      maxQuantity: 3975,
      comment: "לבן",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/flowers/f65.jpg",
    },
    {
      id: "f66",
      sortOrder: 1120,
      category: "flowers",
      name: "טווידה תכלת",
      minQuantity: 25,
      maxQuantity: 3975,
      comment: "תכלת",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/flowers/f66.jpg",
    },
    {
      id: "f67",
      sortOrder: 1340,
      category: "flowers",
      name: "טגטס",
      minQuantity: 10,
      maxQuantity: 3990,
      comment: "צהוב / כתום / זהב / אדום-חום / דו-גוני",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/flowers/f67.jpg",
    },
    {
      id: "f68",
      sortOrder: 1100,
      category: "flowers",
      name: "טווידה ורוד",
      minQuantity: 25,
      maxQuantity: 3975,
      comment: "ורוד",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/flowers/f68.jpg",
    },
    {
      id: "f69",
      sortOrder: 940,
      category: "flowers",
      name: 'ליזיאנטוס 80 ס"מ ורוד',
      minQuantity: 10,
      maxQuantity: 3990,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/flowers/f69.jpg",
    },
    {
      id: "f70",
      sortOrder: 980,
      category: "flowers",
      name: 'ליזיאנטוס 80 ס"מ סגול-לבן',
      minQuantity: 10,
      maxQuantity: 3990,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/flowers/f70.jpg",
    },
    {
      id: "f71",
      sortOrder: 990,
      category: "flowers",
      name: 'ליזיאנטוס 80 ס"מ פוקסיה',
      minQuantity: 10,
      maxQuantity: 3990,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/flowers/f71.jpg",
    },
    {
      id: "f72",
      sortOrder: 950,
      category: "flowers",
      name: 'ליזיאנטוס 80 ס"מ ורוד בהיר',
      minQuantity: 10,
      maxQuantity: 3990,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/flowers/f72.jpg",
    },
    {
      id: "f73",
      sortOrder: 960,
      category: "flowers",
      name: 'ליזיאנטוס 80 ס"מ לבן',
      minQuantity: 10,
      maxQuantity: 3990,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/flowers/f73.jpg",
    },
    {
      id: "f74",
      sortOrder: 970,
      category: "flowers",
      name: 'ליזיאנטוס 80 ס"מ סגול',
      minQuantity: 10,
      maxQuantity: 3990,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/flowers/f74.jpg",
    },
    {
      id: "f75",
      sortOrder: 1430,
      category: "flowers",
      name: "צלוזיה בומביי",
      minQuantity: 10,
      maxQuantity: 3990,
      comment: "בורדו / ורוד / כתום / צהוב / ירוק / סגול",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/flowers/f75.jpg",
    },
    {
      id: "f76",
      sortOrder: 1440,
      category: "flowers",
      name: "צלוזיה זנב",
      minQuantity: 10,
      maxQuantity: 3990,
      comment: "נא לציין את הצבע המבוקש",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/flowers/f76.jpg",
    },
    {
      id: "f77",
      sortOrder: 1150,
      category: "flowers",
      name: "סולידגו סאן גלורי.",
      minQuantity: 25,
      maxQuantity: 3975,
      comment: "סגור-ירוק   פתוח-צהוב",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/flowers/f77.jpg",
    },
    {
      id: "f78",
      sortOrder: 1380,
      category: "flowers",
      name: "סחלב דנדרוביום ענף בודד",
      minQuantity: 1,
      maxQuantity: 3999,
      comment: "לבן / סגול / ורוד / ירוק / צהוב / דו-גוני ,מגיע בענף בודד",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/flowers/f78.jpg",
    },
    {
      id: "f79",
      sortOrder: 1490,
      category: "flowers",
      name: "חרצית יבוא",
      minQuantity: 5,
      maxQuantity: 3995,
      comment: "לבן / צהוב / ורוד / סגול / בורדו / כתום / ירוק, דו-גוני",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/flowers/f79.jpg",
    },
    {
      id: "f80",
      sortOrder: 1500,
      category: "flowers",
      name: "חרצית יבוא סנטיני בלבד",
      minQuantity: 25,
      maxQuantity: 3975,
      comment: "נא לציין את הצבע המבוקש",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/flowers/f80.jpg",
    },
    {
      id: "f81",
      sortOrder: 1510,
      category: "flowers",
      name: "חרצית ראש יבוא",
      minQuantity: 10,
      maxQuantity: 3990,
      comment: "יש לציין סוג ראש מלא או ספיידר ולרשום צבע מבוקש בהערות",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/flowers/f81.jpg",
    },
    {
      id: "f82",
      sortOrder: 1600,
      category: "flowers",
      name: "סחלב צימבידיום מיני יבוא",
      minQuantity: 5,
      maxQuantity: 3995,
      comment:
        "נא לציין את הצבע המבוקש הזמנה שבועיים מראש, צבעים זמינים : ורוד כהה בורדו ירוק ליים ירוק צבוע כתום ואדמדם(בורוד לא כהה) תמונות להמחשה בלבדדדדדדדדד",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/flowers/f82.jpg",
    },
    {
      id: "f83",
      sortOrder: 1590,
      category: "flowers",
      name: "סחלב צימבידיום יבוא",
      minQuantity: 1,
      maxQuantity: 3999,
      comment:
        "נא לציין את הצבע המבוקש הזמנה שבועיים מראש לבן ירוק צהוב ורוד בהיר ורוד כהה בלבד!!!!!! אין חלודה איו בורדו אין כתום!!!! תמונות להמחשה בלבדדדדדד",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/flowers/f83.jpg",
    },
    {
      id: "f84",
      sortOrder: 1530,
      category: "flowers",
      name: "אנטוריום יבוא",
      minQuantity: 12,
      maxQuantity: 3996,
      comment: "נא להזמין שבועיים מראש ולציין את שם הזן",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/flowers/f84.jpg",
    },
    {
      id: "f85",
      sortOrder: 400,
      category: "flowers",
      name: 'ורד פיץ אוולנש 50 ס"מ',
      minQuantity: 20,
      maxQuantity: 3980,
      comment: "ורד אפרסק סגור",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/flowers/f85.jpg",
    },
    {
      id: "f86",
      sortOrder: 410,
      category: "flowers",
      name: 'ורד פיץ אוולנש 60 ס"מ',
      minQuantity: 20,
      maxQuantity: 3980,
      comment: "אפרסק (גוון כתום בהיר)",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/flowers/f86.jpg",
    },
    {
      id: "f87",
      sortOrder: 420,
      category: "flowers",
      name: 'ורד פיץ אוולנש 70 ס"מ',
      minQuantity: 20,
      maxQuantity: 3980,
      comment: "אפרסק (גוון כתום בהיר)",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/flowers/f87.jpg",
    },
    {
      id: "f88",
      sortOrder: 430,
      category: "flowers",
      name: 'ורד פיץ אוולנש 80 ס"מ',
      minQuantity: 20,
      maxQuantity: 3980,
      comment: "אפרסק(גוון כתום בהיר)",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/flowers/f88.jpg",
    },
    {
      id: "f89",
      sortOrder: 240,
      category: "flowers",
      name: 'ורד מילווה 50 ס"מ',
      minQuantity: 20,
      maxQuantity: 3980,
      comment: "ורד כתום סגור",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/flowers/f89.jpg",
    },
    {
      id: "f90",
      sortOrder: 250,
      category: "flowers",
      name: 'ורד מילווה 60 ס"מ',
      minQuantity: 20,
      maxQuantity: 3980,
      comment: "כתום",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/flowers/f90.jpg",
    },
    {
      id: "f91",
      sortOrder: 260,
      category: "flowers",
      name: 'ורד מילווה 70 ס"מ',
      minQuantity: 20,
      maxQuantity: 3980,
      comment: "כתום",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/flowers/f91.jpg",
    },
    {
      id: "f92",
      sortOrder: 270,
      category: "flowers",
      name: 'ורד מילווה 80 ס"מ',
      minQuantity: 20,
      maxQuantity: 3980,
      comment: "כתום",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/flowers/f92.jpg",
    },
    {
      id: "f93",
      sortOrder: 180,
      category: "flowers",
      name: 'ורד לוולי רד 50 ס"מ',
      minQuantity: 20,
      maxQuantity: 3980,
      comment:
        "מחיר וזמינות עשויים להשתנות בחגים. הכמות מוגבלת ואין התחייבות לאספקה בחגים",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/flowers/f93.jpg",
    },
    {
      id: "f94",
      sortOrder: 190,
      category: "flowers",
      name: 'ורד לוולי רד 60 ס"מ',
      minQuantity: 20,
      maxQuantity: 3980,
      comment:
        "מחיר וזמינות עשויים להשתנות בחגים. הכמות מוגבלת ואין התחייבות לאספקה בחגים",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/flowers/f94.jpg",
    },
    {
      id: "f95",
      sortOrder: 200,
      category: "flowers",
      name: 'ורד לוולי רד 70 ס"מ',
      minQuantity: 20,
      maxQuantity: 3980,
      comment:
        "מחיר וזמינות עשויים להשתנות בחגים. הכמות מוגבלת ואין התחייבות לאספקה בחגים",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/flowers/f95.jpg",
    },
    {
      id: "f96",
      sortOrder: 210,
      category: "flowers",
      name: 'ורד לוולי רד 80 ס"מ',
      minQuantity: 20,
      maxQuantity: 3980,
      comment:
        "מחיר וזמינות עשויים להשתנות בחגים. הכמות מוגבלת ואין התחייבות לאספקה בחגים",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/flowers/f96.jpg",
    },
    {
      id: "f97",
      sortOrder: 220,
      category: "flowers",
      name: "ורד לוולי רד גובה מטר",
      minQuantity: 20,
      maxQuantity: 3980,
      comment:
        "מחיר וזמינות עשויים להשתנות בחגים. הכמות מוגבלת ואין התחייבות לאספקה בחגים",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/flowers/f97.jpg",
    },
    {
      id: "f98",
      sortOrder: 320,
      category: "flowers",
      name: 'ורד סוויט אוולנש 50 ס"מ',
      minQuantity: 20,
      maxQuantity: 3980,
      comment: "ורוד בהיר סגור",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/flowers/f98.jpg",
    },
    {
      id: "f99",
      sortOrder: 330,
      category: "flowers",
      name: 'ורד סוויט אוולנש 60 ס"מ',
      minQuantity: 20,
      maxQuantity: 3980,
      comment: "ורוד בהיר",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/flowers/f99.jpg",
    },
    {
      id: "f100",
      sortOrder: 340,
      category: "flowers",
      name: 'ורד סוויט אוולנש 70 ס"מ',
      minQuantity: 20,
      maxQuantity: 3980,
      comment: "ורוד בהיר",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/flowers/f100.jpg",
    },
    {
      id: "f101",
      sortOrder: 350,
      category: "flowers",
      name: 'ורד סוויט אוולנש 80 ס"מ',
      minQuantity: 20,
      maxQuantity: 3980,
      comment: "ורוד בהיר",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/flowers/f101.jpg",
    },
    {
      id: "f102",
      sortOrder: 690,
      category: "flowers",
      name: 'ורד ריבייבל 50 ס"מ',
      minQuantity: 20,
      maxQuantity: 3980,
      comment: "ורוד,סגור\\פתיחת שטח",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/flowers/f102.jpg",
    },
    {
      id: "f103",
      sortOrder: 580,
      category: "flowers",
      name: 'ורד ריבייבל 60 ס"מ',
      minQuantity: 20,
      maxQuantity: 3980,
      comment: "ורוד",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/flowers/f103.jpg",
    },
    {
      id: "f104",
      sortOrder: 590,
      category: "flowers",
      name: 'ורד ריבייבל 70 ס"מ',
      minQuantity: 20,
      maxQuantity: 3980,
      comment: "ורוד",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/flowers/f104.jpg",
    },
    {
      id: "f105",
      sortOrder: 600,
      category: "flowers",
      name: 'ורד ריבייבל 80 ס"מ',
      minQuantity: 20,
      maxQuantity: 3980,
      comment: "ורוד",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/flowers/f105.jpg",
    },
    {
      id: "f106",
      sortOrder: 1540,
      category: "flowers",
      name: "אנטוריום פרח קטן יבוא",
      minQuantity: 20,
      maxQuantity: 3980,
      comment: "נא להזמין שבועיים מראש ולציין את שם הזן",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/flowers/f106.jpg",
    },
    {
      id: "f107",
      sortOrder: 1580,
      category: "flowers",
      name: "סחלב פינלופסיס-פעמון יבוא",
      minQuantity: 1,
      maxQuantity: 3999,
      comment:
        "לבן-לב צהוב\\לבן-לב ורוד\\ורוד\\פוקסיה בהזמנה של שבועיים מראש,מחיר הענף עלול להשתנות בהתאם לצבע",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/flowers/f107.jpg",
    },
    {
      id: "f108",
      sortOrder: 20,
      category: "flowers",
      name: 'ורד אוולנש 50 ס"מ',
      minQuantity: 20,
      maxQuantity: 3980,
      comment: "לבן-שמנת סגור בלבד",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/flowers/f108.jpg",
    },
    {
      id: "f109",
      sortOrder: 30,
      category: "flowers",
      name: 'ורד אוולנש 60 ס"מ',
      minQuantity: 20,
      maxQuantity: 3980,
      comment: "לבן-שמנת סגור בלבד",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/flowers/f109.jpg",
    },
    {
      id: "f110",
      sortOrder: 40,
      category: "flowers",
      name: 'ורד אוולנש 70 ס"מ',
      minQuantity: 20,
      maxQuantity: 3980,
      comment: "לבן-שמנת סגור בלבד",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/flowers/f110.jpg",
    },
    {
      id: "f111",
      sortOrder: 50,
      category: "flowers",
      name: 'ורד אוולנש 80 ס"מ',
      minQuantity: 20,
      maxQuantity: 3980,
      comment: "לבן-שמנת סגור בלבד",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/flowers/f111.jpg",
    },
    {
      id: "f112",
      sortOrder: 700,
      category: "flowers",
      name: 'ורד שרי ברנדי 50 ס"מ',
      minQuantity: 20,
      maxQuantity: 3980,
      comment: "אדום-כתום,סגור\\פתיחת שטח",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/flowers/f112.jpg",
    },
    {
      id: "f113",
      sortOrder: 610,
      category: "flowers",
      name: 'ורד שרי ברנדי 60 ס"מ',
      minQuantity: 20,
      maxQuantity: 3980,
      comment: "אדום-כתום",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/flowers/f113.jpg",
    },
    {
      id: "f114",
      sortOrder: 70,
      category: "flowers",
      name: 'ורד אושן סונג 50 ס"מ',
      minQuantity: 20,
      maxQuantity: 3980,
      comment: "ורד לילך סגור בלבד",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/flowers/f114.jpg",
    },
    {
      id: "f115",
      sortOrder: 80,
      category: "flowers",
      name: 'ורד אושן סונג 60 ס"מ',
      minQuantity: 20,
      maxQuantity: 3980,
      comment: "לילך",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/flowers/f115.jpg",
    },
    {
      id: "f116",
      sortOrder: 90,
      category: "flowers",
      name: 'ורד אושן סונג 70 ס"מ',
      minQuantity: 20,
      maxQuantity: 3980,
      comment: "לילך",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/flowers/f116.jpg",
    },
    {
      id: "f117",
      sortOrder: 100,
      category: "flowers",
      name: 'ורד אושן סונג 80 ס"מ',
      minQuantity: 20,
      maxQuantity: 3980,
      comment: "לילך",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/flowers/f117.jpg",
    },
    {
      id: "f118",
      sortOrder: 550,
      category: "flowers",
      name: 'ורד קרונוס 50 ס"מ',
      minQuantity: 20,
      maxQuantity: 3980,
      comment: "צהוב סגור",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/flowers/f118.jpg",
    },
    {
      id: "f119",
      sortOrder: 560,
      category: "flowers",
      name: 'ורד קרונוס 60 ס"מ',
      minQuantity: 20,
      maxQuantity: 3980,
      comment: "צהוב",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/flowers/f119.jpg",
    },
    {
      id: "f120",
      sortOrder: 570,
      category: "flowers",
      name: 'ורד קרונוס 70 ס"מ',
      minQuantity: 20,
      maxQuantity: 3980,
      comment: "צהוב",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/flowers/f120.jpg",
    },
    {
      id: "f121",
      sortOrder: 300,
      category: "flowers",
      name: 'ורד מיקמאק 50 ס"מ',
      minQuantity: 20,
      maxQuantity: 3980,
      comment: "חום-אפור-ורוד סגור, מלאי מוגבל ללקוח\\הזמנה\\אירוע",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/flowers/f121.jpg",
    },
    {
      id: "f122",
      sortOrder: 280,
      category: "flowers",
      name: 'ורד מיס-פיגי 50 ס"מ',
      minQuantity: 20,
      maxQuantity: 3980,
      comment: "כתום-ורוד סגור",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/flowers/f122.jpg",
    },
    {
      id: "f123",
      sortOrder: 130,
      category: "flowers",
      name: 'ורד טו-פייס 50 ס"מ',
      minQuantity: 40,
      maxQuantity: 3960,
      comment: "ורוד-אפור,פתיחת שטח",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/flowers/f123.jpg",
    },
    {
      id: "f124",
      sortOrder: 290,
      category: "flowers",
      name: 'ורד מיס-פיגי 60 ס"מ',
      minQuantity: 20,
      maxQuantity: 3980,
      comment: "כתום-ורוד",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/flowers/f124.jpg",
    },
    {
      id: "f125",
      sortOrder: 450,
      category: "flowers",
      name: 'ורד פקולטה 50 ס"מ',
      minQuantity: 20,
      maxQuantity: 3980,
      comment: "ורד פוקסיה,סגור",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/flowers/f125.jpg",
    },
    {
      id: "f126",
      sortOrder: 460,
      category: "flowers",
      name: 'ורד פקולטה 60 ס"מ',
      minQuantity: 20,
      maxQuantity: 3980,
      comment: "פוקסיה",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/flowers/f126.jpg",
    },
    {
      id: "f127",
      sortOrder: 470,
      category: "flowers",
      name: 'ורד פקולטה 70 ס"מ',
      minQuantity: 20,
      maxQuantity: 3980,
      comment: "פוקסיה",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/flowers/f127.jpg",
    },
    {
      id: "f128",
      sortOrder: 480,
      category: "flowers",
      name: 'ורד פקולטה 80 ס"מ',
      minQuantity: 20,
      maxQuantity: 3980,
      comment: "פוקסיה",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/flowers/f128.jpg",
    },
    {
      id: "f129",
      sortOrder: 710,
      category: "flowers",
      name: "כותרות ורדים",
      minQuantity: 25,
      maxQuantity: 3975,
      comment: "לבן \\אדום ,צבעים נוספים בהזמנה מיוחדת",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/flowers/f129.jpg",
    },
    {
      id: "f130",
      sortOrder: 1570,
      category: "flowers",
      name: "סחלב וונדה ענף יבוא",
      minQuantity: 2,
      maxQuantity: 3998,
      comment:
        "הזמנה של שבועיים מראש,צירפנו קטלוג תמונות למוצר -אנא השתמשו בשמות הזנים. כל הזנים האדומים לא זמינים עד חודש יולי כרגע CHOCOLATE RED/LAVA",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/flowers/f130.jpg",
    },
    {
      id: "f131",
      sortOrder: 500,
      category: "flowers",
      name: 'ורד קול ווטר 50 ס"מ',
      minQuantity: 20,
      maxQuantity: 3980,
      comment: "ורד סגול-ורוד סגור",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/flowers/f131.jpg",
    },
    {
      id: "f132",
      sortOrder: 510,
      category: "flowers",
      name: 'ורד קול ווטר 60 ס"מ',
      minQuantity: 20,
      maxQuantity: 3980,
      comment: "סגול-ורוד",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/flowers/f132.jpg",
    },
    {
      id: "f133",
      sortOrder: 520,
      category: "flowers",
      name: 'ורד קול ווטר 70 ס"מ',
      minQuantity: 20,
      maxQuantity: 3980,
      comment: "סגול-ורוד",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/flowers/f133.jpg",
    },
    {
      id: "f134",
      sortOrder: 530,
      category: "flowers",
      name: 'ורד קולווטר 80 ס"מ',
      minQuantity: 20,
      maxQuantity: 3980,
      comment: "סגול-ורוד",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/flowers/f134.jpg",
    },
    {
      id: "f135",
      sortOrder: 10,
      category: "flowers",
      name: "ורד אוולנש - שטח",
      minQuantity: 40,
      maxQuantity: 3960,
      comment: "ורד פתוח בלבד-לא מתאים לחנויות",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/flowers/f135.jpg",
    },
    {
      id: "f136",
      sortOrder: 60,
      category: "flowers",
      name: "ורד אושן סונג - שטח",
      minQuantity: 40,
      maxQuantity: 3960,
      comment: "ורד פתוח בלבד-לא מתאים לחנויות",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/flowers/f136.jpg",
    },
    {
      id: "f137",
      sortOrder: 170,
      category: "flowers",
      name: "ורד לוולי - שטח",
      minQuantity: 20,
      maxQuantity: 3980,
      comment: "ורד פתוח בלבד-לא מתאים לחנויות",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/flowers/f137.jpg",
    },
    {
      id: "f138",
      sortOrder: 230,
      category: "flowers",
      name: "ורד מילווה - שטח",
      minQuantity: 20,
      maxQuantity: 3980,
      comment: "ורד פתוח בלבד-לא מתאים לחנויות",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/flowers/f138.jpg",
    },
    {
      id: "f139",
      sortOrder: 310,
      category: "flowers",
      name: "ורד סוויט - שטח",
      minQuantity: 40,
      maxQuantity: 3960,
      comment: "ורד פתוח בלבד-לא מתאים לחנויות",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/flowers/f139.jpg",
    },
    {
      id: "f140",
      sortOrder: 390,
      category: "flowers",
      name: "ורד פיץ - שטח",
      minQuantity: 40,
      maxQuantity: 3960,
      comment: "ורד פתוח בלבד-לא מתאים לחנויות",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/flowers/f140.jpg",
    },
    {
      id: "f141",
      sortOrder: 440,
      category: "flowers",
      name: "ורד פקולטה - שטח",
      minQuantity: 40,
      maxQuantity: 3960,
      comment: "ורד פתוח בלבד-לא מתאים לחנויות",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/flowers/f141.jpg",
    },
    {
      id: "f142",
      sortOrder: 490,
      category: "flowers",
      name: "ורד קול ווטר - שטח",
      minQuantity: 40,
      maxQuantity: 3960,
      comment: "ורד פתוח בלבד-לא מתאים לחנויות",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/flowers/f142.jpg",
    },
    {
      id: "f143",
      sortOrder: 540,
      category: "flowers",
      name: "ורד קורונוס - שטח",
      minQuantity: 40,
      maxQuantity: 3960,
      comment: "ורד פתוח בלבד-לא מתאים לחנויות",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/flowers/f143.jpg",
    },
    {
      id: "f144",
      sortOrder: 640,
      category: "flowers",
      name: 'ורד סירקוס 50 ס"מ',
      minQuantity: 20,
      maxQuantity: 3980,
      comment: "צהוב-אדום,סגור\\פתיחת שטח",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/flowers/f144.jpg",
    },
    {
      id: "f145",
      sortOrder: 360,
      category: "flowers",
      name: 'ורד סירקוס 60 ס"מ',
      minQuantity: 20,
      maxQuantity: 3980,
      comment: "צהוב-אדום",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/flowers/f145.jpg",
    },
    {
      id: "f146",
      sortOrder: 370,
      category: "flowers",
      name: 'ורד סירקוס 70 ס"מ',
      minQuantity: 20,
      maxQuantity: 3980,
      comment: "צהוב-אדום",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/flowers/f146.jpg",
    },
    {
      id: "f147",
      sortOrder: 380,
      category: "flowers",
      name: 'ורד סירקוס 80 ס"מ',
      minQuantity: 20,
      maxQuantity: 3980,
      comment: "צהוב-אדום",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/flowers/f147.jpg",
    },
    {
      id: "f148",
      sortOrder: 630,
      category: "flowers",
      name: 'ורד טיטניק 50 ס"מ',
      minQuantity: 20,
      maxQuantity: 3980,
      comment: "ורוד בהיר, סגור\\פתיחת שטח",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/flowers/f148.jpg",
    },
    {
      id: "f149",
      sortOrder: 140,
      category: "flowers",
      name: 'ורד טיטניק 60 ס"מ',
      minQuantity: 20,
      maxQuantity: 3980,
      comment: "ורוד בהיר",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/flowers/f149.jpg",
    },
    {
      id: "f150",
      sortOrder: 150,
      category: "flowers",
      name: 'ורד טיטניק 70 ס"מ',
      minQuantity: 20,
      maxQuantity: 3980,
      comment: "ורוד בהיר",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/flowers/f150.jpg",
    },
    {
      id: "f151",
      sortOrder: 160,
      category: "flowers",
      name: 'ורד טיטניק 80 ס"מ',
      minQuantity: 20,
      maxQuantity: 3980,
      comment: "ורוד בהיר",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/flowers/f151.jpg",
    },
    {
      id: "f152",
      sortOrder: 110,
      category: "flowers",
      name: "ורד אנגלי פוקסיה",
      minQuantity: 40,
      maxQuantity: 3960,
      comment: "פתיחת שטח בלבד,אריזות אחרות יחוייבו לפי גובה",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/flowers/f152.jpg",
    },
    {
      id: "f153",
      sortOrder: 120,
      category: "flowers",
      name: "ורד אנגלי צהוב",
      minQuantity: 40,
      maxQuantity: 3960,
      comment: "פתיחת שטח 40 יח בחבילה\\ארוז",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/flowers/f153.jpg",
    },
    {
      id: "f154",
      sortOrder: 650,
      category: "flowers",
      name: 'ורד ספרי 50 ס"מ',
      minQuantity: 10,
      maxQuantity: 3990,
      comment: "לבן\\ורוד\\לילך\\אדום\\כתום\\צהוב נא לציין את הצבע המבוקש",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/flowers/f154.jpg",
    },
    {
      id: "f155",
      sortOrder: 660,
      category: "flowers",
      name: 'ורד ספרי 60 ס"מ',
      minQuantity: 10,
      maxQuantity: 3990,
      comment: "לבן\\ורוד\\לילך\\אדום\\כתום\\צהוב נא לציין את הצבע המבוקש",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/flowers/f155.jpg",
    },
    {
      id: "f156",
      sortOrder: 670,
      category: "flowers",
      name: 'ורד ספרי 70 ס"מ',
      minQuantity: 10,
      maxQuantity: 3990,
      comment: "לבן\\ורוד\\לילך\\אדום\\כתום\\צהוב נא לציין את הצבע המבוקש",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/flowers/f156.jpg",
    },
    {
      id: "f157",
      sortOrder: 680,
      category: "flowers",
      name: 'ורד ספרי 80 ס"מ',
      minQuantity: 10,
      maxQuantity: 3990,
      comment: "לבן\\ורוד\\לילך\\אדום\\כתום\\צהוב נא לציין את הצבע המבוקש",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/flowers/f157.jpg",
    },
    {
      id: "f158",
      sortOrder: 1550,
      category: "flowers",
      name: "אסטילבה יבוא",
      minQuantity: 10,
      maxQuantity: 3990,
      comment: "לבן\\ ורוד בהיר \\ורוד כהה \\וברודו",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/flowers/f158.jpg",
    },
    {
      id: "f159",
      sortOrder: 1560,
      category: "flowers",
      name: "הורטנזיה יבוא",
      minQuantity: 5,
      maxQuantity: 3995,
      comment:
        "נא לציין את הצבע,שבועיים מראש ורוד בהיר ורוד עם ירוק  לילך תכלת כחול סגול כהה ירוק ולבן הצבעים עשויים להשתנות מפעם לפעם",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/flowers/f159.jpg",
    },
    {
      id: "f160",
      sortOrder: 1610,
      category: "flowers",
      name: "קלות צבע יבוא",
      minQuantity: 10,
      maxQuantity: 3990,
      comment: "נא לציין צבע מבוקש למעט לבן והזמנה שבועיים מראש",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/flowers/f160.jpg",
    },
    {
      id: "f161",
      sortOrder: 1520,
      category: "flowers",
      name: "קלות לבן יבוא",
      minQuantity: 10,
      maxQuantity: 3990,
      comment: "לבן בלבד!",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/flowers/f161.jpg",
    },
    {
      id: "g1",
      sortOrder: 330,
      category: "greenery",
      name: "גזע ארליה 2 מטר",
      minQuantity: 5,
      maxQuantity: 3995,
      comment: "ירוק ,בהזמנה של 24 שעות מראש",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/greenery/g1.jpg",
    },
    {
      id: "g2",
      sortOrder: 630,
      category: "greenery",
      name: "סביון מאפיר-עלים",
      minQuantity: 25,
      maxQuantity: 3975,
      comment: "אפור",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/greenery/g2.jpg",
    },
    {
      id: "g3",
      sortOrder: 130,
      category: "greenery",
      name: "אוקורוס",
      minQuantity: 50,
      maxQuantity: 3950,
      comment: "ירוק",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/greenery/g3.jpg",
    },
    {
      id: "g4",
      sortOrder: 870,
      category: "greenery",
      name: "גרבילאה פורחת",
      minQuantity: 10,
      maxQuantity: 3990,
      comment: "כתום, אפרסק (פיץ'), אדום, צהוב, ורוד",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/greenery/g4.jpg",
    },
    {
      id: "g5",
      sortOrder: 620,
      category: "greenery",
      name: "סביון מאפיר ענף",
      minQuantity: 10,
      maxQuantity: 3990,
      comment: "אפור",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/greenery/g5.jpg",
    },
    {
      id: "g6",
      sortOrder: 40,
      category: "greenery",
      name: "אקליפטוס פרובלנטה גיינט",
      minQuantity: 5,
      maxQuantity: 3995,
      comment: "אפור,3 מטר גובה!",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/greenery/g6.jpg",
    },
    {
      id: "g7",
      sortOrder: 610,
      category: "greenery",
      name: "ננדיה",
      minQuantity: 5,
      maxQuantity: 3995,
      comment: "אדום-ירוק מחיר לענף חב של 5 יח",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/greenery/g7.jpg",
    },
    {
      id: "g8",
      sortOrder: 450,
      category: "greenery",
      name: "חונדרו",
      minQuantity: 20,
      maxQuantity: 3980,
      comment: "ירוק כהה",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/greenery/g8.jpg",
    },
    {
      id: "g9",
      sortOrder: 100,
      category: "greenery",
      name: "שרך עלה האור",
      minQuantity: 50,
      maxQuantity: 3950,
      comment: "ירוק כהה",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/greenery/g9.jpg",
    },
    {
      id: "g10",
      sortOrder: 110,
      category: "greenery",
      name: "שרך שרון",
      minQuantity: 100,
      maxQuantity: 3900,
      comment: "ירוק בהיר",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/greenery/g10.jpg",
    },
    {
      id: "g11",
      sortOrder: 640,
      category: "greenery",
      name: "סהרון קצר",
      minQuantity: 50,
      maxQuantity: 3950,
      comment: "ירוק",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/greenery/g11.jpg",
    },
    {
      id: "g12",
      sortOrder: 710,
      category: "greenery",
      name: "ענן",
      minQuantity: 1,
      maxQuantity: 3999,
      comment: "ירוק\\ורוד עתיק 10-20 ענפים בחבילה",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/greenery/g12.jpg",
    },
    {
      id: "g13",
      sortOrder: 720,
      category: "greenery",
      name: "ענפי גוייאבה",
      minQuantity: 10,
      maxQuantity: 3990,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/greenery/g13.jpg",
    },
    {
      id: "g14",
      sortOrder: 470,
      category: "greenery",
      name: "יעלי",
      minQuantity: 10,
      maxQuantity: 3990,
      comment: "ירוק-אדום-צהוב",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/greenery/g14.jpg",
    },
    {
      id: "g15",
      sortOrder: 60,
      category: "greenery",
      name: "דקל חמדוראה ענפים",
      minQuantity: 20,
      maxQuantity: 3980,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/greenery/g15.jpg",
    },
    {
      id: "g16",
      sortOrder: 750,
      category: "greenery",
      name: "פמפס",
      minQuantity: 10,
      maxQuantity: 3990,
      comment: "ירוק כהה",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/greenery/g16.jpg",
    },
    {
      id: "g17",
      sortOrder: 320,
      category: "greenery",
      name: "גומא פפירוס",
      minQuantity: 5,
      maxQuantity: 3995,
      comment: "ירוק",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/greenery/g17.jpg",
    },
    {
      id: "g18",
      sortOrder: 310,
      category: "greenery",
      name: "גומא דבורה",
      minQuantity: 10,
      maxQuantity: 3990,
      comment: "אין אחריות אין זיכויים-מחזיק מעט",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/greenery/g18.jpg",
    },
    {
      id: "g19",
      sortOrder: 70,
      category: "greenery",
      name: "ענפי דקל אריקה",
      minQuantity: 20,
      maxQuantity: 3980,
      comment: 'גובה 100 ס"מ (1מטר)',
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/greenery/g19.jpg",
    },
    {
      id: "g20",
      sortOrder: 240,
      category: "greenery",
      name: 'ארליה 20 ס"מ',
      minQuantity: 10,
      maxQuantity: 3990,
      comment: "המוצג הימני",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/greenery/g20.jpg",
    },
    {
      id: "g21",
      sortOrder: 250,
      category: "greenery",
      name: 'ארליה 40 ס"מ',
      minQuantity: 10,
      maxQuantity: 3990,
      comment: "המוצג השמאלי",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/greenery/g21.jpg",
    },
    {
      id: "g22",
      sortOrder: 260,
      category: "greenery",
      name: 'ארליה 60 ס"מ',
      minQuantity: 10,
      maxQuantity: 3990,
      comment: "המוצג האמצעי",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/greenery/g22.jpg",
    },
    {
      id: "g23",
      sortOrder: 270,
      category: "greenery",
      name: "ארליה אצבעות קצר",
      minQuantity: 20,
      maxQuantity: 3980,
      comment: "שחור",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/greenery/g23.jpg",
    },
    {
      id: "g24",
      sortOrder: 920,
      category: "greenery",
      name: "רוסקוס צבוע",
      minQuantity: 50,
      maxQuantity: 3950,
      comment: "בהזמנה של 72 שעות מראש,נא לציין צבע מבוקש",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/greenery/g24.jpg",
    },
    {
      id: "g25",
      sortOrder: 530,
      category: "greenery",
      name: "מונסטרה ענק",
      minQuantity: 10,
      maxQuantity: 3990,
      comment: "ירוק",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/greenery/g25.jpg",
    },
    {
      id: "g26",
      sortOrder: 520,
      category: "greenery",
      name: "מונסטרה גדול",
      minQuantity: 10,
      maxQuantity: 3990,
      comment: "ירוק",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/greenery/g26.jpg",
    },
    {
      id: "g27",
      sortOrder: 510,
      category: "greenery",
      name: "מונסטרה בינוני",
      minQuantity: 10,
      maxQuantity: 3990,
      comment: "ירוק כהה",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/greenery/g27.jpg",
    },
    {
      id: "g28",
      sortOrder: 540,
      category: "greenery",
      name: "מונסטרה קטן",
      minQuantity: 10,
      maxQuantity: 3990,
      comment: "ירוק",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/greenery/g28.jpg",
    },
    {
      id: "g29",
      sortOrder: 810,
      category: "greenery",
      name: "קסנדו",
      minQuantity: 25,
      maxQuantity: 3975,
      comment: "ירוק כהה",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/greenery/g29.jpg",
    },
    {
      id: "g30",
      sortOrder: 280,
      category: "greenery",
      name: "ביפי ענק",
      minQuantity: 10,
      maxQuantity: 3990,
      comment: "ירוק  יתכנו חוסרים במוצר זה",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/greenery/g30.jpg",
    },
    {
      id: "g31",
      sortOrder: 830,
      category: "greenery",
      name: "רוסקוס",
      minQuantity: 50,
      maxQuantity: 3950,
      comment: "ירוק כהה",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/greenery/g31.jpg",
    },
    {
      id: "g32",
      sortOrder: 30,
      category: "greenery",
      name: "אקליפטוס פרובלנטה",
      minQuantity: 10,
      maxQuantity: 3990,
      comment: "אפור",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/greenery/g32.jpg",
    },
    {
      id: "g33",
      sortOrder: 140,
      category: "greenery",
      name: "אלוקסיה עלים",
      minQuantity: 10,
      maxQuantity: 3990,
      comment: "ירוק",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/greenery/g33.jpg",
    },
    {
      id: "g34",
      sortOrder: 10,
      category: "greenery",
      name: "אקליפטוס מטבעות",
      minQuantity: 10,
      maxQuantity: 3990,
      comment: "ירוק-אפור",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/greenery/g34.jpg",
    },
    {
      id: "g35",
      sortOrder: 20,
      category: "greenery",
      name: "אקליפטוס מקור",
      minQuantity: 10,
      maxQuantity: 3990,
      comment: "ירוק-אדום בקצוות,רגיש בקיץ עם נטייה להתייבש מהר",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/greenery/g35.jpg",
    },
    {
      id: "g36",
      sortOrder: 230,
      category: "greenery",
      name: "אקציה",
      minQuantity: 10,
      maxQuantity: 3990,
      comment: "אפור-סגול-ירוק",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/greenery/g36.jpg",
    },
    {
      id: "g37",
      sortOrder: 180,
      category: "greenery",
      name: "אספרגוס ורגטוס",
      minQuantity: 50,
      maxQuantity: 3950,
      comment: "ירוק כהה",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/greenery/g37.jpg",
    },
    {
      id: "g38",
      sortOrder: 440,
      category: "greenery",
      name: "זית-ענפים",
      minQuantity: 10,
      maxQuantity: 3990,
      comment: "ירוק כהה",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/greenery/g38.jpg",
    },
    {
      id: "g39",
      sortOrder: 220,
      category: "greenery",
      name: "אספרגוס פלימוזיס",
      minQuantity: 25,
      maxQuantity: 3975,
      comment: "ירוק כהה",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/greenery/g39.jpg",
    },
    {
      id: "g40",
      sortOrder: 50,
      category: "greenery",
      name: "דקל וושינגטוניה גזור\\לא גזור",
      minQuantity: 5,
      maxQuantity: 3995,
      comment: "בהזמנה של 24 שעות מראש,מחירו של גזור:20 שקל לענף",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/greenery/g40.jpg",
    },
    {
      id: "g41",
      sortOrder: 490,
      category: "greenery",
      name: "כוחיה",
      minQuantity: 10,
      maxQuantity: 3990,
      comment: "אפור",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/greenery/g41.jpg",
    },
    {
      id: "g42",
      sortOrder: 900,
      category: "greenery",
      name: "פיטוספורום גבוה",
      minQuantity: 20,
      maxQuantity: 3980,
      comment: "ירוק-לבן\\ירוק-כהה",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/greenery/g42.jpg",
    },
    {
      id: "g43",
      sortOrder: 430,
      category: "greenery",
      name: "זומזומית",
      minQuantity: 1,
      maxQuantity: 3999,
      comment: "ירוק",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/greenery/g43.jpg",
    },
    {
      id: "g44",
      sortOrder: 420,
      category: "greenery",
      name: "דרצנה ענף גבוה",
      minQuantity: 5,
      maxQuantity: 3995,
      comment: "ירוק-לבן\\צהבהב",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/greenery/g44.jpg",
    },
    {
      id: "g45",
      sortOrder: 930,
      category: "greenery",
      name: "פלומוזיס צבוע",
      minQuantity: 50,
      maxQuantity: 3950,
      comment: "בהזמנה מראש של 72 שעות,נא לציין צבע מבוקש",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/greenery/g45.jpg",
    },
    {
      id: "g46",
      sortOrder: 880,
      category: "greenery",
      name: "זיפן",
      minQuantity: 1,
      maxQuantity: 3999,
      comment: "ירוק\\חום ,כמות בחבילה 25 יח",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/greenery/g46.jpg",
    },
    {
      id: "g47",
      sortOrder: 850,
      category: "greenery",
      name: "שבטבט",
      minQuantity: 25,
      maxQuantity: 3975,
      comment: "ירוק",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/greenery/g47.jpg",
    },
    {
      id: "g48",
      sortOrder: 700,
      category: "greenery",
      name: "עלי גן עדן",
      minQuantity: 10,
      maxQuantity: 3990,
      comment: "ירוק",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/greenery/g48.jpg",
    },
    {
      id: "g49",
      sortOrder: 150,
      category: "greenery",
      name: "אספדיסטרה / מגינית",
      minQuantity: 50,
      maxQuantity: 3950,
      comment: "ירוק כהה",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/greenery/g49.jpg",
    },
    {
      id: "g50",
      sortOrder: 170,
      category: "greenery",
      name: "אספדיסטרה מנוקדת",
      minQuantity: 25,
      maxQuantity: 3975,
      comment: "ירוק עם נקודות לבנות",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/greenery/g50.jpg",
    },
    {
      id: "g51",
      sortOrder: 730,
      category: "greenery",
      name: "פורמיום",
      minQuantity: 50,
      maxQuantity: 3950,
      comment: "חום-לבן",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/greenery/g51.jpg",
    },
    {
      id: "g52",
      sortOrder: 780,
      category: "greenery",
      name: "קיסוס-ענפים",
      minQuantity: 10,
      maxQuantity: 3990,
      comment: "ירוק-לבן\\ירוק כהה, 1-1.5 מטר",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/greenery/g52.jpg",
    },
    {
      id: "g53",
      sortOrder: 580,
      category: "greenery",
      name: "מוראה",
      minQuantity: 20,
      maxQuantity: 3980,
      comment: "ירוק",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/greenery/g53.jpg",
    },
    {
      id: "g54",
      sortOrder: 860,
      category: "greenery",
      name: "שמרופס",
      minQuantity: 10,
      maxQuantity: 3990,
      comment: "ירוק",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/greenery/g54.jpg",
    },
    {
      id: "g55",
      sortOrder: 600,
      category: "greenery",
      name: "מריסיניה",
      minQuantity: 25,
      maxQuantity: 3975,
      comment: "ירוק כהה",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/greenery/g55.jpg",
    },
    {
      id: "g56",
      sortOrder: 380,
      category: "greenery",
      name: "גרבילאה רובוסטה",
      minQuantity: 1,
      maxQuantity: 3999,
      comment: "ירוק-אפור 10-20 ענפים בממוצע",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/greenery/g56.jpg",
    },
    {
      id: "g57",
      sortOrder: 370,
      category: "greenery",
      name: "גרבילאה עלים",
      minQuantity: 20,
      maxQuantity: 3980,
      comment: "ירוק-צהבהב",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/greenery/g57.jpg",
    },
    {
      id: "g58",
      sortOrder: 770,
      category: "greenery",
      name: "קיסוס גיינט",
      minQuantity: 50,
      maxQuantity: 3950,
      comment: "ירוק, בערך 2 מטר אורך",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/greenery/g58.jpg",
    },
    {
      id: "g59",
      sortOrder: 340,
      category: "greenery",
      name: "גרבילאה איבנהו",
      minQuantity: 20,
      maxQuantity: 3980,
      comment: "ירוק-אדום-צהוב",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/greenery/g59.jpg",
    },
    {
      id: "g60",
      sortOrder: 120,
      category: "greenery",
      name: "דקל וושינגטונה צבוע",
      minQuantity: 5,
      maxQuantity: 3995,
      comment: "בהזמנה מראש של 72 שעות ,לפני נא לציין צבע",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/greenery/g60.jpg",
    },
    {
      id: "g61",
      sortOrder: 160,
      category: "greenery",
      name: "אספדיסטרה מגוונת",
      minQuantity: 50,
      maxQuantity: 3950,
      comment: "ירוק-פס לבן",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/greenery/g61.jpg",
    },
    {
      id: "g62",
      sortOrder: 910,
      category: "greenery",
      name: "פיטוספורום קצר",
      minQuantity: 50,
      maxQuantity: 3950,
      comment: "ירוק-לבן\\ירוק כהה-",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/greenery/g62.jpg",
    },
    {
      id: "g63",
      sortOrder: 200,
      category: "greenery",
      name: "אספרגוס מרוקלאדיוס",
      minQuantity: 10,
      maxQuantity: 3990,
      comment: "ירוק כהה-קצר",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/greenery/g63.jpg",
    },
    {
      id: "g64",
      sortOrder: 590,
      category: "greenery",
      name: "מורן פרי שחור",
      minQuantity: 10,
      maxQuantity: 3990,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/greenery/g64.jpg",
    },
    {
      id: "g65",
      sortOrder: 190,
      category: "greenery",
      name: "אספרגוס מאירי",
      minQuantity: 50,
      maxQuantity: 3950,
      comment: "ירוק",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/greenery/g65.jpg",
    },
    {
      id: "g66",
      sortOrder: 390,
      category: "greenery",
      name: "גרין בל עופרים",
      minQuantity: 15,
      maxQuantity: 3990,
      comment: "ירוק",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/greenery/g66.jpg",
    },
    {
      id: "g67",
      sortOrder: 650,
      category: "greenery",
      name: "סליקס בינוני",
      minQuantity: 10,
      maxQuantity: 3990,
      comment: "המוצג השמאלי-בערך 2-2.5 מטר גובה",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/greenery/g67.jpg",
    },
    {
      id: "g68",
      sortOrder: 660,
      category: "greenery",
      name: "סליקס ענק",
      minQuantity: 10,
      maxQuantity: 3990,
      comment: "המוצג הימני-בערך 3-3.5 מטר גובה",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/greenery/g68.jpg",
    },
    {
      id: "g69",
      sortOrder: 90,
      category: "greenery",
      name: "שרך ברזל",
      minQuantity: 50,
      maxQuantity: 3950,
      comment: "ירוק כהה",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/greenery/g69.jpg",
    },
    {
      id: "g70",
      sortOrder: 80,
      category: "greenery",
      name: "שרך אפור",
      minQuantity: 50,
      maxQuantity: 3950,
      comment: "אפור",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/greenery/g70.jpg",
    },
    {
      id: "g71",
      sortOrder: 480,
      category: "greenery",
      name: "ירקה ירוקה",
      minQuantity: 50,
      maxQuantity: 3950,
      comment: "ירוק כהה",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/greenery/g71.jpg",
    },
    {
      id: "g72",
      sortOrder: 300,
      category: "greenery",
      name: "ברוש טויה",
      minQuantity: 1,
      maxQuantity: 3999,
      comment: "ירוק 10 ענפים בממוצע",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/greenery/g72.jpg",
    },
    {
      id: "g73",
      sortOrder: 290,
      category: "greenery",
      name: "בלה מקנדה",
      minQuantity: 5,
      maxQuantity: 3995,
      comment: "גובה מטר-ללא פריחה",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/greenery/g73.jpg",
    },
    {
      id: "g74",
      sortOrder: 890,
      category: "greenery",
      name: "פיטוספורום איטלקי מגוון",
      minQuantity: 20,
      maxQuantity: 3980,
      comment: "ירוק-לבן\\ירוק כהה",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/greenery/g74.jpg",
    },
    {
      id: "g75",
      sortOrder: 840,
      category: "greenery",
      name: "רוסקוס מסולסל",
      minQuantity: 50,
      maxQuantity: 3950,
      comment: "ירוק כהה-מבריק,חזק,ומחזיר מעמד",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/greenery/g75.jpg",
    },
    {
      id: "g76",
      sortOrder: 790,
      category: "greenery",
      name: "קיסוסית",
      minQuantity: 1,
      maxQuantity: 3999,
      comment: "1.5 מטר מלופף על חוט=1יח",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/greenery/g76.jpg",
    },
    {
      id: "g77",
      sortOrder: 800,
      category: "greenery",
      name: "קיסוסית קוצנית",
      minQuantity: 1,
      maxQuantity: 3999,
      comment: "בערך 2 מטר אורך,דוקרני",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/greenery/g77.jpg",
    },
    {
      id: "g78",
      sortOrder: 360,
      category: "greenery",
      name: "גרבילאה מוזהבת",
      minQuantity: 10,
      maxQuantity: 3990,
      comment: 'ירוק-זהב   רק 50 ס"מ גובה',
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/greenery/g78.jpg",
    },
    {
      id: "g79",
      sortOrder: 350,
      category: "greenery",
      name: "גרבילאה חוטית",
      minQuantity: 20,
      maxQuantity: 3980,
      comment: "ירוק-אדום-חום",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/greenery/g79.jpg",
    },
    {
      id: "g80",
      sortOrder: 760,
      category: "greenery",
      name: "ציקאס",
      minQuantity: 10,
      maxQuantity: 3990,
      comment: "ירוק",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/greenery/g80.jpg",
    },
    {
      id: "g81",
      sortOrder: 460,
      category: "greenery",
      name: "טילנדסיה אפורה",
      minQuantity: 1,
      maxQuantity: 3999,
      comment: "אפור",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/greenery/g81.jpg",
    },
    {
      id: "g82",
      sortOrder: 680,
      category: "greenery",
      name: "סנסיווריה - חרבות",
      minQuantity: 10,
      maxQuantity: 3990,
      comment: "ירוק",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/greenery/g82.jpg",
    },
    {
      id: "g83",
      sortOrder: 690,
      category: "greenery",
      name: "סנסיוריה גלילית",
      minQuantity: 10,
      maxQuantity: 3990,
      comment: "ירוק כהה",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/greenery/g83.jpg",
    },
    {
      id: "g84",
      sortOrder: 210,
      category: "greenery",
      name: "אספרגוס נשפך",
      minQuantity: 25,
      maxQuantity: 3975,
      comment: "ירוק",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/greenery/g84.jpg",
    },
    {
      id: "g85",
      sortOrder: 740,
      category: "greenery",
      name: "פילפלון",
      minQuantity: 25,
      maxQuantity: 3975,
      comment: "יתכנו חוסרים במוצר",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/greenery/g85.jpg",
    },
    {
      id: "g86",
      sortOrder: 500,
      category: "greenery",
      name: "לוגיסטרום",
      minQuantity: 10,
      maxQuantity: 3990,
      comment: "ירוק",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/greenery/g86.jpg",
    },
    {
      id: "g87",
      sortOrder: 820,
      category: "greenery",
      name: "רוזמרין-ענפים",
      minQuantity: 1,
      maxQuantity: 3999,
      comment: "ירוק 10 ענפים בממוצע",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/greenery/g87.jpg",
    },
    {
      id: "g88",
      sortOrder: 550,
      category: "greenery",
      name: "מוס אפור טבעי",
      minQuantity: 1,
      maxQuantity: 3999,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/greenery/g88.jpg",
    },
    {
      id: "g89",
      sortOrder: 570,
      category: "greenery",
      name: "מוס טרי-BALL",
      minQuantity: 1,
      maxQuantity: 3999,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/greenery/g89.jpg",
    },
    {
      id: "g90",
      sortOrder: 560,
      category: "greenery",
      name: "מוס טרי-פלאט",
      minQuantity: 1,
      maxQuantity: 3999,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/greenery/g90.jpg",
    },
    {
      id: "g91",
      sortOrder: 400,
      category: "greenery",
      name: "דיאנלה",
      minQuantity: 10,
      maxQuantity: 3990,
      comment: "ירוק-לבן",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/greenery/g91.jpg",
    },
    {
      id: "g92",
      sortOrder: 410,
      category: "greenery",
      name: "דיאנלה ירוקה",
      minQuantity: 10,
      maxQuantity: 3990,
      comment: "ירוק כהה",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/greenery/g92.jpg",
    },
    {
      id: "g93",
      sortOrder: 670,
      category: "greenery",
      name: "סליקס קצר",
      minQuantity: 50,
      maxQuantity: 3950,
      comment: "בערך 1.5 מטר גובה",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/greenery/g93.jpg",
    },
    {
      id: "p1",
      sortOrder: 2270,
      category: "plants",
      name: "עציץ קולאוס ע.18 / 17",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p1.jpg",
    },
    {
      id: "p2",
      sortOrder: 2900,
      category: "plants",
      name: "עציץ סנסיווריה TWISTED צמה ע.9 יבוא",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p2.jpg",
    },
    {
      id: "p3",
      sortOrder: 120,
      category: "plants",
      name: "עציץ אנטוריום ע.14",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "אדום, ורוד, לבן, סגול, בורדו, ירוק, אפרסק, דו-גוני",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/plants/p3.jpg",
    },
    {
      id: "p4",
      sortOrder: 130,
      category: "plants",
      name: "עציץ אנטוריום ע.17",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "אדום, ורוד, לבן, סגול, בורדו, ירוק, אפרסק, דו-גוני",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/plants/p4.jpg",
    },
    {
      id: "p5",
      sortOrder: 40,
      category: "plants",
      name: "עציץ אנטוריום ע.21",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p5.jpg",
    },
    {
      id: "p6",
      sortOrder: 1590,
      category: "plants",
      name: "עציץ סינגוניום ורוד ע.12",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p6.jpg",
    },
    {
      id: "p7",
      sortOrder: 1730,
      category: "plants",
      name: "עציץ ספטיפילום ע 17",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p7.jpg",
    },
    {
      id: "p8",
      sortOrder: 680,
      category: "plants",
      name: "עציץ אלוהה קוסמו / טיקי טהי ע 9",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p8.jpg",
    },
    {
      id: "p9",
      sortOrder: 2930,
      category: "plants",
      name: "עציץ פוטוס פיקטוס / ברזיל יבוא ע.12",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p9.jpg",
    },
    {
      id: "p10",
      sortOrder: 90,
      category: "plants",
      name: "מבצע עציץ סחלב ברבור ע.9 + קרמיקה",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p10.jpg",
    },
    {
      id: "p11",
      sortOrder: 2470,
      category: "plants",
      name: "עציץ רוזמרין דלי ע.24",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p11.jpg",
    },
    {
      id: "p12",
      sortOrder: 2790,
      category: "plants",
      name: "עציץ גוזמניה ע.9 יבוא",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p12.jpg",
    },
    {
      id: "p13",
      sortOrder: 1150,
      category: "plants",
      name: "עציץ וריזאה ע.14 מקומי",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p13.jpg",
    },
    {
      id: "p14",
      sortOrder: 1900,
      category: "plants",
      name: "עציץ פורטולוקריה זוחלת קערה 20",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p14.jpg",
    },
    {
      id: "p15",
      sortOrder: 1750,
      category: "plants",
      name: "עציץ ספטיפילום ע.14/15",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p15.jpg",
    },
    {
      id: "p16",
      sortOrder: 2480,
      category: "plants",
      name: "עציץ ריו (עלים סגולים) ע.18",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p16.jpg",
    },
    {
      id: "p17",
      sortOrder: 150,
      category: "plants",
      name: 'עציץ סחלב פילנופסיס מיני 2 ענף 25 ס"מ ע.7 עם קרמיקה',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "נא לציין צבע רצוי\\מיקס",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/plants/p17.jpg",
    },
    {
      id: "p18",
      sortOrder: 2880,
      category: "plants",
      name: "עציץ טורף כדנית  קערת תליה  ע.14 יבוא",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p18.jpg",
    },
    {
      id: "p19",
      sortOrder: 1190,
      category: "plants",
      name: "עציץ זית בונסאי ע.12",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p19.jpg",
    },
    {
      id: "p20",
      sortOrder: 1200,
      category: "plants",
      name: "עציץ זית בונסאי ע.15",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p20.jpg",
    },
    {
      id: "p21",
      sortOrder: 3220,
      category: "plants",
      name: "עציץ ניצנית ע.12 מקומי",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "נא לציין צבע רצוי,פתוח\\סגור",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/plants/p21.jpg",
    },
    {
      id: "p22",
      sortOrder: 3290,
      category: "plants",
      name: "עציץ פלפל נוי ע.12",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "אדום\\ירוק\\שחור",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/plants/p22.jpg",
    },
    {
      id: "p23",
      sortOrder: 3420,
      category: "plants",
      name: "עציץ תבלין ע-12 מיקס סוגים",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "קיים במגוון סוגים נא לציין סוג רצוי",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/plants/p23.jpg",
    },
    {
      id: "p24",
      sortOrder: 1000,
      category: "plants",
      name: "עציץ דיפנבכיה טרופיק ע. 24",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p24.jpg",
    },
    {
      id: "p25",
      sortOrder: 260,
      category: "plants",
      name: "עציץ דקל רווינאה ע.24",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p25.jpg",
    },
    {
      id: "p26",
      sortOrder: 2550,
      category: "plants",
      name: "עציץ שיפלרה שיחית ע.24",
      minQuantity: 1,
      maxQuantity: 199,
      comment: '80 ס"מ-מטר גובה',
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p26.jpg",
    },
    {
      id: "p27",
      sortOrder: 3280,
      category: "plants",
      name: "עציץ פיקוס גומי שחור / בליז מגוון ע-24",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "שחור\\מגוון",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/plants/p27.jpg",
    },
    {
      id: "p28",
      sortOrder: 1350,
      category: "plants",
      name: "עציץ יסמין (זנים שונים) דלי 7 ליטר",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p28.jpg",
    },
    {
      id: "p29",
      sortOrder: 2180,
      category: "plants",
      name: "עציץ פפרומיה מגנפוליה ירוקה קערה 20",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p29.jpg",
    },
    {
      id: "p30",
      sortOrder: 2280,
      category: "plants",
      name: "עציץ קורדליין אלקטריק /קיווי 10 ליטר(ע. 24)",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p30.jpg",
    },
    {
      id: "p31",
      sortOrder: 640,
      category: "plants",
      name: "עציץ אגלונמה ירוקה ע.12 מקומי",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p31.jpg",
    },
    {
      id: "p32",
      sortOrder: 180,
      category: "plants",
      name: "עציץ דקל אריקה ע.12/11",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p32.jpg",
    },
    {
      id: "p33",
      sortOrder: 3410,
      category: "plants",
      name: "עציץ שרך / ירוקים פרדו (סוגים שונים) ע.10",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/plants/p33.jpg",
    },
    {
      id: "p34",
      sortOrder: 740,
      category: "plants",
      name: "עציץ אשיננטוס מונה ליזה ע.15",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p34.jpg",
    },
    {
      id: "p35",
      sortOrder: 2310,
      category: "plants",
      name: "עציץ קיסוס הדרה קערה 20",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p35.jpg",
    },
    {
      id: "p36",
      sortOrder: 1800,
      category: "plants",
      name: "עציץ סקנדנס מגוון ע.15",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p36.jpg",
    },
    {
      id: "p37",
      sortOrder: 1880,
      category: "plants",
      name: "עציץ פוטוס תליה ע.15",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p37.jpg",
    },
    {
      id: "p38",
      sortOrder: 1960,
      category: "plants",
      name: "עציץ פייפר / מגוון ע.15",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p38.jpg",
    },
    {
      id: "p39",
      sortOrder: 1580,
      category: "plants",
      name: "עציץ סינגוניום אדום תליה ע-15 פרדו",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p39.jpg",
    },
    {
      id: "p40",
      sortOrder: 2610,
      category: "plants",
      name: "עציץ שרך בוסטון תליה קערה 20",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p40.jpg",
    },
    {
      id: "p41",
      sortOrder: 1090,
      category: "plants",
      name: "עציץ הדס כדורי ע.24- ראש גדול/ גזע גבוה",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p41.jpg",
    },
    {
      id: "p42",
      sortOrder: 1070,
      category: "plants",
      name: "עציץ הדס כדורי ע.12",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p42.jpg",
    },
    {
      id: "p43",
      sortOrder: 1370,
      category: "plants",
      name: "עציץ ירקה קערה 20",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p43.jpg",
    },
    {
      id: "p44",
      sortOrder: 2920,
      category: "plants",
      name: "עציץ ספטיפילום ע.7 יבוא",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p44.jpeg",
    },
    {
      id: "p45",
      sortOrder: 1720,
      category: "plants",
      name: "עציץ סנציו כדורים / בננה קערה 20קצר(לארוך מקט ניפרד)",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p45.jpg",
    },
    {
      id: "p46",
      sortOrder: 2230,
      category: "plants",
      name: "עציץ ציקס ע-12",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p46.jpg",
    },
    {
      id: "p47",
      sortOrder: 580,
      category: "plants",
      name: "עץ האושר בקרמיקה 9X9",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p47.jpg",
    },
    {
      id: "p48",
      sortOrder: 720,
      category: "plants",
      name: "עציץ אספרגוס מנוצה ע.12 או זנים שונים",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p48.jpg",
    },
    {
      id: "p49",
      sortOrder: 2750,
      category: "plants",
      name: "עציץ אלוורה רפואית ע.12 יבוא",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p49.jpg",
    },
    {
      id: "p50",
      sortOrder: 3330,
      category: "plants",
      name: "עציץ קקטוס מורכב קטן ע. 9",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "אדום, צהוב, כתום, ורוד, סגול",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/plants/p50.jpg",
    },
    {
      id: "p51",
      sortOrder: 3320,
      category: "plants",
      name: "עציץ קקטוס מורכב גדול ע.10",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "אדום, צהוב, כתום, ורוד, סגול",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/plants/p51.jpg",
    },
    {
      id: "p52",
      sortOrder: 270,
      category: "plants",
      name: "עציץ דקל שיפריצי 15 ליטר",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p52.jpg",
    },
    {
      id: "p53",
      sortOrder: 2860,
      category: "plants",
      name: "עציץ זמיה קוקולוס ע.19 יבוא",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p53.jpg",
    },
    {
      id: "p54",
      sortOrder: 2370,
      category: "plants",
      name: "עציץ קן ציפור ע.25",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "המוצג הימני",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p54.jpg",
    },
    {
      id: "p55",
      sortOrder: 1390,
      category: "plants",
      name: "עציץ לריופ יורו ע.15/ע.18",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "המוצג הימני",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p55.jpg",
    },
    {
      id: "p56",
      sortOrder: 3270,
      category: "plants",
      name: "עציץ עץ כסף בקרמיקה 9X9",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "אושר\\בטון\\קרמיקה",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/plants/p56.jpg",
    },
    {
      id: "p57",
      sortOrder: 310,
      category: "plants",
      name: "עציץ סוקולנט דיסקית אפורה / כריש ע.12",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p57.jpg",
    },
    {
      id: "p58",
      sortOrder: 1860,
      category: "plants",
      name: "עציץ פוטוס ירוק תליה קערה 20",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p58.jpg",
    },
    {
      id: "p59",
      sortOrder: 3480,
      category: "plants",
      name: "עציץ סנסיווריה עפרונות יבוא ע-8 (ראש ציבעוני)",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "קיים במגוון צבעים נא לציין צבע רצוי",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/plants/p59.jpg",
    },
    {
      id: "p60",
      sortOrder: 210,
      category: "plants",
      name: "עציץ דקל חמדוריאה אלגנס ע.12",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p60.jpg",
    },
    {
      id: "p61",
      sortOrder: 200,
      category: "plants",
      name: 'עציץ דקל אריקה ע.24 (נמוכה 80 ס"מ)',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p61.jpg",
    },
    {
      id: "p62",
      sortOrder: 1950,
      category: "plants",
      name: "עציץ פיטוספורום דלי",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p62.jpg",
    },
    {
      id: "p63",
      sortOrder: 3400,
      category: "plants",
      name: "עציץ קרוטון ע.13",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "מנוקד\\פטרה",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/plants/p63.jpg",
    },
    {
      id: "p64",
      sortOrder: 1470,
      category: "plants",
      name: "עציץ מריסיניה ע.12",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p64.jpg",
    },
    {
      id: "p65",
      sortOrder: 3360,
      category: "plants",
      name: "עציץ קקטוס ע.6.5 מקומי",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "נא לציין סוג רצוי",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/plants/p65.jpg",
    },
    {
      id: "p66",
      sortOrder: 3370,
      category: "plants",
      name: "עציץ קקטוס ע.9 מקומי",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "נא לציין סוג רצוי",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/plants/p66.jpg",
    },
    {
      id: "p67",
      sortOrder: 450,
      category: "plants",
      name: "לאקי במבוק זוג זכוכית 7X7",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p67.jpg",
    },
    {
      id: "p68",
      sortOrder: 1110,
      category: "plants",
      name: "עציץ הוורטיה ע.9",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "המוצג האמצעי",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p68.jpg",
    },
    {
      id: "p69",
      sortOrder: 3230,
      category: "plants",
      name: "עציץ סדום (צורית) ע-12",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "נא לציין את הסוג הרצוי",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/plants/p69.jpg",
    },
    {
      id: "p70",
      sortOrder: 290,
      category: "plants",
      name: "עציץ דקל שיפריצי דלי 7 ליטר",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "המוצג הימני",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p70.jpg",
    },
    {
      id: "p71",
      sortOrder: 3000,
      category: "plants",
      name: "עציץ פפרומיה הפי בין ע.12 יבוא",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p71.jpg",
    },
    {
      id: "p72",
      sortOrder: 2390,
      category: "plants",
      name: "עציץ קרוטון (זנים שונים) ע.15",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p72.jpg",
    },
    {
      id: "p73",
      sortOrder: 940,
      category: "plants",
      name: "עציץ גפנית ע.12",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p73.jpg",
    },
    {
      id: "p74",
      sortOrder: 1640,
      category: "plants",
      name: "עציץ סנסיווריה אפורה מונשיין ע.12",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p74.jpg",
    },
    {
      id: "p75",
      sortOrder: 1870,
      category: "plants",
      name: "עציץ פוטוס לבן ע.15",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p75.jpg",
    },
    {
      id: "p76",
      sortOrder: 160,
      category: "plants",
      name: 'עציץ סחלב פילנופסיס יבוא XXL 2 ענפים ע- 12 זוגות 70 ס"מ',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "נא לציין צבע רצוי",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/plants/p76.jpg",
    },
    {
      id: "p77",
      sortOrder: 890,
      category: "plants",
      name: "עציץ בת שבע קערה 20",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p77.jpg",
    },
    {
      id: "p78",
      sortOrder: 3030,
      category: "plants",
      name: "עציץ קיסוס יבוא ע-8/9",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p78.jpeg",
    },
    {
      id: "p79",
      sortOrder: 1820,
      category: "plants",
      name: "עציץ סרסניה טורף ע.12",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p79.jpg",
    },
    {
      id: "p80",
      sortOrder: 1920,
      category: "plants",
      name: "עציץ פיטוניה גידי כסף ע. 15",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p80.jpg",
    },
    {
      id: "p81",
      sortOrder: 1760,
      category: "plants",
      name: "עציץ ספטיפיליום ע.21 (מי עמי)",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p81.jpg",
    },
    {
      id: "p82",
      sortOrder: 350,
      category: "plants",
      name: "עציץ סוקולנט יבוא ע.12",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "נא לציין צורה\\צבע",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/plants/p82.jpg",
    },
    {
      id: "p83",
      sortOrder: 3470,
      category: "plants",
      name: "עציץ ניצנית ע.10.5 יבוא",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "נא לציין צבע רצוי,פתוח בלבד",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/plants/p83.jpg",
    },
    {
      id: "p84",
      sortOrder: 2170,
      category: "plants",
      name: "עציץ פפרומיה ליליאן ירוקה ע.12",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p84.jpg",
    },
    {
      id: "p85",
      sortOrder: 1160,
      category: "plants",
      name: "עציץ זיגו קקטוס קערה ללא פריחה!",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p85.jpeg",
    },
    {
      id: "p86",
      sortOrder: 3340,
      category: "plants",
      name: "עציץ קקטוס מקומי סוגים שונים ע. 12",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "נא לציין סוג רצוי",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/plants/p86.jpg",
    },
    {
      id: "p87",
      sortOrder: 1220,
      category: "plants",
      name: "עציץ זית בונסאי קערה 25",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p87.jpg",
    },
    {
      id: "p88",
      sortOrder: 250,
      category: "plants",
      name: "עציץ דקל רווינאה 25 ליטר",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "1 מטר-1.5 מטר",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p88.jpg",
    },
    {
      id: "p89",
      sortOrder: 1080,
      category: "plants",
      name: "עציץ הדס כדורי ע.18",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p89.jpg",
    },
    {
      id: "p90",
      sortOrder: 2940,
      category: "plants",
      name: "עציץ פיקוס בונסאי ע 5.5 יבוא",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p90.jpg",
    },
    {
      id: "p91",
      sortOrder: 3440,
      category: "plants",
      name: "עציץ הורטנזיה ע.14 יבוא",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "3 תפרחות (כחול/ לבן /ורוד רגיל)",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/plants/p91.jpg",
    },
    {
      id: "p92",
      sortOrder: 3080,
      category: "plants",
      name: "עציץ שעוונית זוחלת ע.15 יבוא ארוך מהרגיל",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "ירוק/ שחור",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p92.jpg",
    },
    {
      id: "p93",
      sortOrder: 20,
      category: "plants",
      name: "עציץ אנטוריום ע.11",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p93.jpg",
    },
    {
      id: "p94",
      sortOrder: 1810,
      category: "plants",
      name: "עציץ סקנדנס קערה 20",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p94.jpg",
    },
    {
      id: "p95",
      sortOrder: 10,
      category: "plants",
      name: "עציץ אנטוריום ורוד לילי ע 9",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p95.jpg",
    },
    {
      id: "p96",
      sortOrder: 2580,
      category: "plants",
      name: "עציץ שערות שולמית ע.15",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p96.jpg",
    },
    {
      id: "p97",
      sortOrder: 550,
      category: "plants",
      name: "עץ אהבה קערה 20",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p97.jpg",
    },
    {
      id: "p98",
      sortOrder: 560,
      category: "plants",
      name: "עץ אהבה קערה 25",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p98.jpg",
    },
    {
      id: "p99",
      sortOrder: 2450,
      category: "plants",
      name: "עציץ קרסולה ע.5.5  מיקס סוגים",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p99.jpg",
    },
    {
      id: "p100",
      sortOrder: 3170,
      category: "plants",
      name: "עציץ דיפלדניה /מנדבילה / סנדוילה ע.12",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "אדום, ורוד, לבן, צהוב, פוקסיה, משמש/אפרסק",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/plants/p100.jpg",
    },
    {
      id: "p101",
      sortOrder: 100,
      category: "plants",
      name: "עציץ אנטוריום ע.12 פרח שחור / בורדו יבוא",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p101.jpg",
    },
    {
      id: "p102",
      sortOrder: 2760,
      category: "plants",
      name: "עציץ אלוקסיה פולי ע.12 יבוא",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p102.jpg",
    },
    {
      id: "p103",
      sortOrder: 2500,
      category: "plants",
      name: "עציץ ריפסליס מיקס ע.15(ימני בלבד במלאי!)",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p103.jpg",
    },
    {
      id: "p104",
      sortOrder: 3250,
      category: "plants",
      name: "עציץ סנדוילה ע.18",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "אדום, ורוד, לבן, צהוב, פוקסיה",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/plants/p104.jpg",
    },
    {
      id: "p105",
      sortOrder: 3460,
      category: "plants",
      name: "עציץ ניצנית מיני ע.7 יבוא",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "נא לציין צבע רצוי",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/plants/p105.jpg",
    },
    {
      id: "p106",
      sortOrder: 2890,
      category: "plants",
      name: "עציץ ניצנית מג'יק בלס ע.14 יבוא (פעמונים ירוקים)",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p106.jpg",
    },
    {
      id: "p107",
      sortOrder: 1040,
      category: "plants",
      name: "עציץ דרצנה אוסטרלית אדמה ע.18",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p107.jpg",
    },
    {
      id: "p108",
      sortOrder: 330,
      category: "plants",
      name: "עציץ סוקולנט ע.9",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "נא לציין צורה\\צבע",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/plants/p108.jpg",
    },
    {
      id: "p109",
      sortOrder: 60,
      category: "plants",
      name: "עציץ סחלב אונצידיום 2 ענפים ע.12",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p109.jpg",
    },
    {
      id: "p110",
      sortOrder: 1010,
      category: "plants",
      name: "עציץ דיפנבכיה טרופיק ע.15",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p110.jpg",
    },
    {
      id: "p111",
      sortOrder: 3490,
      category: "plants",
      name: "עציץ פיטוניה גידי כסף יבוא ע.8",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "נא ציין צבע רצוי-מגש שלם מכיל 21 יח",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/plants/p111.jpg",
    },
    {
      id: "p112",
      sortOrder: 800,
      category: "plants",
      name: "עציץ ביגוניה רקס קערה 20 מיקס סוגים",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p112.jpg",
    },
    {
      id: "p113",
      sortOrder: 540,
      category: "plants",
      name: "עץ אהבה מדבקה צהובה",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p113.jpg",
    },
    {
      id: "p114",
      sortOrder: 1120,
      category: "plants",
      name: "עציץ הויה לב מגוון  ע.9- מלאי מוגבל",
      minQuantity: 1,
      maxQuantity: 199,
      comment: 'את הכלי אפשר למצוא בחיפוש "64507" המוצר ללא כלי!',
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p114.jpg",
    },
    {
      id: "p115",
      sortOrder: 1300,
      category: "plants",
      name: "עציץ יוקה ירוקה/מגוונת דלי",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p115.jpg",
    },
    {
      id: "p116",
      sortOrder: 820,
      category: "plants",
      name: "עציץ ביפי 7 ליטר דלי/ ע.24",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "גובה 1 מטר ומעלה",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p116.jpg",
    },
    {
      id: "p117",
      sortOrder: 3430,
      category: "plants",
      name: "עציץ דרצנה למון / דורדו/ טורנדו יבוא ע.12",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "למון\\ירוק\\מגוון",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/plants/p117.jpg",
    },
    {
      id: "p118",
      sortOrder: 3130,
      category: "plants",
      name: "עציץ אנג'לוניה ע.12",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "סגול, ורוד, לבן, כחול, דו-גוני",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/plants/p118.jpg",
    },
    {
      id: "p119",
      sortOrder: 2840,
      category: "plants",
      name: "עציץ זמיה קוקולוס ע.12 יבוא",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p119.jpg",
    },
    {
      id: "p120",
      sortOrder: 1670,
      category: "plants",
      name: "עציץ סנסיווריה מקלות טבעי ע.6",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p120.jpg",
    },
    {
      id: "p121",
      sortOrder: 340,
      category: "plants",
      name: "עציץ סוקולנט יבוא ע-5.5",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "נא לציין צורה\\צבע",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/plants/p121.jpg",
    },
    {
      id: "p122",
      sortOrder: 2560,
      category: "plants",
      name: "עציץ שעוונית זוחלת ע.12",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p122.jpg",
    },
    {
      id: "p123",
      sortOrder: 1600,
      category: "plants",
      name: "עציץ סינגוניום ירוק רגיל / פיקסי ע.12",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p123.jpg",
    },
    {
      id: "p124",
      sortOrder: 3150,
      category: "plants",
      name: "עציץ אקזקום ע.12",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "סגול/כחול, לבן, ורוד",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/plants/p124.jpg",
    },
    {
      id: "p125",
      sortOrder: 2720,
      category: "plants",
      name: "עציץ אופורביה טריגונה ע.12 יבוא",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p125.jpg",
    },
    {
      id: "p126",
      sortOrder: 1570,
      category: "plants",
      name: "עציץ סטיפה ע.17",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p126.jpg",
    },
    {
      id: "p127",
      sortOrder: 1700,
      category: "plants",
      name: "עציץ סנציו ג'נגל גולז ע.9/ 12",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p127.jpg",
    },
    {
      id: "p128",
      sortOrder: 2360,
      category: "plants",
      name: "עציץ קלתאה מיקס סוגים מקומי ע.24",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p128.jpg",
    },
    {
      id: "p129",
      sortOrder: 1680,
      category: "plants",
      name: "עציץ סנסיווריה מקלות מנומר טבעי ע..8/9",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p129.jpg",
    },
    {
      id: "p130",
      sortOrder: 2650,
      category: "plants",
      name: "צמח אויר אפור L",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p130.jpg",
    },
    {
      id: "p131",
      sortOrder: 220,
      category: "plants",
      name: "עציץ דקל חמדוריאה אלגנס ע.24",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "המוצג הימני",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p131.jpg",
    },
    {
      id: "p132",
      sortOrder: 830,
      category: "plants",
      name: "עציץ ביפי ע.18 / 17",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p132.jpg",
    },
    {
      id: "p133",
      sortOrder: 1320,
      category: "plants",
      name: "עציץ יוקה על גזע ע. 24 (צעירים)",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p133.jpg",
    },
    {
      id: "p134",
      sortOrder: 1440,
      category: "plants",
      name: "עציץ מורן החורש ע.24",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p134.jpg",
    },
    {
      id: "p135",
      sortOrder: 3140,
      category: "plants",
      name: "עציץ אנג'לוניה קערה 20",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "סגול, ורוד, לבן, כחול, דו-גוני",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/plants/p135.jpg",
    },
    {
      id: "p136",
      sortOrder: 3040,
      category: "plants",
      name: 'עציץ קן ציפור ע.12 יבוא "קריספי וויב"',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p136.jpg",
    },
    {
      id: "p137",
      sortOrder: 3190,
      category: "plants",
      name: "עציץ וינקה ע. 12(רק הפרח הגדול)",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "ורוד, לבן, סגול, אדום, לילך, בורדו, דו-גוני",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/plants/p137.jpg",
    },
    {
      id: "p138",
      sortOrder: 1910,
      category: "plants",
      name: "עציץ פורטולקה קערה 20",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p138.jpg",
    },
    {
      id: "p139",
      sortOrder: 3300,
      category: "plants",
      name: "עציץ פנטס ע.12",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "אדום, ורוד, סגול/לילך, לבן",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/plants/p139.jpg",
    },
    {
      id: "p140",
      sortOrder: 2100,
      category: "plants",
      name: "עציץ פלקטרנטוס מדגסקרי מגוון קערה 20",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p140.jpg",
    },
    {
      id: "p141",
      sortOrder: 1230,
      category: "plants",
      name: "עציץ זית בונסאי קערה 35",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p141.jpg",
    },
    {
      id: "p142",
      sortOrder: 2870,
      category: "plants",
      name: 'עציץ זמיה קוקולוס ע.21 יבוא גובה 100 ס"מ',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p142.jpg",
    },
    {
      id: "p143",
      sortOrder: 2080,
      category: "plants",
      name: "עציץ פיקוס פומילה קערה 20",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p143.jpg",
    },
    {
      id: "p144",
      sortOrder: 690,
      category: "plants",
      name: "עציץ אלוקסיה 25 ליטר(זנים שונים)",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "המוצג השמאלי",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p144.jpg",
    },
    {
      id: "p145",
      sortOrder: 510,
      category: "plants",
      name: "עץ אהבה מדבקה אדומה",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p145.jpg",
    },
    {
      id: "p146",
      sortOrder: 3090,
      category: "plants",
      name: "עציץ שרך אלבולינטה יבוא ע.12",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p146.jpg",
    },
    {
      id: "p147",
      sortOrder: 2490,
      category: "plants",
      name: "עציץ ריפסליס חוטי ע.12 מקומי",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p147.jpg",
    },
    {
      id: "p148",
      sortOrder: 710,
      category: "plants",
      name: "עציץ אלוקסיה ריגל שילדס ע.18 מיקס סוגים!",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p148.jpg",
    },
    {
      id: "p149",
      sortOrder: 1840,
      category: "plants",
      name: "עציץ עשב לימון ע. 12 (למון גראס)",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p149.jpg",
    },
    {
      id: "p150",
      sortOrder: 1450,
      category: "plants",
      name: "עציץ מורן מבריק ע.24",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p150.jpg",
    },
    {
      id: "p151",
      sortOrder: 1550,
      category: "plants",
      name: "עציץ סדום ע.9/10",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p151.jpg",
    },
    {
      id: "p152",
      sortOrder: 2780,
      category: "plants",
      name: "עציץ גוזמניה ע.12 יבוא",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p152.jpg",
    },
    {
      id: "p153",
      sortOrder: 2410,
      category: "plants",
      name: "עציץ קרוטון ע.28/ע.32",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p153.jpg",
    },
    {
      id: "p154",
      sortOrder: 390,
      category: "plants",
      name: "דרצנה טורנדו ע.6",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p154.jpg",
    },
    {
      id: "p155",
      sortOrder: 3160,
      category: "plants",
      name: "עציץ דיפלדניה / סנדוילה 7 ליטר",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "אדום, ורוד, לבן, צהוב",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/plants/p155.jpg",
    },
    {
      id: "p156",
      sortOrder: 440,
      category: "plants",
      name: 'לאקי במבוק בזכוכית עגולה 3 קנים גובה 10 ס"מ לאקי עגול',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p156.jpg",
    },
    {
      id: "p157",
      sortOrder: 430,
      category: "plants",
      name: 'לאקי במבוק בזכוכית מרובעת 3 קנים גובה 30 ס"מ לאקי בינוני',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p157.jpg",
    },
    {
      id: "p158",
      sortOrder: 520,
      category: "plants",
      name: "עץ אהבה מדבקה ירוקה",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p158.jpg",
    },
    {
      id: "p159",
      sortOrder: 2850,
      category: "plants",
      name: "עציץ זמיה קוקולוס ע.14 יבוא",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p159.jpg",
    },
    {
      id: "p160",
      sortOrder: 1240,
      category: "plants",
      name: "עציץ זמיה קוקולוס ע.17",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p160.jpg",
    },
    {
      id: "p161",
      sortOrder: 1930,
      category: "plants",
      name: "עציץ פיטוניה מיני נועה ע.12 קליברכואה",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p161.jpg",
    },
    {
      id: "p162",
      sortOrder: 490,
      category: "plants",
      name: "סביון מלבין ע.17",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p162.jpg",
    },
    {
      id: "p163",
      sortOrder: 2800,
      category: "plants",
      name: "עציץ דישידיה תליה יבוא קערה ע 14",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p163.jpg",
    },
    {
      id: "p164",
      sortOrder: 1400,
      category: "plants",
      name: "עציץ מארנטה זנים שונים ע.12.",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p164.jpg",
    },
    {
      id: "p165",
      sortOrder: 3050,
      category: "plants",
      name: "עציץ קרוטון ע.8 יבוא מנוקד צהוב בלבד",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p165.jpg",
    },
    {
      id: "p166",
      sortOrder: 810,
      category: "plants",
      name: "עציץ ביפי 25 ליטר",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p166.jpg",
    },
    {
      id: "p167",
      sortOrder: 1030,
      category: "plants",
      name: "עציץ דרצנה (סוגים שונים) קמור 32 / 15 ליטר",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p167.jpg",
    },
    {
      id: "p168",
      sortOrder: 2400,
      category: "plants",
      name: "עציץ קרוטון מיני מנוקד צהוב ע.18",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p168.jpg",
    },
    {
      id: "p169",
      sortOrder: 1650,
      category: "plants",
      name: "עציץ סנסיווריה חרבות ירוק / צהוב ע.12",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "המוצג השמאלי",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p169.jpg",
    },
    {
      id: "p170",
      sortOrder: 610,
      category: "plants",
      name: "עץ האושר מדבקה צהובה",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p170.jpg",
    },
    {
      id: "p171",
      sortOrder: 590,
      category: "plants",
      name: "עץ האושר מדבקה ירוקה",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p171.jpg",
    },
    {
      id: "p172",
      sortOrder: 600,
      category: "plants",
      name: "עץ האושר מדבקה כחולה",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p172.jpg",
    },
    {
      id: "p173",
      sortOrder: 1940,
      category: "plants",
      name: "עציץ פיטוניה מיני נועה קערה 20(מיקס צבעים )",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p173.jpg",
    },
    {
      id: "p174",
      sortOrder: 2960,
      category: "plants",
      name: "עציץ פיקוס בונסאי ע.12 יבוא",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p174.jpg",
    },
    {
      id: "p175",
      sortOrder: 620,
      category: "plants",
      name: "עץ הכסף מדבקה צהובה",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p175.jpg",
    },
    {
      id: "p176",
      sortOrder: 1770,
      category: "plants",
      name: "עציץ סקיבולה קערה 20",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p176.jpg",
    },
    {
      id: "p177",
      sortOrder: 3010,
      category: "plants",
      name: "עציץ פפרומיה שומי מקומטת ע.12 יבוא",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "שחור/ אדום/ אפרפר אדום",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p177.jpg",
    },
    {
      id: "p178",
      sortOrder: 1210,
      category: "plants",
      name: "עציץ זית בונסאי קערה 20",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p178.jpg",
    },
    {
      id: "p179",
      sortOrder: 140,
      category: "plants",
      name: 'עציץ סחלב פילנופסיס מולטי 2 ענפים ע-12 50 ס"מ',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "נא לציין צבע רצוי\\מיקס",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/plants/p179.jpg",
    },
    {
      id: "p180",
      sortOrder: 110,
      category: "plants",
      name: 'עציץ סחלב ריחני זני ארומה 35 ס"מ ע.12 (לוודא זמינות צבעים)יבוא בהזמנה מראש בלבד',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p180.jpg",
    },
    {
      id: "p181",
      sortOrder: 2770,
      category: "plants",
      name: "עציץ ארליה זוגיים ע.12 יבוא",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p181.jpg",
    },
    {
      id: "p182",
      sortOrder: 500,
      category: "plants",
      name: "עץ אהבה ברככיטון בעציץ פלסטיק ע.12",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p182.jpg",
    },
    {
      id: "p183",
      sortOrder: 2090,
      category: "plants",
      name: "עציץ פיקוס תאילנדי מגוון (עלה מאורך) 10 ליטר",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p183.jpg",
    },
    {
      id: "p184",
      sortOrder: 1180,
      category: "plants",
      name: "עציץ זיף נוצה ירוק דלי- פריחה מועטה",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p184.jpg",
    },
    {
      id: "p185",
      sortOrder: 2420,
      category: "plants",
      name: "עציץ קרוטון פטרה ע.17",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p185.jpg",
    },
    {
      id: "p186",
      sortOrder: 240,
      category: "plants",
      name: "עציץ דקל ראפיס דלי",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p186.jpg",
    },
    {
      id: "p187",
      sortOrder: 3390,
      category: "plants",
      name: "עציץ קרוטון (זנים שונים) ע.24 / דלי",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "מנוקד\\פטרה",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/plants/p187.jpg",
    },
    {
      id: "p188",
      sortOrder: 1460,
      category: "plants",
      name: "עציץ מילנבקיה קערה 20",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p188.jpg",
    },
    {
      id: "p189",
      sortOrder: 1410,
      category: "plants",
      name: "עציץ מונסטרה  7 ליטר דלי ע.24",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p189.jpg",
    },
    {
      id: "p190",
      sortOrder: 960,
      category: "plants",
      name: "עציץ דייטס דלי",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p190.jpg",
    },
    {
      id: "p191",
      sortOrder: 2290,
      category: "plants",
      name: "עציץ קורקומה ע.15",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p191.jpg",
    },
    {
      id: "p192",
      sortOrder: 2120,
      category: "plants",
      name: "עציץ פנדוריאה עלה מגוון פרח ורוד דלי 7 ליטר",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p192.jpg",
    },
    {
      id: "p193",
      sortOrder: 280,
      category: "plants",
      name: "עציץ דקל שיפריצי 25 ליטר",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p193.jpg",
    },
    {
      id: "p194",
      sortOrder: 3100,
      category: "plants",
      name: "עציץ שרך בוסטון יבוא ע.12",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p194.jpg",
    },
    {
      id: "p195",
      sortOrder: 300,
      category: "plants",
      name: "מבצע עציץ דקל טבעות 25 ליטר - נמוך לא מתאים לאירועים",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "המוצג השמאלי",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p195.jpg",
    },
    {
      id: "p196",
      sortOrder: 700,
      category: "plants",
      name: "עציץ אלוקסיה ירוקה 10 ליטר",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "המוצג הימני",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p196.jpg",
    },
    {
      id: "p197",
      sortOrder: 660,
      category: "plants",
      name: "עציץ אדיננטוס דלי",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p197.jpg",
    },
    {
      id: "p198",
      sortOrder: 2590,
      category: "plants",
      name: "עציץ שרך (זנים שונים) דלי",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p198.jpg",
    },
    {
      id: "p199",
      sortOrder: 1060,
      category: "plants",
      name: "עציץ דרצנה סוגים שונים קמור ע.22 / ע.24",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p199.jpg",
    },
    {
      id: "p200",
      sortOrder: 570,
      category: "plants",
      name: "עץ אהבה קרמיקה 9X9",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p200.jpg",
    },
    {
      id: "p201",
      sortOrder: 860,
      category: "plants",
      name: "עציץ בשמת השולטן ע. 12",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p201.jpg",
    },
    {
      id: "p202",
      sortOrder: 2110,
      category: "plants",
      name: "עציץ פנדוריאה דלי 7 ליטר",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "כמטר וחצי גובה",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p202.jpg",
    },
    {
      id: "p203",
      sortOrder: 2810,
      category: "plants",
      name: "עציץ דרצנה מרגינטה גזע מפוצלת ע.12 -יבוא",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p203.jpg",
    },
    {
      id: "p204",
      sortOrder: 410,
      category: "plants",
      name: 'לאקי במבוק ארובה גובה 40 ס"מ',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p204.jpg",
    },
    {
      id: "p205",
      sortOrder: 460,
      category: "plants",
      name: 'לאקי במבוק פטרייה גדול 45 ס"מ',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p205.jpg",
    },
    {
      id: "p206",
      sortOrder: 2510,
      category: "plants",
      name: "עציץ ריפסליס ע.9",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p206.jpg",
    },
    {
      id: "p207",
      sortOrder: 2630,
      category: "plants",
      name: "פפרומיה הפי בין ע.5.5",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p207.jpg",
    },
    {
      id: "p208",
      sortOrder: 3060,
      category: "plants",
      name: "עציץ ריפסליס ע.5.5 יבוא",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p208.jpg",
    },
    {
      id: "p209",
      sortOrder: 1560,
      category: "plants",
      name: "עציץ סטיפה דלי",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p209.jpg",
    },
    {
      id: "p210",
      sortOrder: 1340,
      category: "plants",
      name: "עציץ יוקה רוסטרטה אפורה דלי 10 ליטר",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p210.jpg",
    },
    {
      id: "p211",
      sortOrder: 2260,
      category: "plants",
      name: "עציץ קולאוס ע.12",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p211.jpg",
    },
    {
      id: "p212",
      sortOrder: 3200,
      category: "plants",
      name: "עציץ חרצית כריזנטמה ע. 12",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "נא ציין צבע\\מיקס",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/plants/p212.jpg",
    },
    {
      id: "p213",
      sortOrder: 420,
      category: "plants",
      name: "לאקי במבוק בזכוכית 3 קנים גבוה (לאקי גדול)",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p213.jpg",
    },
    {
      id: "p214",
      sortOrder: 1020,
      category: "plants",
      name: "עציץ דיפנבכיה קמילה ע.12",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p214.jpg",
    },
    {
      id: "p215",
      sortOrder: 2050,
      category: "plants",
      name: "עציץ פיקוס כינורי ע.12",
      minQuantity: 1,
      maxQuantity: 199,
      comment: 'גובה כ 40-50 ס"מ',
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p215.jpg",
    },
    {
      id: "p216",
      sortOrder: 3110,
      category: "plants",
      name: "עציץ שרך כחול יבוא ע-12",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p216.jpg",
    },
    {
      id: "p217",
      sortOrder: 2670,
      category: "plants",
      name: "קוקטייל קקטוס מדבקה כחולה",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p217.jpg",
    },
    {
      id: "p218",
      sortOrder: 2660,
      category: "plants",
      name: "קוקטייל קקטוס מדבקה אדומה",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p218.jpg",
    },
    {
      id: "p219",
      sortOrder: 850,
      category: "plants",
      name: "עציץ ביצן רובי ע.18",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p219.jpg",
    },
    {
      id: "p220",
      sortOrder: 2250,
      category: "plants",
      name: "עציץ צסטרום לילי דלי 7 ליטר (לא לארוע)",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "כמטר וחצי גובה",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p220.jpg",
    },
    {
      id: "p221",
      sortOrder: 910,
      category: "plants",
      name: "עציץ גפן זנים שונים 7 ליטר",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p221.jpg",
    },
    {
      id: "p222",
      sortOrder: 900,
      category: "plants",
      name: "עציץ גוזמניה ע.14",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "המוצגים הימיניים-קיים רק באדום",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p222.jpg",
    },
    {
      id: "p223",
      sortOrder: 2020,
      category: "plants",
      name: "עציץ פיקוס גומי מגוון על גזע ע.17",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p223.jpg",
    },
    {
      id: "p224",
      sortOrder: 2460,
      category: "plants",
      name: "עציץ קרסולה/ ניצנית פנדה ע.12 מקומי (זנים שונים)",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p224.jpg",
    },
    {
      id: "p225",
      sortOrder: 3310,
      category: "plants",
      name: "עציץ קלתאה ע.12 זנים שונים",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "נא לציין את הגוון הרצוי",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/plants/p225.jpg",
    },
    {
      id: "p226",
      sortOrder: 400,
      category: "plants",
      name: "לאקי במבוק אגרטל קלאסי (3 קנים)",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p226.jpg",
    },
    {
      id: "p227",
      sortOrder: 2130,
      category: "plants",
      name: "עציץ פסיפלורה ע.18",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p227.jpg",
    },
    {
      id: "p228",
      sortOrder: 30,
      category: "plants",
      name: "עציץ אנטוריום ע.12 מקומי",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p228.jpg",
    },
    {
      id: "p229",
      sortOrder: 2380,
      category: "plants",
      name: "עציץ קקטוס הצבריות כסא חותנת קערה 20",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p229.jpg",
    },
    {
      id: "p230",
      sortOrder: 2730,
      category: "plants",
      name: "עציץ אכימאה ורודה ע.12 - יבוא",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p230.jpg",
    },
    {
      id: "p231",
      sortOrder: 3020,
      category: "plants",
      name: "עציץ צמח קפה יבוא ע.12",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p231.jpg",
    },
    {
      id: "p232",
      sortOrder: 230,
      category: "plants",
      name: "עציץ דקל קנציה זוג דלי חום (פרדו)",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p232.jpg",
    },
    {
      id: "p233",
      sortOrder: 2240,
      category: "plants",
      name: "עציץ צמח קפה ע.9 בספל קרמיקה",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p233.jpg",
    },
    {
      id: "p234",
      sortOrder: 840,
      category: "plants",
      name: "עציץ ביצן ע.12",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p234.jpg",
    },
    {
      id: "p235",
      sortOrder: 2910,
      category: "plants",
      name: "עציץ סנציו הימלאיה ירוק ע.10.5 יבוא",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p235.jpg",
    },
    {
      id: "p236",
      sortOrder: 1530,
      category: "plants",
      name: "עציץ סביון מאפיר ניו לוק ע.12",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p236.jpg",
    },
    {
      id: "p237",
      sortOrder: 2570,
      category: "plants",
      name: "עציץ שערות שולמית ע.12",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p237.jpg",
    },
    {
      id: "p238",
      sortOrder: 970,
      category: "plants",
      name: "עציץ דיכונדרה כסופה ע.12",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "כסוף  - לא מוכן לארוע",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p238.jpg",
    },
    {
      id: "p239",
      sortOrder: 190,
      category: "plants",
      name: "עציץ דקל אריקה ע.15",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p239.jpg",
    },
    {
      id: "p240",
      sortOrder: 3180,
      category: "plants",
      name: "עציץ דרצנה למון ליים / מסנג'נה ע.15",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "ירוק-לימון, ירוק-כהה, צהוב",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/plants/p240.jpg",
    },
    {
      id: "p241",
      sortOrder: 2040,
      category: "plants",
      name: "עציץ פיקוס גומי שחור 15 ליטר",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p241.jpg",
    },
    {
      id: "p242",
      sortOrder: 920,
      category: "plants",
      name: "עציץ גפנית  ע 10",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p242.jpg",
    },
    {
      id: "p243",
      sortOrder: 70,
      category: "plants",
      name: "עציץ סחלב אונצידיום ענף בודד ע.12 (פתוח בלבד!)",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p243.jpg",
    },
    {
      id: "p244",
      sortOrder: 50,
      category: "plants",
      name: "עציץ אנטוריום קלווריום עלה שחור ע.14",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p244.jpg",
    },
    {
      id: "p245",
      sortOrder: 2210,
      category: "plants",
      name: "עציץ פפרומיה מגנפוליה מקומי ע.10",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p245.jpg",
    },
    {
      id: "p246",
      sortOrder: 1520,
      category: "plants",
      name: "עציץ ננדינה תרבותית / קומפקטום דלי",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p246.jpg",
    },
    {
      id: "p247",
      sortOrder: 2300,
      category: "plants",
      name: "עציץ קזוארינה מכחילה 10 ליטר",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p247.jpg",
    },
    {
      id: "p248",
      sortOrder: 670,
      category: "plants",
      name: "עציץ אימפריאל אדום / ירוק על מוס ע.22",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p248.jpg",
    },
    {
      id: "p249",
      sortOrder: 2330,
      category: "plants",
      name: "עציץ קיסוס קשת ע.12",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p249.jpg",
    },
    {
      id: "p250",
      sortOrder: 1100,
      category: "plants",
      name: "עציץ הוורטיה ע.5.5",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "המוצג הימני",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p250.jpg",
    },
    {
      id: "p251",
      sortOrder: 1890,
      category: "plants",
      name: "עציץ פוקסיה על קשת ע.18",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p251.jpg",
    },
    {
      id: "p252",
      sortOrder: 1360,
      category: "plants",
      name: "עציץ ירקה ע.12",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p252.jpg",
    },
    {
      id: "p253",
      sortOrder: 2710,
      category: "plants",
      name: "עציץ אופורביה טירוקלי ע 12 יבוא",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p253.jpg",
    },
    {
      id: "p254",
      sortOrder: 990,
      category: "plants",
      name: "עציץ דיפנבכיה ואזוס ע.24",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p254.jpg",
    },
    {
      id: "p255",
      sortOrder: 1850,
      category: "plants",
      name: "עציץ פוטוס /סקנדנס (סוגים שונים) ע.10",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p255.jpg",
    },
    {
      id: "p256",
      sortOrder: 3070,
      category: "plants",
      name: "עציץ ריפסליס פילוקרפה דק ע.17 יבוא",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p256.jpg",
    },
    {
      id: "p257",
      sortOrder: 1130,
      category: "plants",
      name: "עציץ היפומאה קערה 20",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p257.jpg",
    },
    {
      id: "p258",
      sortOrder: 170,
      category: "plants",
      name: "עציץ דקל אריקה 12 ליטר או 15 ליטר (נמוכים ורחבים)",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "המוצג השמאלי",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p258.jpg",
    },
    {
      id: "p259",
      sortOrder: 1690,
      category: "plants",
      name: "עציץ סנציו אפונים מקומי ע. 9",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p259.jpg",
    },
    {
      id: "p260",
      sortOrder: 2820,
      category: "plants",
      name: "עציץ דרצנה מרגינטה ע.17 יבוא",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p260.jpg",
    },
    {
      id: "p261",
      sortOrder: 3380,
      category: "plants",
      name: "עציץ קרוטון (זנים שונים) 25 ליטר",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "מנוקד\\פטרה",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/plants/p261.jpg",
    },
    {
      id: "p262",
      sortOrder: 320,
      category: "plants",
      name: "עציץ סוקולנט מיקס סוגים דלי 7 ליטר (דלי שחור)",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p262.png",
    },
    {
      id: "p263",
      sortOrder: 1170,
      category: "plants",
      name: "עציץ זיף נוצה ארגמני- אדום דלי",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p263.jpg",
    },
    {
      id: "p264",
      sortOrder: 2440,
      category: "plants",
      name: "עציץ קרסולה סגלגלה / אלמוגים דלי 10ליטר",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p264.jpg",
    },
    {
      id: "p265",
      sortOrder: 1420,
      category: "plants",
      name: "עציץ מונסטרה אובליקה חורים ע 12- מלאות ויפות",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p265.jpg",
    },
    {
      id: "p266",
      sortOrder: 530,
      category: "plants",
      name: "עץ אהבה מדבקה כחולה",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p266.jpg",
    },
    {
      id: "p267",
      sortOrder: 1310,
      category: "plants",
      name: "עציץ יוקה מגוונת גואל 15 ליטר",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p267.jpg",
    },
    {
      id: "p268",
      sortOrder: 3350,
      category: "plants",
      name: "עציץ קקטוס מקומי סוגים שונים ע. 15",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "נא לציין סוג רצוי",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/plants/p268.jpg",
    },
    {
      id: "p269",
      sortOrder: 2540,
      category: "plants",
      name: "עציץ שיפלרה שיחית 15 ליטר **גובה 2 מטר!!!!****",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p269.jpg",
    },
    {
      id: "p270",
      sortOrder: 1620,
      category: "plants",
      name: "עציץ סנסיוורה 15 ליטר",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p270.jpg",
    },
    {
      id: "p271",
      sortOrder: 2740,
      category: "plants",
      name: "עציץ אלוהה קוסמו ע 12 יבוא",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p271.jpg",
    },
    {
      id: "p272",
      sortOrder: 2350,
      category: "plants",
      name: "עציץ קליסיה קערה 20",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p272.jpg",
    },
    {
      id: "p273",
      sortOrder: 2320,
      category: "plants",
      name: "עציץ קיסוס כוסית",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p273.jpg",
    },
    {
      id: "p274",
      sortOrder: 2430,
      category: "plants",
      name: "עציץ קריפטנטוס ע 5.5",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p274.jpg",
    },
    {
      id: "p275",
      sortOrder: 1980,
      category: "plants",
      name: "עציץ פילאה דמעות באפור ע.15",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p275.jpg",
    },
    {
      id: "p276",
      sortOrder: 1290,
      category: "plants",
      name: "עציץ יוקה ירוקה 15 ליטר",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "המוצג השמאלי",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p276.jpg",
    },
    {
      id: "p277",
      sortOrder: 630,
      category: "plants",
      name: "עץ פיקוס כינורי מעוצב על גזע 15 ליטר",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "עציץ זה יחוייב בתוספת הובלה- בהתאם לאיזור הפריקה",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p277.jpg",
    },
    {
      id: "p278",
      sortOrder: 2060,
      category: "plants",
      name: "עציץ פיקוס כינורי ע.24",
      minQuantity: 1,
      maxQuantity: 199,
      comment: 'גובה כ 80 ס"מ-מטר',
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p278.jpg",
    },
    {
      id: "p279",
      sortOrder: 1970,
      category: "plants",
      name: "עציץ פילאה (זנים שונים) ע.12 מקומי",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p279.jpg",
    },
    {
      id: "p280",
      sortOrder: 1990,
      category: "plants",
      name: "עציץ פילאה דמעות באפור ע.9",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p280.jpg",
    },
    {
      id: "p281",
      sortOrder: 980,
      category: "plants",
      name: "עציץ דיכונדרה כסופה קערה 20",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p281.jpg",
    },
    {
      id: "p282",
      sortOrder: 1140,
      category: "plants",
      name: "עציץ וינקה מיוחדת סופר סטאר (ביוטי)קערה 20",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "המוצג השמאלי",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p282.jpg",
    },
    {
      id: "p283",
      sortOrder: 2030,
      category: "plants",
      name: "עציץ פיקוס גומי ע.12",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p283.jpg",
    },
    {
      id: "p284",
      sortOrder: 1050,
      category: "plants",
      name: "עציץ דרצנה מרגינטה גזע 15 ליטר",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p284.jpg",
    },
    {
      id: "p285",
      sortOrder: 1480,
      category: "plants",
      name: "עציץ מריסיניה ע.15",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p285.jpg",
    },
    {
      id: "p286",
      sortOrder: 370,
      category: "plants",
      name: "אגבה בלו גלואו 10 ליטר",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p286.jpg",
    },
    {
      id: "p287",
      sortOrder: 1610,
      category: "plants",
      name: "עציץ סנטולינה ע.17",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p287.png",
    },
    {
      id: "p288",
      sortOrder: 2190,
      category: "plants",
      name: "עציץ פפרומיה מגנפוליה מגוון קערה 20",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p288.jpg",
    },
    {
      id: "p289",
      sortOrder: 2160,
      category: "plants",
      name: "עציץ פפרומיה אקוודור מגוון בהיר קערה 20",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p289.jpg",
    },
    {
      id: "p290",
      sortOrder: 2220,
      category: "plants",
      name: "עציץ פפרומיה רנה ורדה קערה 20",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p290.jpg",
    },
    {
      id: "p291",
      sortOrder: 750,
      category: "plants",
      name: 'עציץ אשיננטוס מסולסל "רסטה"  ע.15',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p291.jpg",
    },
    {
      id: "p292",
      sortOrder: 2070,
      category: "plants",
      name: "עציץ פיקוס פומילה ע.12",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p292.jpg",
    },
    {
      id: "p293",
      sortOrder: 3260,
      category: "plants",
      name: "עציץ סנציו מאונט אוורסט ע.5.5",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "נא לציין צבע מבוקש",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/plants/p293.jpg",
    },
    {
      id: "p294",
      sortOrder: 3210,
      category: "plants",
      name: "עציץ טונברגיה סוזי שחורת העין 7 ליטר",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "כתום, צהוב, לבן, ורוד, אדום/בורדו",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/plants/p294.jpg",
    },
    {
      id: "p295",
      sortOrder: 930,
      category: "plants",
      name: "עציץ גפנית מחומשת / משולשת -נמוכה 8 ליטר",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p295.jpg",
    },
    {
      id: "p296",
      sortOrder: 1790,
      category: "plants",
      name: "עציץ סקנדנס ירוק ע.15",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p296.jpg",
    },
    {
      id: "p297",
      sortOrder: 2150,
      category: "plants",
      name: "עציץ פפרומיה אקוודור ירוק קערה 20",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p297.jpg",
    },
    {
      id: "p298",
      sortOrder: 1260,
      category: "plants",
      name: "עציץ חלבלוב טירוקלי 10 ליטר מקומי",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p298.jpg",
    },
    {
      id: "p299",
      sortOrder: 790,
      category: "plants",
      name: "עציץ ביגוניה רקס ע.12 (מיקס צבעים)",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p299.jpg",
    },
    {
      id: "p300",
      sortOrder: 1500,
      category: "plants",
      name: "עציץ ניקולאי / רבנלה דלי 15 ליטר",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "המוצג הימני,כמטר וחצי-2 מטר",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p300.jpg",
    },
    {
      id: "p301",
      sortOrder: 2340,
      category: "plants",
      name: "עציץ קלדיום ע 18",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p301.jpg",
    },
    {
      id: "p302",
      sortOrder: 2950,
      category: "plants",
      name: "עציץ פיקוס בונסאי ע 9 יבוא",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p302.jpg",
    },
    {
      id: "p303",
      sortOrder: 1430,
      category: "plants",
      name: "עציץ מונסטרה דליסיוזה ע.15",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p303.jpg",
    },
    {
      id: "p304",
      sortOrder: 2980,
      category: "plants",
      name: "עציץ פכירה בונסאי שזור יבוא ע.12",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p304.jpg",
    },
    {
      id: "p305",
      sortOrder: 2970,
      category: "plants",
      name: "עציץ פכירה בונסאי שזור יבוא ע 17",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p305.jpg",
    },
    {
      id: "p306",
      sortOrder: 2010,
      category: "plants",
      name: "עציץ פילדנדרון לימון גולד ע 12",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p306.jpg",
    },
    {
      id: "p307",
      sortOrder: 1740,
      category: "plants",
      name: "עציץ ספטיפילום ע.11",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p307.jpg",
    },
    {
      id: "p308",
      sortOrder: 1280,
      category: "plants",
      name: "עציץ יהודי נודד ע.9 זנים פשוטים",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p308.jpg",
    },
    {
      id: "p309",
      sortOrder: 2530,
      category: "plants",
      name: "עציץ שיפלרה עצית ע.24",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p309.jpg",
    },
    {
      id: "p310",
      sortOrder: 2000,
      category: "plants",
      name: "עציץ פילדנדרון בירקין ע.12",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p310.jpg",
    },
    {
      id: "p311",
      sortOrder: 780,
      category: "plants",
      name: "עציץ ביגוניה סולי מוטטה 20 מקומי",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p311.jpg",
    },
    {
      id: "p312",
      sortOrder: 1630,
      category: "plants",
      name: "עציץ סנסיווריה 20 ליטר",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "המוצג הימני",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p312.jpg",
    },
    {
      id: "p313",
      sortOrder: 880,
      category: "plants",
      name: "עציץ בת שבע ע.9",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p313.jpg",
    },
    {
      id: "p314",
      sortOrder: 770,
      category: "plants",
      name: "עציץ ביגוניה מנוקדת מקולטה /שיחית/ כנפי מלאך ע 13/12",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p314.jpg",
    },
    {
      id: "p315",
      sortOrder: 2990,
      category: "plants",
      name: "עציץ פפרומיה אבטיח ע.12 יבוא ARGYREIA",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p315.jpg",
    },
    {
      id: "p316",
      sortOrder: 2140,
      category: "plants",
      name: 'עציץ פפרומיה "פנקייק" ריינדרופ ע.15/18',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p316.jpg",
    },
    {
      id: "p317",
      sortOrder: 1660,
      category: "plants",
      name: "עציץ סנסיווריה חרבות ירוק / צהוב ע.9",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "המוצג האמצעי",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p317.jpg",
    },
    {
      id: "p318",
      sortOrder: 1330,
      category: "plants",
      name: "עציץ יוקה רוסטרטה אפורה 15 ליטר",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p318.jpg",
    },
    {
      id: "p319",
      sortOrder: 80,
      category: "plants",
      name: 'עציץ סחלב זנים מיוחדים מונקו חום ע.12 60 ס"מ- לפי הזמנה מיוחדת',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p319.jpg",
    },
    {
      id: "p320",
      sortOrder: 1270,
      category: "plants",
      name: "עציץ טילנדסיה דריאנה ע.9 פרח כתום",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p320.jpg",
    },
    {
      id: "p321",
      sortOrder: 3120,
      category: "plants",
      name: "צמח אויר ורוד במתקן מתכת - יבוא",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p321.jpg",
    },
    {
      id: "p322",
      sortOrder: 1780,
      category: "plants",
      name: "עציץ סקנדנס (סוגים שונים) ע.12",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p322.jpg",
    },
    {
      id: "p323",
      sortOrder: 1710,
      category: "plants",
      name: "עציץ סנציו הימליה ירוק/ אוורס אפור ע.9",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p323.jpg",
    },
    {
      id: "p324",
      sortOrder: 730,
      category: "plants",
      name: "עציץ ארליה יפנית/ מגוונת/ירוקה  / פטסיה  ע 18",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p324.jpg",
    },
    {
      id: "p325",
      sortOrder: 1250,
      category: "plants",
      name: "עציץ חי עולם ע.7",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p325.jpg",
    },
    {
      id: "p326",
      sortOrder: 2640,
      category: "plants",
      name: "צורית נוסבאומר 5 ליטר",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p326.jpg",
    },
    {
      id: "p327",
      sortOrder: 2830,
      category: "plants",
      name: "עציץ הורטנזיה פניקולטה ע.26 תחילת פריחה- לבן בלבד יבוא- עד גמר המלאי ללא שמירה",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p327.jpg",
    },
    {
      id: "p328",
      sortOrder: 2200,
      category: "plants",
      name: "עציץ פפרומיה מגנפוליה מגוונת/ ירוקה ע.12",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p328.jpg",
    },
    {
      id: "p329",
      sortOrder: 3240,
      category: "plants",
      name: "עציץ סינגוניום אדום מריה ע.12",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "ורוד-אדמדם, ירוק-זית",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/plants/p329.jpg",
    },
    {
      id: "p330",
      sortOrder: 650,
      category: "plants",
      name: "עציץ אגלונמה עלה צר ע.12",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p330.jpg",
    },
    {
      id: "p331",
      sortOrder: 2520,
      category: "plants",
      name: "עציץ ריפסליס קע.20 מקומי (זנים שונים) קצר",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p331.jpg",
    },
    {
      id: "p332",
      sortOrder: 3450,
      category: "plants",
      name: "עציץ ניצנית מיני במשפך ע.7 יבוא",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "נא ציין צבע רצוי",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/plants/p332.jpg",
    },
    {
      id: "p333",
      sortOrder: 1490,
      category: "plants",
      name: "עציץ ניצחה 10 ליטר",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p333.jpg",
    },
    {
      id: "p334",
      sortOrder: 1510,
      category: "plants",
      name: "עציץ ניקולאי 25 ליטר חמישיות",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p334.jpg",
    },
    {
      id: "p335",
      sortOrder: 2600,
      category: "plants",
      name: "עציץ שרך (סוגים שונים) ע.12 גידול מקומי",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p335.jpg",
    },
    {
      id: "p336",
      sortOrder: 870,
      category: "plants",
      name: "עציץ בת שבע ע. 12 מקומי",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p336.jpg",
    },
    {
      id: "p337",
      sortOrder: 1540,
      category: "plants",
      name: "עציץ סביון ניו לוק מאפיר ע.17",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p337.jpg",
    },
    {
      id: "p338",
      sortOrder: 1830,
      category: "plants",
      name: "עציץ עב שיבולת ע.12",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p338.png",
    },
    {
      id: "p339",
      sortOrder: 380,
      category: "plants",
      name: "אורגנו ע.12",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p339.jpg",
    },
    {
      id: "p340",
      sortOrder: 480,
      category: "plants",
      name: "נענע ע.12",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p340.jpg",
    },
    {
      id: "p341",
      sortOrder: 360,
      category: "plants",
      name: ".לואיזה ע.12",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p341.jpg",
    },
    {
      id: "p342",
      sortOrder: 2690,
      category: "plants",
      name: "רוזמרין זקוף  ע.12",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p342.jpg",
    },
    {
      id: "p343",
      sortOrder: 2700,
      category: "plants",
      name: "שיבא ע.12",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p343.jpg",
    },
    {
      id: "p344",
      sortOrder: 2620,
      category: "plants",
      name: "עציץ תבלין פיגם/רודה ע.12",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p344.jpg",
    },
    {
      id: "p345",
      sortOrder: 2680,
      category: "plants",
      name: "קורנית טימין ע.12",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p345.jpg",
    },
    {
      id: "p346",
      sortOrder: 1380,
      category: "plants",
      name: "עציץ לבנדר מנוצה / קנרי ע.12",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p346.jpg",
    },
    {
      id: "p347",
      sortOrder: 760,
      category: "plants",
      name: "עציץ בזיליקום ע.12",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p347.jpg",
    },
    {
      id: "p348",
      sortOrder: 470,
      category: "plants",
      name: "מליסה ע.12",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p348.jpg",
    },
    {
      id: "p349",
      sortOrder: 950,
      category: "plants",
      name: "עציץ גרניום לימוני ע.12",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/plants/p349.jpg",
    },
    {
      id: "d1",
      sortOrder: 30,
      category: "driedFlowers",
      name: "אקליפטוס פרובלנטה גוונים",
      minQuantity: 1,
      maxQuantity: 199,
      comment:
        "גוונים: כתום/כחול/צהוב/חציל/ורוד/אדום. סחורה טרייה באיכות ייבוש גבוהה. לתשומת לבכם - המחיר הוא לחבילה המכילה כ-15 ענפים.",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/driedFlowers/d1.jpg",
    },
    {
      id: "d2",
      sortOrder: 360,
      category: "driedFlowers",
      name: "חיטה טבעי מקומי",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "גוון חום טבעי, כ-50 יחידות בכל חבילה.",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/driedFlowers/d2.jpg",
    },
    {
      id: "d3",
      sortOrder: 380,
      category: "driedFlowers",
      name: "כותנה ענף בודד",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "בכל ענף כ-7-8 פרחים בממוצע.",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/driedFlowers/d3.jpg",
    },
    {
      id: "d4",
      sortOrder: 370,
      category: "driedFlowers",
      name: "חרדלית",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "החבילה כוללת 5 ענפים.",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/driedFlowers/d4.jpg",
    },
    {
      id: "d5",
      sortOrder: 440,
      category: "driedFlowers",
      name: "עשב בר",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "גוון טבעי, כ-35 ענפים בכל חבילה.",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/driedFlowers/d5.jpg",
    },
    {
      id: "d6",
      sortOrder: 310,
      category: "driedFlowers",
      name: "גרינבל מיובש טבעי",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "גוון טבעי, 5 יחידות בחבילה.",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/driedFlowers/d6.jpg",
    },
    {
      id: "d7",
      sortOrder: 570,
      category: "driedFlowers",
      name: "סליקס צבוע",
      minQuantity: 10,
      maxQuantity: 190,
      comment:
        "גוונים: אדום/אפור/לבן. ניתן להזמין מראש בהתראה של 72 שעות בכל הגוונים - נא לציין את הצבע המבוקש.",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/driedFlowers/d7.jpg",
    },
    {
      id: "d8",
      sortOrder: 350,
      category: "driedFlowers",
      name: "חבילת חציר קטנה",
      minQuantity: 1,
      maxQuantity: 199,
      comment: 'גודל המוצר 11X6 ס"מ - זהו הפריט המופיע בצד שמאל בתמונה.',
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/driedFlowers/d8.jpg",
    },
    {
      id: "d9",
      sortOrder: 340,
      category: "driedFlowers",
      name: "חבילת חציר בינונית",
      minQuantity: 1,
      maxQuantity: 199,
      comment: 'גודל המוצר 12X27 ס"מ - זהו הפריט המופיע בצד ימין בתמונה.',
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/driedFlowers/d9.jpg",
    },
    {
      id: "d10",
      sortOrder: 580,
      category: "driedFlowers",
      name: "פרח פמפס חנוט גבוה",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "אדום/אפור (טבעי).",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/driedFlowers/d10.jpg",
    },
    {
      id: "d11",
      sortOrder: 140,
      category: "driedFlowers",
      name: "לגורוס-זנב ארנב יבוא 100 יח",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "שחור/לבן.",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/driedFlowers/d11.jpg",
    },
    {
      id: "d12",
      sortOrder: 610,
      category: "driedFlowers",
      name: 'סילבר גראס 70 ס"מ(עטוף נייר חום)',
      minQuantity: 1,
      maxQuantity: 199,
      comment:
        "מיבוא 2025. גוונים: טבעי/לבנדר/חום/לבן/כחול/צהוב/ורוד. 6 יחידות בחבילה.",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/driedFlowers/d12.jpg",
    },
    {
      id: "d13",
      sortOrder: 420,
      category: "driedFlowers",
      name: "משיין יבש לבן",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "מקטיף שנת 2025, בגוון לבן פתוח.",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/driedFlowers/d13.jpg",
    },
    {
      id: "d14",
      sortOrder: 400,
      category: "driedFlowers",
      name: "לוטוס יבש על מקל",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "10 יחידות בכל חבילה.",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/driedFlowers/d14.jpg",
    },
    {
      id: "d15",
      sortOrder: 480,
      category: "driedFlowers",
      name: "תפזורת אצטרובל",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/driedFlowers/d15.jpg",
    },
    {
      id: "d16",
      sortOrder: 120,
      category: "driedFlowers",
      name: "גונפרנה יבשה יבוא",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "כחול/לבן/שחור, כ-25 ענפים בממוצע לחבילה.",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/driedFlowers/d16.jpg",
    },
    {
      id: "d17",
      sortOrder: 540,
      category: "driedFlowers",
      name: "לינו גראס",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "גוונים: לבן/שחור/חום. למעלה מ-50 ענפים בחבילה.",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/driedFlowers/d17.jpg",
    },
    {
      id: "d18",
      sortOrder: 160,
      category: "driedFlowers",
      name: "לימוניום יבוא יבש",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "לבן/כחול.",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/driedFlowers/d18.jpg",
    },
    {
      id: "d19",
      sortOrder: 390,
      category: "driedFlowers",
      name: "לבנדר יבש מקומי",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "מקטיף שנת 2024, כ-50 יחידות בחבילה.",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/driedFlowers/d19.jpg",
    },
    {
      id: "d20",
      sortOrder: 130,
      category: "driedFlowers",
      name: "גראס טבעי יבוא",
      minQuantity: 1,
      maxQuantity: 199,
      comment:
        "מיבוא 2025. גוונים: שחור/חום/ורוד/לבן/טבעי/לבנדר/כחול/צהוב. למעלה מ-50 ענפים בחבילה.",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/driedFlowers/d20.jpg",
    },
    {
      id: "d21",
      sortOrder: 320,
      category: "driedFlowers",
      name: "דקל יבש טבעי מעוגל",
      minQuantity: 1,
      maxQuantity: 199,
      comment: '3 יחידות בחבילה, בגובה 45 ס"מ.',
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/driedFlowers/d21.jpg",
    },
    {
      id: "d22",
      sortOrder: 60,
      category: "driedFlowers",
      name: "זנב חתול יבוא",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/driedFlowers/d22.jpg",
    },
    {
      id: "d23",
      sortOrder: 190,
      category: "driedFlowers",
      name: "פמפס חנוט יבוא",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "טבעי (אפור)/כחול.",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/driedFlowers/d23.jpg",
    },
    {
      id: "d24",
      sortOrder: 70,
      category: "driedFlowers",
      name: "מקלות זנב חתול יבש יבוא",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/driedFlowers/d24.jpg",
    },
    {
      id: "d25",
      sortOrder: 490,
      category: "driedFlowers",
      name: "פמפס יבש צבע טבעי מבצע",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "חבילה של 15 ענפים (5 צרורות של 3), בגוון טבעי אפור.",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/driedFlowers/d25.jpg",
    },
    {
      id: "d26",
      sortOrder: 270,
      category: "driedFlowers",
      name: "גומא מיני יבש",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/driedFlowers/d26.jpg",
    },
    {
      id: "d27",
      sortOrder: 290,
      category: "driedFlowers",
      name: "גזר-קיפח",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/driedFlowers/d27.jpg",
    },
    {
      id: "d28",
      sortOrder: 300,
      category: "driedFlowers",
      name: "גיפסנית לבנה חנוטה",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "נפח זהה לחבילה הטרייה, כ-25 ענפים בממוצע.",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/driedFlowers/d28.jpg",
    },
    {
      id: "d29",
      sortOrder: 240,
      category: "driedFlowers",
      name: "ארטישוק יבש",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/driedFlowers/d29.jpg",
    },
    {
      id: "d30",
      sortOrder: 590,
      category: "driedFlowers",
      name: "רוסקוס מולבן\\צבוע חדש",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "צהוב/פיץ/אדום.",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/driedFlowers/d30.jpg",
    },
    {
      id: "d31",
      sortOrder: 250,
      category: "driedFlowers",
      name: "ארטישוק מפוצל יבש",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "נמכר לפי יחידת ענף בודד.",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/driedFlowers/d31.jpg",
    },
    {
      id: "d32",
      sortOrder: 180,
      category: "driedFlowers",
      name: "פילאריס יבש יבוא",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "גוונים: לבן/טבעי/לילך/חום.",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/driedFlowers/d32.jpg",
    },
    {
      id: "d33",
      sortOrder: 560,
      category: "driedFlowers",
      name: "סיטאריה יבש",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "100 גר בחבילה (כ-20 ענפים), בגוונים טבעי/כחול.",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/driedFlowers/d33.jpg",
    },
    {
      id: "d34",
      sortOrder: 500,
      category: "driedFlowers",
      name: "אוונה יבש",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "100 גר בחבילה (כ-25 ענפים בממוצע), בגוון לבן.",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/driedFlowers/d34.jpg",
    },
    {
      id: "d35",
      sortOrder: 600,
      category: "driedFlowers",
      name: "תירס הודי יבש",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "לבן/כחול/ורוד.",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/driedFlowers/d35.jpg",
    },
    {
      id: "d36",
      sortOrder: 80,
      category: "driedFlowers",
      name: "אכילאה יבשה יבוא",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "מיבוא 2025, בגוונים לבן/טבעי.",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/driedFlowers/d36.jpg",
    },
    {
      id: "d37",
      sortOrder: 40,
      category: "driedFlowers",
      name: "אקליפטוס מטבעות חנוט יבוא",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "כחול.",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/driedFlowers/d37.jpg",
    },
    {
      id: "d38",
      sortOrder: 620,
      category: "driedFlowers",
      name: "פוניקס גראס יבש-מבצע",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "גוונים: לבן/דבש/כחול. 100 גר בחבילה - למעלה מ-100 יחידות.",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/driedFlowers/d38.jpg",
    },
    {
      id: "d39",
      sortOrder: 200,
      category: "driedFlowers",
      name: "פרח אורז חנוט יבוא",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "80 גר בחבילה, מיבוא 2025, בגוון לבן.",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/driedFlowers/d39.jpg",
    },
    {
      id: "d40",
      sortOrder: 510,
      category: "driedFlowers",
      name: "אספרגוס ורגטוס חנוט",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "לבן, 10 ענפים בחבילה.",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/driedFlowers/d40.jpg",
    },
    {
      id: "d41",
      sortOrder: 460,
      category: "driedFlowers",
      name: "שום סגול יבש",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "החבילה מכילה 5 ענפים.",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/driedFlowers/d41.jpg",
    },
    {
      id: "d42",
      sortOrder: 230,
      category: "driedFlowers",
      name: "אספרגוס פלומוזיס מולבן",
      minQuantity: 25,
      maxQuantity: 175,
      comment: "תהליך הלבנה מושלם - ללא דביקות וללא ריח.",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/driedFlowers/d42.jpg",
    },
    {
      id: "d43",
      sortOrder: 220,
      category: "driedFlowers",
      name: "אספרגוס מרוקלאדיוס מולבן חנוט",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/driedFlowers/d43.jpg",
    },
    {
      id: "d44",
      sortOrder: 20,
      category: "driedFlowers",
      name: "אקליפטוס גיינט יבש גוונים",
      minQuantity: 5,
      maxQuantity: 195,
      comment:
        "כל ענף באורך 2 מטר, יבש וצבוע במגוון גוונים. נמכר לפי ענפים, 5 יחידות בחבילה.",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/driedFlowers/d44.jpg",
    },
    {
      id: "d45",
      sortOrder: 520,
      category: "driedFlowers",
      name: "זיפן יבש",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "יש לציין את הגוון המבוקש בעת ההזמנה.",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/driedFlowers/d45.jpg",
    },
    {
      id: "d46",
      sortOrder: 530,
      category: "driedFlowers",
      name: "לימוניום סנסי יבש",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "לבן.",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/driedFlowers/d46.jpg",
    },
    {
      id: "d47",
      sortOrder: 10,
      category: "driedFlowers",
      name: "אקליפטוס פרי יבש יבוא",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/driedFlowers/d47.jpg",
    },
    {
      id: "d48",
      sortOrder: 150,
      category: "driedFlowers",
      name: "לגורוס-זנב ארנב יבוא 50 יח",
      minQuantity: 1,
      maxQuantity: 199,
      comment:
        "מיבוא 2025. גוונים: ורוד בהיר/לילך/צהוב/חום, וכן גוון חדש - כחול.",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/driedFlowers/d48.jpg",
    },
    {
      id: "d49",
      sortOrder: 100,
      category: "driedFlowers",
      name: "אקליפוטוס גוני יבוא",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "מיבוא 2025, בגוונים אדום/כחול.",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/driedFlowers/d49.jpg",
    },
    {
      id: "d50",
      sortOrder: 50,
      category: "driedFlowers",
      name: "אקליפטוס פרי יבוא",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "מיבוא 2025, בגוונים צהוב/אדום/טבעי.",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/driedFlowers/d50.jpg",
    },
    {
      id: "d51",
      sortOrder: 110,
      category: "driedFlowers",
      name: "גונפרנה טבעית יבשה יבוא",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "לבן.",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/driedFlowers/d51.jpg",
    },
    {
      id: "d52",
      sortOrder: 210,
      category: "driedFlowers",
      name: "פרח כדור יבוא",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "מיבוא 2026, 3 יחידות בחבילה, בגוונים לבן/ורוד/חום.",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/driedFlowers/d52.jpg",
    },
    {
      id: "d53",
      sortOrder: 170,
      category: "driedFlowers",
      name: "לימוניום יפני יבוא",
      minQuantity: 1,
      maxQuantity: 199,
      comment:
        "מיבוא 2025, 10 יחידות בחבילה, בגוונים לבן טבעי/צהוב/אדום/סגול/כתום.",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/driedFlowers/d53.jpg",
    },
    {
      id: "d54",
      sortOrder: 450,
      category: "driedFlowers",
      name: "קרספידיה יבשה צהוב",
      minQuantity: 10,
      maxQuantity: 190,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/driedFlowers/d54.jpg",
    },
    {
      id: "d55",
      sortOrder: 430,
      category: "driedFlowers",
      name: "ענפי תות יבש",
      minQuantity: 5,
      maxQuantity: 195,
      comment: "אורך הענף כ-3 מטר.",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/driedFlowers/d55.jpg",
    },
    {
      id: "d56",
      sortOrder: 90,
      category: "driedFlowers",
      name: "אמרנטוס חנוט יבוא",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "מיבוא 2026. גוונים: ורוד בהיר/סגול כהה-חום/צהוב בהיר.",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/driedFlowers/d56.jpg",
    },
    {
      id: "d57",
      sortOrder: 330,
      category: "driedFlowers",
      name: 'דקל יבש טבעי מעוגל ראש 25-30 ס"מ',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "המחיר הינו ליחידה.",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/driedFlowers/d57.jpg",
    },
    {
      id: "d58",
      sortOrder: 280,
      category: "driedFlowers",
      name: "גומא מיני יבש כדורי",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/driedFlowers/d58.jpg",
    },
    {
      id: "d59",
      sortOrder: 410,
      category: "driedFlowers",
      name: "מוזהבת יבשה",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/driedFlowers/d59.jpg",
    },
    {
      id: "d60",
      sortOrder: 470,
      category: "driedFlowers",
      name: "תגית בר יבשה",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "10 ענפים בכל חבילה.",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/driedFlowers/d60.jpg",
    },
    {
      id: "d61",
      sortOrder: 550,
      category: "driedFlowers",
      name: "מוס חנוט 0.5 קילו",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "בהיר/תפוח.",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/driedFlowers/d61.jpg",
    },
    {
      id: "d62",
      sortOrder: 260,
      category: "driedFlowers",
      name: "באלה חציר גדולה",
      minQuantity: 1,
      maxQuantity: 199,
      comment: 'גודל המוצר: 85X47X35 ס"מ.',
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/driedFlowers/d62.jpg",
    },
    {
      id: "a1",
      sortOrder: 60,
      category: "accessories",
      name: "ספוג אואזיס מידי תליה",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/accessories/a1.jpg",
    },
    {
      id: "a2",
      sortOrder: 1260,
      category: "accessories",
      name: 'ספריי צבע ספרינג  400 סמ"ק',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "נא לציין צבע מבוקש",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/accessories/a2.jpg",
    },
    {
      id: "a3",
      sortOrder: 1250,
      category: "accessories",
      name: 'ספריי נצנצים 300 סמ"ק GLITTER',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "כסוף\\זהב",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/accessories/a3.jpg",
    },
    {
      id: "a4",
      sortOrder: 600,
      category: "accessories",
      name: "דלי גדול כללי",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/accessories/a4.jpg",
    },
    {
      id: "a5",
      sortOrder: 620,
      category: "accessories",
      name: "כרטיס ברכה",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/accessories/a5.jpg",
    },
    {
      id: "a6",
      sortOrder: 530,
      category: "accessories",
      name: "גרלנדה אואזיס",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/accessories/a6.jpg",
    },
    {
      id: "a7",
      sortOrder: 460,
      category: "accessories",
      name: "ארגז פלסטיק שחור",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/accessories/a7.jpg",
    },
    {
      id: "a8",
      sortOrder: 640,
      category: "accessories",
      name: "לונג לייף קרטון 1000 יח'",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/accessories/a8.jpg",
    },
    {
      id: "a9",
      sortOrder: 400,
      category: "accessories",
      name: "סרט קשירה",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "נא לציין צבע מבוקש",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/accessories/a9.jpg",
    },
    {
      id: "a10",
      sortOrder: 1240,
      category: "accessories",
      name: "סליל ברזל  אואזיס",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "ירוק\\כסף\\זהב\\אדום\\שחור",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/accessories/a10.jpg",
    },
    {
      id: "a11",
      sortOrder: 330,
      category: "accessories",
      name: 'סרט סאטן 1.5 ס"מ 50 מטר/50 יארד',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "נא לציין צבע מבוקש",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/accessories/a11.jpg",
    },
    {
      id: "a12",
      sortOrder: 310,
      category: "accessories",
      name: 'סרט אורגנזה 2.5 ס"מ 25 יארד',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "נא לציין צבע מבוקש",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/accessories/a12.jpg",
    },
    {
      id: "a13",
      sortOrder: 340,
      category: "accessories",
      name: 'סרט סאטן 2.5 ס"מ 25 יארד',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "נא לציין צבע מבוקש",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/accessories/a13.jpg",
    },
    {
      id: "a14",
      sortOrder: 360,
      category: "accessories",
      name: 'סרט סאטן רחב 4.0 ס"מ 25 יארד',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "נא לציין צבע מבוקש",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/accessories/a14.jpg",
    },
    {
      id: "a15",
      sortOrder: 320,
      category: "accessories",
      name: 'סרט סאטן 1.5 ס"מ 25 יארד',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "נא לציין צבע מבוקש",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/accessories/a15.jpg",
    },
    {
      id: "a16",
      sortOrder: 180,
      category: "accessories",
      name: "קרטון ספוג אואזיס אידיאל",
      minQuantity: 1,
      maxQuantity: 199,
      comment:
        "מכיל 20 יח,הספוג הטוב בעולם,האיכות הכי גבוהה שיש,אל תחסכו 10 שקל בעיניין הזה!",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/accessories/a16.jpg",
    },
    {
      id: "a17",
      sortOrder: 80,
      category: "accessories",
      name: "ספוג בודד",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/accessories/a17.jpg",
    },
    {
      id: "a18",
      sortOrder: 540,
      category: "accessories",
      name: 'דבק נוזלי בשפורפרת "אואזיס"',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/accessories/a18.jpg",
    },
    {
      id: "a19",
      sortOrder: 800,
      category: "accessories",
      name: "ספריי מבריק עלים גדול",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/accessories/a19.jpg",
    },
    {
      id: "a20",
      sortOrder: 790,
      category: "accessories",
      name: "ספריי מבריק עלים בינוני",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/accessories/a20.jpg",
    },
    {
      id: "a21",
      sortOrder: 470,
      category: "accessories",
      name: "גביע לזר כלה אואזיס",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/accessories/a21.jpg",
    },
    {
      id: "a22",
      sortOrder: 610,
      category: "accessories",
      name: "טול לגביע",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/accessories/a22.jpg",
    },
    {
      id: "a23",
      sortOrder: 1340,
      category: "accessories",
      name: "קש סומבררו גדול טבעי\\לבן",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "טבעי\\לבן",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/accessories/a23.jpg",
    },
    {
      id: "a24",
      sortOrder: 450,
      category: "accessories",
      name: "אנקור טייפ",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/accessories/a24.jpg",
    },
    {
      id: "a25",
      sortOrder: 1290,
      category: "accessories",
      name: "קערה אוולית שווצרית",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "ירוק\\לבן",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/accessories/a25.jpg",
    },
    {
      id: "a26",
      sortOrder: 1320,
      category: "accessories",
      name: "קערה מרובעת שווצרית",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "ירוק\\לבן",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/accessories/a26.jpg",
    },
    {
      id: "a27",
      sortOrder: 1300,
      category: "accessories",
      name: "קערה מלבנית שווצרית",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "ירוק\\לבן",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/accessories/a27.jpg",
    },
    {
      id: "a28",
      sortOrder: 1330,
      category: "accessories",
      name: "קערה עגולה שווצרית",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "ירוק\\לבן",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/accessories/a28.jpg",
    },
    {
      id: "a29",
      sortOrder: 1310,
      category: "accessories",
      name: "קערה מרובעת גמבו",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "ירוק\\לבן",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/accessories/a29.jpg",
    },
    {
      id: "a30",
      sortOrder: 850,
      category: "accessories",
      name: "קערה מגבעת",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/accessories/a30.jpg",
    },
    {
      id: "a31",
      sortOrder: 750,
      category: "accessories",
      name: "סיכות פטנט",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/accessories/a31.jpg",
    },
    {
      id: "a32",
      sortOrder: 860,
      category: "accessories",
      name: "קערה מרקייה",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/accessories/a32.jpg",
    },
    {
      id: "a33",
      sortOrder: 380,
      category: "accessories",
      name: 'סרט פלסטיק צר 2 ס"מ',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "נא לציין צבע מבוקש",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/accessories/a33.jpg",
    },
    {
      id: "a34",
      sortOrder: 370,
      category: "accessories",
      name: 'סרט פלסטיק בינוני 3 ס"מ',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "נא לציין צבע מבוקש",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/accessories/a34.jpg",
    },
    {
      id: "a35",
      sortOrder: 390,
      category: "accessories",
      name: 'סרט פלסטיק רחב 5 ס"מ',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "נא לציין צבע מבוקש",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/accessories/a35.jpg",
    },
    {
      id: "a36",
      sortOrder: 710,
      category: "accessories",
      name: "מקלף ורדים ברזל",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/accessories/a36.jpg",
    },
    {
      id: "a37",
      sortOrder: 760,
      category: "accessories",
      name: "סכין פלוריסטים",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/accessories/a37.jpg",
    },
    {
      id: "a38",
      sortOrder: 190,
      category: "accessories",
      name: "קרטון ספוג אואזיס ג'מבו",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "מכיל 3 יחידות",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/accessories/a38.jpg",
    },
    {
      id: "a39",
      sortOrder: 220,
      category: "accessories",
      name: "חוט ברזל 0.8",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/accessories/a39.jpg",
    },
    {
      id: "a40",
      sortOrder: 230,
      category: "accessories",
      name: "חוט ברזל 1.2",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/accessories/a40.jpg",
    },
    {
      id: "a41",
      sortOrder: 880,
      category: "accessories",
      name: "רפייה",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/accessories/a41.jpg",
    },
    {
      id: "a42",
      sortOrder: 520,
      category: "accessories",
      name: "גליל צלופן",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/accessories/a42.jpg",
    },
    {
      id: "a43",
      sortOrder: 810,
      category: "accessories",
      name: "ספריי מדביר כנימות ספרינג",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/accessories/a43.jpg",
    },
    {
      id: "a44",
      sortOrder: 50,
      category: "accessories",
      name: "כדור ספוג 9 ס\"מ (מארז 5 י'ח)",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/accessories/a44.jpg",
    },
    {
      id: "a45",
      sortOrder: 20,
      category: "accessories",
      name: "כדור ספוג 12 ס\"מ (מארז 5 י'ח)",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/accessories/a45.jpg",
    },
    {
      id: "a46",
      sortOrder: 30,
      category: "accessories",
      name: "כדור ספוג 16 ס\"מ (מארז 2 י'ח)",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/accessories/a46.jpg",
    },
    {
      id: "a47",
      sortOrder: 40,
      category: "accessories",
      name: "כדור ספוג 20 ס\"מ (י'ח אחת)",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/accessories/a47.jpg",
    },
    {
      id: "a48",
      sortOrder: 100,
      category: "accessories",
      name: 'ספוג לב אואזיס 30 ס"מ(2יח)',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/accessories/a48.jpg",
    },
    {
      id: "a49",
      sortOrder: 970,
      category: "accessories",
      name: 'תחתית עגולה 14 ס"מ',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/accessories/a49.jpg",
    },
    {
      id: "a50",
      sortOrder: 980,
      category: "accessories",
      name: 'תחתית עגולה 16 ס"מ',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/accessories/a50.jpg",
    },
    {
      id: "a51",
      sortOrder: 990,
      category: "accessories",
      name: 'תחתית עגולה 18 ס"מ',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/accessories/a51.jpg",
    },
    {
      id: "a52",
      sortOrder: 1000,
      category: "accessories",
      name: 'תחתית עגולה 20 ס"מ',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/accessories/a52.jpg",
    },
    {
      id: "a53",
      sortOrder: 1010,
      category: "accessories",
      name: 'תחתית עגולה 22 ס"מ',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/accessories/a53.jpg",
    },
    {
      id: "a54",
      sortOrder: 1020,
      category: "accessories",
      name: 'תחתית עגולה 24 ס"מ',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/accessories/a54.jpg",
    },
    {
      id: "a55",
      sortOrder: 1030,
      category: "accessories",
      name: 'תחתית עגולה 26 ס"מ',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/accessories/a55.jpg",
    },
    {
      id: "a56",
      sortOrder: 1040,
      category: "accessories",
      name: 'תחתית עגולה 28 ס"מ',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/accessories/a56.jpg",
    },
    {
      id: "a57",
      sortOrder: 1050,
      category: "accessories",
      name: 'תחתית עגולה 30 ס"מ',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/accessories/a57.jpg",
    },
    {
      id: "a58",
      sortOrder: 940,
      category: "accessories",
      name: 'תחתית עגולה  35/36 ס"מ',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/accessories/a58.jpg",
    },
    {
      id: "a59",
      sortOrder: 1090,
      category: "accessories",
      name: 'תחתית עגולה 40 ס"מ',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/accessories/a59.jpg",
    },
    {
      id: "a60",
      sortOrder: 920,
      category: "accessories",
      name: 'תחתית מעוטרת לאדנית 60 ס"מ',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/accessories/a60.jpg",
    },
    {
      id: "a61",
      sortOrder: 1170,
      category: "accessories",
      name: "גליל טול 50 מטר",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "נא לציין צבע מבוקש",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/accessories/a61.jpg",
    },
    {
      id: "a62",
      sortOrder: 1160,
      category: "accessories",
      name: "גליל אורגנזה",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "נא לציין צבע מבוקש",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/accessories/a62.jpg",
    },
    {
      id: "a63",
      sortOrder: 1350,
      category: "accessories",
      name: "רשת ארומה",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "נא לציין צבע מבוקש",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/accessories/a63.jpg",
    },
    {
      id: "a64",
      sortOrder: 1230,
      category: "accessories",
      name: "טייפ גמיש",
      minQuantity: 2,
      maxQuantity: 198,
      comment: "ירוק\\לבן",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/accessories/a64.jpg",
    },
    {
      id: "a65",
      sortOrder: 240,
      category: "accessories",
      name: "חוט ברזל מלופף לזר לראש",
      minQuantity: 10,
      maxQuantity: 190,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/accessories/a65.jpg",
    },
    {
      id: "a66",
      sortOrder: 840,
      category: "accessories",
      name: "קערה בינונית",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/accessories/a66.jpg",
    },
    {
      id: "a67",
      sortOrder: 830,
      category: "accessories",
      name: "קיטומון-סכין אצבע לחיתוך גבעולים",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/accessories/a67.jpg",
    },
    {
      id: "a68",
      sortOrder: 700,
      category: "accessories",
      name: "מקטפה כחולה",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/accessories/a68.jpg",
    },
    {
      id: "a69",
      sortOrder: 480,
      category: "accessories",
      name: 'גלגל אבל - חישוק קש לזר אבל 60 ס"מ',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/accessories/a69.jpg",
    },
    {
      id: "a70",
      sortOrder: 290,
      category: "accessories",
      name: "חוט ביופיקס",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "טבעי\\חום\\ירוק\\לבן",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/accessories/a70.jpg",
    },
    {
      id: "a71",
      sortOrder: 1190,
      category: "accessories",
      name: "גליל פניניות שמפיין/לבן/כסף",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "נא לציין צבע מבוקש",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/accessories/a71.jpg",
    },
    {
      id: "a72",
      sortOrder: 740,
      category: "accessories",
      name: "סיכות יהלום קטן",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/accessories/a72.jpg",
    },
    {
      id: "a73",
      sortOrder: 730,
      category: "accessories",
      name: "סיכות יהלום גדול",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/accessories/a73.jpg",
    },
    {
      id: "a74",
      sortOrder: 440,
      category: "accessories",
      name: "אואזיס פיקס",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/accessories/a74.jpg",
    },
    {
      id: "a75",
      sortOrder: 960,
      category: "accessories",
      name: 'תחתית עגולה 12 ס"מ',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/accessories/a75.jpg",
    },
    {
      id: "a76",
      sortOrder: 1120,
      category: "accessories",
      name: 'תחתית עגולה 52 ס"מ',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/accessories/a76.jpg",
    },
    {
      id: "a77",
      sortOrder: 490,
      category: "accessories",
      name: "גליל חרוזים לבנים  30 מטר",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/accessories/a77.jpg",
    },
    {
      id: "a78",
      sortOrder: 660,
      category: "accessories",
      name: "מבחנה פלסטיק + מכסה",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/accessories/a78.jpg",
    },
    {
      id: "a79",
      sortOrder: 770,
      category: "accessories",
      name: "סכין קטיף מקצועי",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/accessories/a79.jpg",
    },
    {
      id: "a80",
      sortOrder: 1060,
      category: "accessories",
      name: 'תחתית עגולה 32 ס"מ',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/accessories/a80.jpg",
    },
    {
      id: "a81",
      sortOrder: 720,
      category: "accessories",
      name: "מקלף ורדים סיליקון(3 יח)",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/accessories/a81.jpg",
    },
    {
      id: "a82",
      sortOrder: 200,
      category: "accessories",
      name: "קרטון ספוג אואזיס יבש",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/accessories/a82.jpg",
    },
    {
      id: "a83",
      sortOrder: 670,
      category: "accessories",
      name: "מזמרה כחולה B-4163",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "מומלצת לענפים חזקים",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/accessories/a83.jpg",
    },
    {
      id: "a84",
      sortOrder: 1280,
      category: "accessories",
      name: "קופסת פרפרים על ברזל - 12 יח'",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "נא לציין צבעים רצויים",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/accessories/a84.jpg",
    },
    {
      id: "a85",
      sortOrder: 780,
      category: "accessories",
      name: "סלסלה לשושבינה קש מלמלה",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/accessories/a85.jpg",
    },
    {
      id: "a86",
      sortOrder: 690,
      category: "accessories",
      name: "מקטפה יפנית אדומה T-55/ ARS",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/accessories/a86.jpg",
    },
    {
      id: "a87",
      sortOrder: 630,
      category: "accessories",
      name: 'לב מיני אואזיס 24*25 ס"מ (2יח)',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/accessories/a87.jpg",
    },
    {
      id: "a88",
      sortOrder: 70,
      category: "accessories",
      name: "ספוג אוטו אואזיס",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/accessories/a88.jpg",
    },
    {
      id: "a89",
      sortOrder: 280,
      category: "accessories",
      name: "חוט אלומיניום חלק 12  מטר",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "נא לציין צבע מבוקש",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/accessories/a89.jpg",
    },
    {
      id: "a90",
      sortOrder: 270,
      category: "accessories",
      name: "סליל חוט שוזרים כסף 100 גרם על מקל",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/accessories/a90.jpg",
    },
    {
      id: "a91",
      sortOrder: 420,
      category: "accessories",
      name: "*לבבות ענק באהבה (6 יח')",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/accessories/a91.jpg",
    },
    {
      id: "a92",
      sortOrder: 430,
      category: "accessories",
      name: "*לבבות ענק מנצנץ באהבה (6 יח)",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/accessories/a92.jpg",
    },
    {
      id: "a93",
      sortOrder: 150,
      category: "accessories",
      name: 'ספוג רינג אואזיס 20 ס"מ (2יח)',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/accessories/a93.jpg",
    },
    {
      id: "a94",
      sortOrder: 160,
      category: "accessories",
      name: 'ספוג רינג אואזיס 25 ס"מ(2יח)',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/accessories/a94.jpg",
    },
    {
      id: "a95",
      sortOrder: 170,
      category: "accessories",
      name: 'ספוג רינג אואזיס 30 ס"מ(2יח)',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/accessories/a95.jpg",
    },
    {
      id: "a96",
      sortOrder: 110,
      category: "accessories",
      name: 'ספוג לב אואזיס 38 ס"מ(2יח)',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/accessories/a96.jpg",
    },
    {
      id: "a97",
      sortOrder: 410,
      category: "accessories",
      name: "*לב אדום (ILY)כרית על ברזל ( 12 יח')",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/accessories/a97.jpg",
    },
    {
      id: "a98",
      sortOrder: 130,
      category: "accessories",
      name: 'ספוג קונוס 60 ס"מ',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/accessories/a98.jpg",
    },
    {
      id: "a99",
      sortOrder: 140,
      category: "accessories",
      name: 'ספוג קונוס 80 ס"מ',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/accessories/a99.jpg",
    },
    {
      id: "a100",
      sortOrder: 120,
      category: "accessories",
      name: 'ספוג קונוס 100 ס"מ',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/accessories/a100.jpg",
    },
    {
      id: "a101",
      sortOrder: 10,
      category: "accessories",
      name: 'אואזיס ספוג לב 20 ס"מ סגור(2יח)',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/accessories/a101.jpg",
    },
    {
      id: "a102",
      sortOrder: 930,
      category: "accessories",
      name: "תחתית מעוטרת לאדנית 80 סמ",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/accessories/a102.jpg",
    },
    {
      id: "a103",
      sortOrder: 820,
      category: "accessories",
      name: 'צלופן בודד 6/13/50 ס"מ',
      minQuantity: 50,
      maxQuantity: 150,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/accessories/a103.jpg",
    },
    {
      id: "a104",
      sortOrder: 250,
      category: "accessories",
      name: "חוט ברזל מלופף לזר ראש (100 יחידות)",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/accessories/a104.jpg",
    },
    {
      id: "a105",
      sortOrder: 1210,
      category: "accessories",
      name: "חבילה גומיות 500 גרם",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "אנא ציין עובי\\גודל",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/accessories/a105.jpg",
    },
    {
      id: "a106",
      sortOrder: 910,
      category: "accessories",
      name: "רשת לול 5 מטר-צבע זהב",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/accessories/a106.jpg",
    },
    {
      id: "a107",
      sortOrder: 210,
      category: "accessories",
      name: "רשת לול לספוג בודד",
      minQuantity: 25,
      maxQuantity: 175,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/accessories/a107.jpg",
    },
    {
      id: "a108",
      sortOrder: 890,
      category: "accessories",
      name: "רפייה טבעית סינטטית בגליל",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "רק טבעי במלאי(צד ימין למטה)",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/accessories/a108.jpg",
    },
    {
      id: "a109",
      sortOrder: 680,
      category: "accessories",
      name: "מספריים מקצועיות",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/accessories/a109.jpg",
    },
    {
      id: "a110",
      sortOrder: 90,
      category: "accessories",
      name: 'ספוג לב אואזיס 16 ס"מ(4יח)',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/accessories/a110.jpg",
    },
    {
      id: "a111",
      sortOrder: 590,
      category: "accessories",
      name: "דוקרן פלסטיק עם דבק (50 יח')",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/accessories/a111.jpg",
    },
    {
      id: "a112",
      sortOrder: 510,
      category: "accessories",
      name: "גליל נייר חום",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/accessories/a112.jpg",
    },
    {
      id: "a113",
      sortOrder: 550,
      category: "accessories",
      name: 'דוקרן מתכת לסידור פרחים 40 מ"מ',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "כולל דבק דו צדדי בתחתית",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/accessories/a113.jpg",
    },
    {
      id: "a114",
      sortOrder: 560,
      category: "accessories",
      name: 'דוקרן מתכת לסידור פרחים 50 מ"מ',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "כולל דבק דו צדדי בתחתית",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/accessories/a114.jpg",
    },
    {
      id: "a115",
      sortOrder: 570,
      category: "accessories",
      name: 'דוקרן מתכת לסידור פרחים 60 מ"מ',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "כולל דבק דו צדדי בתחתית",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/accessories/a115.jpg",
    },
    {
      id: "a116",
      sortOrder: 580,
      category: "accessories",
      name: 'דוקרן מתכת לסידור פרחים 70 מ"מ',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "כולל דבק דו צדדי בתחתית",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/accessories/a116.jpg",
    },
    {
      id: "a117",
      sortOrder: 900,
      category: "accessories",
      name: 'רשת לול 30 ס"מ  3.00 מטר צבעים שונים',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/accessories/a117.jpg",
    },
    {
      id: "a118",
      sortOrder: 300,
      category: "accessories",
      name: "חוט ברזל עטוף בחבל",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "נא לציין צבע מבוקש",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/accessories/a118.jpg",
    },
    {
      id: "a119",
      sortOrder: 350,
      category: "accessories",
      name: 'סרט סאטן 4.0 ס"מ 50 יארד',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "נא לציין צבע מבוקש",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/accessories/a119.jpg",
    },
    {
      id: "a120",
      sortOrder: 1150,
      category: "accessories",
      name: "גליונות נייר צבעוני הולנדי(20 יח)",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "נא לציין צבע בצורה הכי ברורה שאפשר",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/accessories/a120.jpg",
    },
    {
      id: "a121",
      sortOrder: 1220,
      category: "accessories",
      name: "חבילת גליונות נייר עיתון לאריזה 50 יח'",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "לבן עיתון\\חום עיתון",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/accessories/a121.jpg",
    },
    {
      id: "a122",
      sortOrder: 1270,
      category: "accessories",
      name: "קופסאות לפרחים סטX 3 עגול",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "נא לציין צבע מבוקש ורוד בהיר חלק  או לבן",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/accessories/a122.jpg",
    },
    {
      id: "a123",
      sortOrder: 500,
      category: "accessories",
      name: "גליל יוטה / מחצלת 10 יארד",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/accessories/a123.jpg",
    },
    {
      id: "a124",
      sortOrder: 1180,
      category: "accessories",
      name: "גליל נייר LOVE\\מודפס לב/עיתון  חום/לבן",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "נא לציין סוג רצוי",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/accessories/a124.jpg",
    },
    {
      id: "a125",
      sortOrder: 1200,
      category: "accessories",
      name: "גליל רשת סיבים טבעי/צבעוני",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "נא לציין צבע מבוקש",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/accessories/a125.jpg",
    },
    {
      id: "a126",
      sortOrder: 870,
      category: "accessories",
      name: "קשת / זר לראש ורוד/לבן (10 יחידות)",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/accessories/a126.jpg",
    },
    {
      id: "a127",
      sortOrder: 650,
      category: "accessories",
      name: 'מבחנה + זרוע 30 ס"מ (100 יח)',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/accessories/a127.jpg",
    },
    {
      id: "a128",
      sortOrder: 260,
      category: "accessories",
      name: "סט קופסאות X 3 לבבות עם סרט",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/accessories/a128.jpg",
    },
    {
      id: "a129",
      sortOrder: 1130,
      category: "accessories",
      name: 'תחתית עגולה 56 ס"מ',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/accessories/a129.jpg",
    },
    {
      id: "a130",
      sortOrder: 1070,
      category: "accessories",
      name: 'תחתית עגולה 37 ס"מ',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/accessories/a130.jpg",
    },
    {
      id: "a131",
      sortOrder: 1110,
      category: "accessories",
      name: 'תחתית עגולה 47 ס"מ',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/accessories/a131.jpg",
    },
    {
      id: "a132",
      sortOrder: 1100,
      category: "accessories",
      name: 'תחתית עגולה 42 ס"מ',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/accessories/a132.jpg",
    },
    {
      id: "a133",
      sortOrder: 1080,
      category: "accessories",
      name: 'תחתית עגולה 39 ס"מ',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/accessories/a133.jpg",
    },
    {
      id: "a134",
      sortOrder: 1140,
      category: "accessories",
      name: 'תחתית עגולה 64 ס"מ',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/accessories/a134.jpg",
    },
    {
      id: "a135",
      sortOrder: 950,
      category: "accessories",
      name: 'תחתית עגולה  44 ס"מ',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/accessories/a135.jpg",
    },
    {
      id: "t1",
      sortOrder: 5970,
      category: "floralTools",
      name: "*מבצע 1+1 שקית בצלים פקעות אירוס כלנית נורית נץ חלב ועוד",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "נא לפרט כמות מכל סוג",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t1.jpg",
    },
    {
      id: "t2",
      sortOrder: 40,
      category: "floralTools",
      name: 'דשן ספרינג 500 סמ"ק',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t2.jpg",
    },
    {
      id: "t3",
      sortOrder: 5380,
      category: "floralTools",
      name: 'שק משחקון 20 ק"ג',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t3.jpg",
    },
    {
      id: "t4",
      sortOrder: 50,
      category: "floralTools",
      name: "טוף / פומיס 25 ליטר",
      minQuantity: 1,
      maxQuantity: 199,
      comment:
        "בהזמנה מעל 5 שקים תחוייב הובלה של 300 שקל אוטומטית בלי הודעה ללקוח",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t4.jpg",
    },
    {
      id: "t5",
      sortOrder: 4180,
      category: "floralTools",
      name: "ארטסטון עם מתלה hanger fiona d25 h12 90-0045",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t5.jpg",
    },
    {
      id: "t6",
      sortOrder: 320,
      category: "floralTools",
      name: 'טרקוטה עציץ 11 ס"מ',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t6.jpg",
    },
    {
      id: "t7",
      sortOrder: 1530,
      category: "floralTools",
      name: "קרמיקה גבוהה לסחלב ע.12(אפור בלבד)",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "אפור כהה בלבד",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t7.jpg",
    },
    {
      id: "t8",
      sortOrder: 1550,
      category: "floralTools",
      name: "קרמיקה חלקה ע.15",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "סגול ולבן",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t8.jpg",
    },
    {
      id: "t9",
      sortOrder: 5860,
      category: "floralTools",
      name: 'תחתית מלבנית לאדנית 60 ס"מ',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "לבן/ירוק כהה/חום",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t9.jpg",
    },
    {
      id: "t10",
      sortOrder: 5850,
      category: "floralTools",
      name: 'תחתית מלבנית לאדנית 40 ס"מ',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "לבן/ירוק כהה/חום",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t10.jpg",
    },
    {
      id: "t11",
      sortOrder: 5870,
      category: "floralTools",
      name: 'תחתית מלבנית לאדנית 90 ס"מ',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "ירוק כהה/חום/לבן",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t11.jpg",
    },
    {
      id: "t12",
      sortOrder: 90,
      category: "floralTools",
      name: "תערובת שתילה 10 ליטר",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t12.jpg",
    },
    {
      id: "t13",
      sortOrder: 100,
      category: "floralTools",
      name: "תערובת שתילה 30 ליטר",
      minQuantity: 1,
      maxQuantity: 199,
      comment:
        "בהזמנה מעל 5 שקים תחוייב הובלה של 300 שקל אוטומטית בלי הודעה ללקוח",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t13.jpg",
    },
    {
      id: "t14",
      sortOrder: 110,
      category: "floralTools",
      name: "תערובת שתילה 50 ליטר (בנטל 50 ליטר פרימיום רגיל )",
      minQuantity: 1,
      maxQuantity: 199,
      comment:
        "בהזמנה מעל 5 שקים תחוייב הובלה של 300 שקל אוטומטית בלי הודעה ללקוח",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t14.jpg",
    },
    {
      id: "t15",
      sortOrder: 80,
      category: "floralTools",
      name: "תערובת סחלבים 10 ליטר",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t15.jpg",
    },
    {
      id: "t16",
      sortOrder: 330,
      category: "floralTools",
      name: 'טרקוטה עציץ 13 ס"מ',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t16.jpg",
    },
    {
      id: "t17",
      sortOrder: 3760,
      category: "floralTools",
      name: "כלי עבודה כף שתילה",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t17.jpg",
    },
    {
      id: "t18",
      sortOrder: 400,
      category: "floralTools",
      name: 'טרקוטה עציץ 39 ס"מ',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t18.jpg",
    },
    {
      id: "t19",
      sortOrder: 5510,
      category: "floralTools",
      name: 'אדנית 40 ס"מ תביג',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "חום/לבן/ירוק כהה",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t19.jpg",
    },
    {
      id: "t20",
      sortOrder: 3690,
      category: "floralTools",
      name: 'סלסלת קוקוס תליה 40 ס"מ',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t20.jpg",
    },
    {
      id: "t21",
      sortOrder: 1600,
      category: "floralTools",
      name: "קרמיקה צילינדר חלקה ע.8",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "שחור/ורוד/חום בהיר/חום כהה/לבן/תכלת/כחול",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t21.jpg",
    },
    {
      id: "t22",
      sortOrder: 60,
      category: "floralTools",
      name: "שק הומוס 10ליטר (דשן תולעים אדומות)",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t22.jpg",
    },
    {
      id: "t23",
      sortOrder: 3640,
      category: "floralTools",
      name: "סלסלת טנא טבעי",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t23.jpg",
    },
    {
      id: "t24",
      sortOrder: 70,
      category: "floralTools",
      name: "תערובת סוקולנטים 10 ליטר",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t24.png",
    },
    {
      id: "t25",
      sortOrder: 820,
      category: "floralTools",
      name: "קרמיקה לונה 23 LUNA",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "לבן",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t25.jpg",
    },
    {
      id: "t26",
      sortOrder: 1720,
      category: "floralTools",
      name: "*מעמד מתקפל 3 עציצים ע-12 טרקוטה/לבן/שחור מבצע !!!*",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "שחור/לבן/חום",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t26.jpg",
    },
    {
      id: "t27",
      sortOrder: 1730,
      category: "floralTools",
      name: "*מעמד מתקפל 3 עציצים ע-15 טרקוטה/לבן/שחור מבצע !!!*",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "שחור/לבן/חום",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t27.jpg",
    },
    {
      id: "t28",
      sortOrder: 1710,
      category: "floralTools",
      name: "*מעמד 3 עציצים ע-15 טרקוטה/לבן/שחור מבצע !!!*",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "שחור/לבן/חום",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t28.jpg",
    },
    {
      id: "t29",
      sortOrder: 1700,
      category: "floralTools",
      name: "*מעמד 3 עציצים ע-12 טרקוטה/לבן/שחור מבצע !!!*",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "לבן/חום/שחור",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t29.jpg",
    },
    {
      id: "t30",
      sortOrder: 560,
      category: "floralTools",
      name: 'קערה טרקוטה סיציליה חלקה 36 ס"מ',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t30.jpg",
    },
    {
      id: "t31",
      sortOrder: 380,
      category: "floralTools",
      name: 'טרקוטה עציץ 31 ס"מ',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t31.jpg",
    },
    {
      id: "t32",
      sortOrder: 5310,
      category: "floralTools",
      name: "קש תחרה לבן",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t32.jpg",
    },
    {
      id: "t33",
      sortOrder: 5530,
      category: "floralTools",
      name: 'אדנית 90 ס"מ תביג',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "חום/לבן/ירוק כהה",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t33.jpg",
    },
    {
      id: "t34",
      sortOrder: 370,
      category: "floralTools",
      name: 'טרקוטה עציץ 21 ס"מ',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t34.jpg",
    },
    {
      id: "t35",
      sortOrder: 340,
      category: "floralTools",
      name: 'טרקוטה עציץ 15 ס"מ',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t35.jpg",
    },
    {
      id: "t36",
      sortOrder: 390,
      category: "floralTools",
      name: 'טרקוטה עציץ 35 ס"מ',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t36.jpg",
    },
    {
      id: "t37",
      sortOrder: 350,
      category: "floralTools",
      name: 'טרקוטה עציץ 17 ס"מ',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t37.jpg",
    },
    {
      id: "t38",
      sortOrder: 1400,
      category: "floralTools",
      name: 'תחתית טרקוטה 9 ס"מ',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t38.jpg",
    },
    {
      id: "t39",
      sortOrder: 1390,
      category: "floralTools",
      name: 'תחתית טרקוטה 7 ס"מ',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t39.jpg",
    },
    {
      id: "t40",
      sortOrder: 1290,
      category: "floralTools",
      name: 'תחתית טרקוטה 13 ס"מ',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t40.jpg",
    },
    {
      id: "t41",
      sortOrder: 1300,
      category: "floralTools",
      name: 'תחתית טרקוטה 15 ס"מ',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t41.jpg",
    },
    {
      id: "t42",
      sortOrder: 1310,
      category: "floralTools",
      name: 'תחתית טרקוטה 17 ס"מ',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t42.jpg",
    },
    {
      id: "t43",
      sortOrder: 5520,
      category: "floralTools",
      name: 'אדנית 60 ס"מ תביג',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "ירוק/חום/לבן",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t43.jpg",
    },
    {
      id: "t44",
      sortOrder: 410,
      category: "floralTools",
      name: 'טרקוטה עציץ 7 ס"מ',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t44.jpg",
    },
    {
      id: "t45",
      sortOrder: 1320,
      category: "floralTools",
      name: 'תחתית טרקוטה 19 ס"מ',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t45.jpg",
    },
    {
      id: "t46",
      sortOrder: 1330,
      category: "floralTools",
      name: 'תחתית טרקוטה 21 ס"מ',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t46.jpg",
    },
    {
      id: "t47",
      sortOrder: 1340,
      category: "floralTools",
      name: 'תחתית טרקוטה 25 ס"מ',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t47.jpg",
    },
    {
      id: "t48",
      sortOrder: 1350,
      category: "floralTools",
      name: 'תחתית טרקוטה 27 ס"מ',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t48.jpg",
    },
    {
      id: "t49",
      sortOrder: 290,
      category: "floralTools",
      name: 'טרקוטה מוקה עציץ 11 ס"מ',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t49.jpg",
    },
    {
      id: "t50",
      sortOrder: 30,
      category: "floralTools",
      name: 'דשן נוזלי לסחלבים 250 מ"ל',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t50.jpg",
    },
    {
      id: "t51",
      sortOrder: 20,
      category: "floralTools",
      name: "אקוגן דשן ביו צמחי בית 1 ליטר",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t51.jpg",
    },
    {
      id: "t52",
      sortOrder: 550,
      category: "floralTools",
      name: 'קערה טרקוטה סיציליה חלקה 26 ס"מ',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t52.jpg",
    },
    {
      id: "t53",
      sortOrder: 530,
      category: "floralTools",
      name: 'קערה טרקוטה בלוטלי פסים 19 ס"מ',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t53.jpg",
    },
    {
      id: "t54",
      sortOrder: 540,
      category: "floralTools",
      name: 'קערה טרקוטה בלוטלי פסים 23 ס"מ',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t54.jpg",
    },
    {
      id: "t55",
      sortOrder: 360,
      category: "floralTools",
      name: 'טרקוטה עציץ 19 ס"מ',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t55.jpg",
    },
    {
      id: "t56",
      sortOrder: 1380,
      category: "floralTools",
      name: 'תחתית טרקוטה 41 ס"מ',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t56.jpg",
    },
    {
      id: "t57",
      sortOrder: 5350,
      category: "floralTools",
      name: "שק חלוקי נחל 20 קילו",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "לבן מידה 2 שחור מידה 3",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t57.jpg",
    },
    {
      id: "t58",
      sortOrder: 1360,
      category: "floralTools",
      name: 'תחתית טרקוטה 29 ס"מ',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t58.jpg",
    },
    {
      id: "t59",
      sortOrder: 1370,
      category: "floralTools",
      name: 'תחתית טרקוטה 31 ס"מ',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t59.jpg",
    },
    {
      id: "t60",
      sortOrder: 5400,
      category: "floralTools",
      name: 'תחתית מתכת גלגלים קוטר 25 ס"מ 2163-11',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t60.jpg",
    },
    {
      id: "t61",
      sortOrder: 10,
      category: "floralTools",
      name: "אקוגן דשן ביו גינה ומרפסת 1 ליטר",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t61.jpg",
    },
    {
      id: "t62",
      sortOrder: 1690,
      category: "floralTools",
      name: '*מבצע* קרמיקה גליקוס גביע 25 ס"מ.',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t62.jpg",
    },
    {
      id: "t63",
      sortOrder: 3670,
      category: "floralTools",
      name: 'סלסלת קוקוס תליה 30 ס"מ',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t63.jpg",
    },
    {
      id: "t64",
      sortOrder: 3680,
      category: "floralTools",
      name: 'סלסלת קוקוס תליה 35 ס"מ',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t64.jpg",
    },
    {
      id: "t65",
      sortOrder: 4950,
      category: "floralTools",
      name: "מתלה ברזל לאדנית (מחיר לזוג)2163-61",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t65.jpg",
    },
    {
      id: "t66",
      sortOrder: 4540,
      category: "floralTools",
      name: "חלוקי נחל קטנים (36 שקית) 18 קילו לפי צבע",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "לבן/שחור/צבעוני",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t66.jpg",
    },
    {
      id: "t67",
      sortOrder: 3310,
      category: "floralTools",
      name: 'קערה זכוכית צילינדר 25 ס"מ 704025',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t67.jpg",
    },
    {
      id: "t68",
      sortOrder: 2380,
      category: "floralTools",
      name: "אגרטל צילינדר מבחנה 520 (קוד קרטון R802)",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t68.jpg",
    },
    {
      id: "t69",
      sortOrder: 3510,
      category: "floralTools",
      name: "סל סיגראס ע.10 174820 11*11",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t69.jpg",
    },
    {
      id: "t70",
      sortOrder: 3290,
      category: "floralTools",
      name: 'קוביה זכוכית 6 ס"מ 5555',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t70.jpg",
    },
    {
      id: "t71",
      sortOrder: 3270,
      category: "floralTools",
      name: 'קוביה זכוכית 12 ס"מ שקוף 7021012',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t71.jpg",
    },
    {
      id: "t72",
      sortOrder: 5370,
      category: "floralTools",
      name: "שק יוטה לעציץ גודל 18 /קערה 20 188-53",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t72.jpg",
    },
    {
      id: "t73",
      sortOrder: 5240,
      category: "floralTools",
      name: 'קערה צילינדר 15 ס"מ 704016',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t73.jpg",
    },
    {
      id: "t74",
      sortOrder: 3260,
      category: "floralTools",
      name: 'קוביה זכוכית 10 ס"מ שקוף 9595 7021010',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t74.jpg",
    },
    {
      id: "t75",
      sortOrder: 4280,
      category: "floralTools",
      name: "בקבוק דלעת כתום מט / קרם ARIEL D7X12H",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t75.jpg",
    },
    {
      id: "t76",
      sortOrder: 4300,
      category: "floralTools",
      name: "בקבוק דלעת כתום מט / קרם ARIEL D9XH9.5",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t76.jpg",
    },
    {
      id: "t77",
      sortOrder: 4290,
      category: "floralTools",
      name: "בקבוק דלעת כתום מט / קרם ARIEL D8X7H",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t77.jpg",
    },
    {
      id: "t78",
      sortOrder: 3180,
      category: "floralTools",
      name: "מרקו פולו זכוכית שולחני 41264 H22D13",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t78.jpg",
    },
    {
      id: "t79",
      sortOrder: 5890,
      category: "floralTools",
      name: "תיק יוטה ע.12",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "(טבעי / שמנת)",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t79.jpg",
    },
    {
      id: "t80",
      sortOrder: 870,
      category: "floralTools",
      name: "קרמיקה מלבן גבוה קקטוס לבן בלבד H25W8L25 ST-14",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t80.jpg",
    },
    {
      id: "t81",
      sortOrder: 2860,
      category: "floralTools",
      name: "זכוכית אובאלית שקופה RC10-30-12",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t81.jpg",
    },
    {
      id: "t82",
      sortOrder: 5920,
      category: "floralTools",
      name: ". מבצע שק יוטה לעציץ גודל 10.",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "טבעי ותכלת",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t82.jpg",
    },
    {
      id: "t83",
      sortOrder: 5960,
      category: "floralTools",
      name: '*מבצע* בקבוק קארו נקודות 12 19 ס"מ 1+1',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "מבצע 1+1",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t83.jpg",
    },
    {
      id: "t84",
      sortOrder: 5490,
      category: "floralTools",
      name: '*בקבוק קארו 6 27.7 ס"מ ללא חום!! ( במלאי ירוק בהיר, ירוק כהה)*',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "ירוק בהיר/ירוק כהה",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t84.jpg",
    },
    {
      id: "t85",
      sortOrder: 4420,
      category: "floralTools",
      name: 'בקבוק קארו 5 D2D7H20.5 ס"מ CARO 5 42905 VERA',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "חום בלבד",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t85.jpg",
    },
    {
      id: "t86",
      sortOrder: 5950,
      category: "floralTools",
      name: '*מבצע* בקבוק קארו 13 בלון משבצות 15 ס"מ 1+1',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "מבצע 1+1",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t86.jpg",
    },
    {
      id: "t87",
      sortOrder: 490,
      category: "floralTools",
      name: 'סט 2 קערות 17/12 ס"מ קרמיקה חלקה / פסים מעוגלת 2311/2312',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "שחור/חום בהיר/חום כהה//ירוק בהיר/ירוק כהה",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t87.jpg",
    },
    {
      id: "t88",
      sortOrder: 2230,
      category: "floralTools",
      name: "אגרטל צילינדר 1220 (TC1220)",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t88.jpg",
    },
    {
      id: "t89",
      sortOrder: 3520,
      category: "floralTools",
      name: "סל סיגראס ע.12 2181-2S 174821 13*14",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t89.jpg",
    },
    {
      id: "t90",
      sortOrder: 1890,
      category: "floralTools",
      name: "אגרטל ארובה 2030",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t90.jpg",
    },
    {
      id: "t91",
      sortOrder: 120,
      category: "floralTools",
      name: "אגרטל כדור קרמיקה ספארי חלק D3/11.7X11.7 חום/כתום/כחול.",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "חום/כתום/כחול",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t91.jpg",
    },
    {
      id: "t92",
      sortOrder: 130,
      category: "floralTools",
      name: "אגרטל כדור קרמיקה ספארי פסים D3/11.7X11.7 כחול/חום/כתום.",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "כתום/חום/כחול",
      needsCommentAnswer: true,
      userCommentAnswer: "",

      imageURL: "/products/floralTools/t92.jpg",
    },
    {
      id: "t93",
      sortOrder: 250,
      category: "floralTools",
      name: 'טרקוטה אורה קרם 36 ס"מ ORA',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t93.jpg",
    },
    {
      id: "t94",
      sortOrder: 740,
      category: "floralTools",
      name: 'קרמיקה הרבין 10 ס"מ HARBIN',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t94.jpg",
    },
    {
      id: "t95",
      sortOrder: 750,
      category: "floralTools",
      name: 'קרמיקה הרבין 12 ס"מ HARBIN',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t95.jpg",
    },
    {
      id: "t96",
      sortOrder: 2370,
      category: "floralTools",
      name: "אגרטל צילינדר מבחנה 515 (קוד קרטון R602)",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t96.jpg",
    },
    {
      id: "t97",
      sortOrder: 2160,
      category: "floralTools",
      name: "אגרטל צילינדר 0815 (קוד קרטון R15-8)",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "מוצר אמצעי",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t97.jpg",
    },
    {
      id: "t98",
      sortOrder: 2700,
      category: "floralTools",
      name: 'ואזה לפרח בודד 24 ס"מ 2270-4 - רק לבן PILO24',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "לבן בלבד",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t98.jpg",
    },
    {
      id: "t99",
      sortOrder: 2350,
      category: "floralTools",
      name: "אגרטל צילינדר 2040",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t99.jpg",
    },
    {
      id: "t100",
      sortOrder: 2500,
      category: "floralTools",
      name: 'בקבוק זכוכית מרובע תכלת חבל 120002 28 ס"מ',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t100.jpg",
    },
    {
      id: "t101",
      sortOrder: 2260,
      category: "floralTools",
      name: "אגרטל צילינדר 1520",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t101.jpg",
    },
    {
      id: "t102",
      sortOrder: 1930,
      category: "floralTools",
      name: 'אגרטל ברנדה מגורען 20 ס"מ 19585 16813',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "בצבע חול בלבד",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t102.jpg",
    },
    {
      id: "t103",
      sortOrder: 4520,
      category: "floralTools",
      name: "הוריקן מגן לנר בלבד- D7H35",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t103.jpg",
    },
    {
      id: "t104",
      sortOrder: 5280,
      category: "floralTools",
      name: "קרטון 300 יח' יוטה טבעי ע.12",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "צבע טבעי בלבד",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t104.jpg",
    },
    {
      id: "t105",
      sortOrder: 2180,
      category: "floralTools",
      name: "אגרטל צילינדר 1020",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "מוצר ימין אחורי",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t105.jpg",
    },
    {
      id: "t106",
      sortOrder: 4010,
      category: "floralTools",
      name: "אדנית מסעדה פלסטיק L96H47W29(אספקה עד 72 שעות)",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t106.jpg",
    },
    {
      id: "t107",
      sortOrder: 4000,
      category: "floralTools",
      name: "אדנית מסעדה פלסטיק L76H38W22 (אספקה עד 72 שעות)",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t107.jpg",
    },
    {
      id: "t108",
      sortOrder: 5320,
      category: "floralTools",
      name: 'שישיית מבחנות מטאלי סמוק (גובה 23 ס"מ)',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t108.jpg",
    },
    {
      id: "t109",
      sortOrder: 5330,
      category: "floralTools",
      name: 'שישיית מבחנות שקוף (גובה 23 ס"מ)',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t109.jpg",
    },
    {
      id: "t110",
      sortOrder: 3320,
      category: "floralTools",
      name: 'קערה זכוכית צילינדר 704019 20 ס"מ',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t110.jpg",
    },
    {
      id: "t111",
      sortOrder: 3100,
      category: "floralTools",
      name: "זכוכית עגולה שקופה עבה 12 7085",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t111.jpg",
    },
    {
      id: "t112",
      sortOrder: 5830,
      category: "floralTools",
      name: "שק יוטה ע.12 שחור/לבן",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t112.jpg",
    },
    {
      id: "t113",
      sortOrder: 4430,
      category: "floralTools",
      name: 'בקבוק קארו 6 H26D9 ס"מ 42906',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t113.jpg",
    },
    {
      id: "t114",
      sortOrder: 2270,
      category: "floralTools",
      name: "אגרטל צילינדר 1525",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t114.jpg",
    },
    {
      id: "t115",
      sortOrder: 2170,
      category: "floralTools",
      name: "אגרטל צילינדר 0825",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t115.jpg",
    },
    {
      id: "t116",
      sortOrder: 1640,
      category: "floralTools",
      name: "קרמיקה קליפסו 14 (שחור בלבד !!!!)",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "ירוק ושחור בלבד",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t116.jpg",
    },
    {
      id: "t117",
      sortOrder: 1490,
      category: "floralTools",
      name: 'קערה קרמיקה חלקה 29 ס"מ 24015',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "חום/תכלת/ירוק",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t117.jpg",
    },
    {
      id: "t118",
      sortOrder: 2480,
      category: "floralTools",
      name: 'בקבוק זכוכית בינוני 27 ס"מ חום R-34 1527',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t118.jpg",
    },
    {
      id: "t119",
      sortOrder: 5840,
      category: "floralTools",
      name: 'שקית חלוקי נחל אבנים 0.5 ק"ג',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "לבן/שחור/צבעוני",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t119.jpg",
    },
    {
      id: "t120",
      sortOrder: 1940,
      category: "floralTools",
      name: "אגרטל ברנדה D13H20 כד חלב",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t120.jpg",
    },
    {
      id: "t121",
      sortOrder: 4410,
      category: "floralTools",
      name: "בקבוק קארו 15 D2WW5H16 42900 VERA",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "חום/סגול",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t121.jpg",
    },
    {
      id: "t122",
      sortOrder: 3540,
      category: "floralTools",
      name: "סל סיגראס ע.18 2181-2L",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t122.jpg",
    },
    {
      id: "t123",
      sortOrder: 3650,
      category: "floralTools",
      name: "סלסלת ליצ'י 23-12 טבעי",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t123.jpg",
    },
    {
      id: "t124",
      sortOrder: 3660,
      category: "floralTools",
      name: "סלסלת ליצ'י 33-12 טבעי",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t124.jpg",
    },
    {
      id: "t125",
      sortOrder: 3550,
      category: "floralTools",
      name: "סל סיגראס ע.24 2181-2XL",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t125.jpg",
    },
    {
      id: "t126",
      sortOrder: 4850,
      category: "floralTools",
      name: 'כלי בטון מרובע לעציץ 12 ס"מ',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t126.jpg",
    },
    {
      id: "t127",
      sortOrder: 430,
      category: "floralTools",
      name: "כד קרמי 2 ידיות אפור/חום טרקוטה H20D7 42922",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t127.jpg",
    },
    {
      id: "t128",
      sortOrder: 440,
      category: "floralTools",
      name: "כד קרמי 2 ידיות אפור/חום טרקוטה H23D7 42923",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t128.jpg",
    },
    {
      id: "t129",
      sortOrder: 5340,
      category: "floralTools",
      name: "שלישיית מבחנות אלכסוניות גדולות",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t129.jpg",
    },
    {
      id: "t130",
      sortOrder: 5210,
      category: "floralTools",
      name: "קוביה מראה 202020",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t130.jpg",
    },
    {
      id: "t131",
      sortOrder: 4020,
      category: "floralTools",
      name: "אדנית מראה 101040",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t131.jpg",
    },
    {
      id: "t132",
      sortOrder: 4030,
      category: "floralTools",
      name: "אדנית מראה 101060",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t132.jpg",
    },
    {
      id: "t133",
      sortOrder: 1080,
      category: "floralTools",
      name: 'קרמיקה קערה פסים 20 ס"מ 8089',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "לבן+כחול/אפור בהיר/שחור/צהוב/לבן נקודות",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t133.jpg",
    },
    {
      id: "t134",
      sortOrder: 2400,
      category: "floralTools",
      name: "אגרטל קוני פסים BELLY 28-10",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t134.jpg",
    },
    {
      id: "t135",
      sortOrder: 4350,
      category: "floralTools",
      name: "בקבוק לבן בסיס מרובע פתח עגול 42907 H16D3",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t135.jpg",
    },
    {
      id: "t136",
      sortOrder: 2950,
      category: "floralTools",
      name: 'זכוכית ביצה 15 ס"מ 15-10 RE שקוף !!!!',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t136.jpg",
    },
    {
      id: "t137",
      sortOrder: 2960,
      category: "floralTools",
      name: 'זכוכית ביצה 20 ס"מ 20-12 RE',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t137.jpg",
    },
    {
      id: "t138",
      sortOrder: 2970,
      category: "floralTools",
      name: 'זכוכית ביצה 25 ס"מ 25-14 RE 2301-16 שקוף בלבד !!!',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t138.jpg",
    },
    {
      id: "t139",
      sortOrder: 3190,
      category: "floralTools",
      name: "מרקו פולו זכוכית שולחני HP-150-13 H15XD8 2574",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t139.jpg",
    },
    {
      id: "t140",
      sortOrder: 1850,
      category: "floralTools",
      name: 'אגרטל אקווריום אקווה 30 ס"מ',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t140.jpg",
    },
    {
      id: "t141",
      sortOrder: 3280,
      category: "floralTools",
      name: 'קוביה זכוכית 15 ס"מ',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t141.jpg",
    },
    {
      id: "t142",
      sortOrder: 5260,
      category: "floralTools",
      name: 'קערת עץ 28 ס"מ 421770 (חום כהה בלבד)',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "מוצר שמאלי",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t142.jpg",
    },
    {
      id: "t143",
      sortOrder: 5090,
      category: "floralTools",
      name: 'עציץ פלסטיק תליה "בומבטו" 25 ס"מ',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t143.jpg",
    },
    {
      id: "t144",
      sortOrder: 2520,
      category: "floralTools",
      name: 'בקבוק זכוכית פסים 7523 / 0715 14 ס"מ LK-105 42901',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t144.jpg",
    },
    {
      id: "t145",
      sortOrder: 3350,
      category: "floralTools",
      name: "*מבצע! ואזה אימרה זכוכית חומה D16.5H29*",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t145.jpg",
    },
    {
      id: "t146",
      sortOrder: 3360,
      category: "floralTools",
      name: "*מבצע! ואזה אימרה זכוכית חומה D17.5H21 45824*",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t146.jpg",
    },
    {
      id: "t147",
      sortOrder: 1060,
      category: "floralTools",
      name: 'קרמיקה קסיאן 10 ס"מ XIAN',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t147.jpg",
    },
    {
      id: "t148",
      sortOrder: 1070,
      category: "floralTools",
      name: 'קרמיקה קסיאן 17 ס"מ XIAN',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t148.jpg",
    },
    {
      id: "t149",
      sortOrder: 2550,
      category: "floralTools",
      name: "בקבוק זכוכית תלייה תכלת 10X4.5X14.5H דגם 2",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t149.jpg",
    },
    {
      id: "t150",
      sortOrder: 2540,
      category: "floralTools",
      name: "בקבוק זכוכית תלייה שקוף D4X7X20.5 דגם 1",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t150.jpg",
    },
    {
      id: "t151",
      sortOrder: 3230,
      category: "floralTools",
      name: "פמוט זכוכית פשוט (בסיס לנר אצבע)",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t151.jpg",
    },
    {
      id: "t152",
      sortOrder: 1480,
      category: "floralTools",
      name: "אגרטל כדור קרמיקה ספארי חברבורות D3/11.7X11.7.",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "חום/כתום/כחול",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t152.jpg",
    },
    {
      id: "t153",
      sortOrder: 1790,
      category: "floralTools",
      name: "אגרטל אפור חלבי 22X11 41120",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "מוצר שמאלי",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t153.jpg",
    },
    {
      id: "t154",
      sortOrder: 1800,
      category: "floralTools",
      name: "אגרטל אפור חלבי 28X11 41128 41126",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "מוצר ימני",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t154.jpg",
    },
    {
      id: "t155",
      sortOrder: 2580,
      category: "floralTools",
      name: 'ואזה 2 מבחנות 22 ס"מ',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "מוצר ימני",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t155.jpg",
    },
    {
      id: "t156",
      sortOrder: 2590,
      category: "floralTools",
      name: 'ואזה 2 מבחנות 32 ס"מ',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "מוצר שמאלי",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t156.jpg",
    },
    {
      id: "t157",
      sortOrder: 2190,
      category: "floralTools",
      name: "אגרטל צילינדר 1030",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t157.jpg",
    },
    {
      id: "t158",
      sortOrder: 3980,
      category: "floralTools",
      name: "אדנית טרה אובאלית  C-TERRA OVAL",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t158.jpg",
    },
    {
      id: "t159",
      sortOrder: 3990,
      category: "floralTools",
      name: "אדנית טרה מלבנית  C-TERRA REC 10-25",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t159.jpg",
    },
    {
      id: "t160",
      sortOrder: 2510,
      category: "floralTools",
      name: 'בקבוק זכוכית עגול תכלת חבל 120001 28 ס"מ',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t160.jpg",
    },
    {
      id: "t161",
      sortOrder: 4400,
      category: "floralTools",
      name: "בקבוק פסים כרמן CARMEN (כחול בלבד!) D4/10.5XH8.5",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t161.jpg",
    },
    {
      id: "t162",
      sortOrder: 1820,
      category: "floralTools",
      name: 'אגרטל אקווריום אקווה 15 ס"מ',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t162.jpg",
    },
    {
      id: "t163",
      sortOrder: 2200,
      category: "floralTools",
      name: "אגרטל צילינדר 1040",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t163.jpg",
    },
    {
      id: "t164",
      sortOrder: 4510,
      category: "floralTools",
      name: "הוריקן מגן לנר בלבד-  D7H30",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t164.jpg",
    },
    {
      id: "t165",
      sortOrder: 4710,
      category: "floralTools",
      name: "כד עתיק קטן 42339 D20H48",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t165.jpg",
    },
    {
      id: "t166",
      sortOrder: 1830,
      category: "floralTools",
      name: 'אגרטל אקווריום אקווה 20 ס"מ',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t166.jpg",
    },
    {
      id: "t167",
      sortOrder: 4690,
      category: "floralTools",
      name: "כד עתיק בינוני 42338 D23H55",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t167.jpg",
    },
    {
      id: "t168",
      sortOrder: 4700,
      category: "floralTools",
      name: "כד עתיק גדול 42337 D27H62",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t168.jpg",
    },
    {
      id: "t169",
      sortOrder: 3200,
      category: "floralTools",
      name: "מרקו פולו זכוכית שולחני2571 H26X12 41262",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t169.jpg",
    },
    {
      id: "t170",
      sortOrder: 1000,
      category: "floralTools",
      name: "קרמיקה צילינדר 205664 H45XD35",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "ורוד/תכלת/כחול בהיר/כחול כהה/שחור/ירוק זוהר/קרם/אפור/חום",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t170.jpg",
    },
    {
      id: "t171",
      sortOrder: 1030,
      category: "floralTools",
      name: "קרמיקה צילינדר H35XD27 205664",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "ורוד/תכלת/כחול בהיר/כחול כהה/שחור/ירוק זוהר/קרם/אפור/חום",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t171.jpg",
    },
    {
      id: "t172",
      sortOrder: 1630,
      category: "floralTools",
      name: 'קרמיקה קוביה פסים / חלק 7.5 ס"מ 118833 201775 19009',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "לבן/ירוק בהיר/אפור/חום בהיר",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t172.jpg",
    },
    {
      id: "t173",
      sortOrder: 2250,
      category: "floralTools",
      name: "אגרטל צילינדר 1230",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t173.jpg",
    },
    {
      id: "t174",
      sortOrder: 4770,
      category: "floralTools",
      name: 'כוס חברון 7 ס"מ',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t174.jpg",
    },
    {
      id: "t175",
      sortOrder: 4580,
      category: "floralTools",
      name: "חרס חברון אגס בינוני D28H31",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t175.jpg",
    },
    {
      id: "t176",
      sortOrder: 4600,
      category: "floralTools",
      name: "חרס חברון פסים גדול(מתאים לע.24)",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t176.jpg",
    },
    {
      id: "t177",
      sortOrder: 4990,
      category: "floralTools",
      name: "סט ארגז עץ חום טבעי 4 יחידות 42180",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t177.jpg",
    },
    {
      id: "t178",
      sortOrder: 190,
      category: "floralTools",
      name: "אדנית קרמיקה קאנו ST-28 H16L35",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "שחור בלבד-ללא לבן!",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t178.jpg",
    },
    {
      id: "t179",
      sortOrder: 1090,
      category: "floralTools",
      name: 'קרמיקה קערה פסים 28 ס"מ 8089',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "לבן+כחול/אפור בהיר/שחור/צהוב/לבן נקודות",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t179.jpg",
    },
    {
      id: "t180",
      sortOrder: 2310,
      category: "floralTools",
      name: "אגרטל צילינדר 1668",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t180.jpg",
    },
    {
      id: "t181",
      sortOrder: 4940,
      category: "floralTools",
      name: "מרסס/ מתז פלסטיק 1 ליטר N1",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t181.jpg",
    },
    {
      id: "t182",
      sortOrder: 4720,
      category: "floralTools",
      name: "כד קרמי שמנת ידית אחתH20.5D4W15 41993 ST-01",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t182.jpg",
    },
    {
      id: "t183",
      sortOrder: 450,
      category: "floralTools",
      name: "כדור קרמיקה 153-118",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t183.jpg",
    },
    {
      id: "t184",
      sortOrder: 4110,
      category: "floralTools",
      name: "אדנית קש בננה ידיות מתכת 47X18X17 2500-5 L.",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t184.jpg",
    },
    {
      id: "t185",
      sortOrder: 4160,
      category: "floralTools",
      name: "אדנית קש S בננה ידיות מתכת 42X16X15 2500-5 S.",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t185.jpg",
    },
    {
      id: "t186",
      sortOrder: 960,
      category: "floralTools",
      name: 'קרמיקה עין הוד כדור לפרח בודד SN-02 12 ס"מ',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t186.jpg",
    },
    {
      id: "t187",
      sortOrder: 940,
      category: "floralTools",
      name: "קרמיקה עין הוד אדנית אובאלית 8-25-13 MOR (לבן/ירוק)",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "לבן/ירוק/טורקיז",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t187.jpg",
    },
    {
      id: "t188",
      sortOrder: 920,
      category: "floralTools",
      name: "קרמיקה עין הוד אגרטל 22-15 AVIV",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "מוצר ימני,לבן,אפור,ירוק",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t188.jpg",
    },
    {
      id: "t189",
      sortOrder: 930,
      category: "floralTools",
      name: "קרמיקה עין הוד אגרטל 27-18 AVIV",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "מוצר שמאלי אפור/לבן/ירוק",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t189.jpg",
    },
    {
      id: "t190",
      sortOrder: 970,
      category: "floralTools",
      name: "קרמיקה עין הוד קערה 12-27 MOR",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "לבן",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t190.jpg",
    },
    {
      id: "t191",
      sortOrder: 950,
      category: "floralTools",
      name: "קרמיקה עין הוד אדנית גבוהה 21-11-19 MOR",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "לבן/טורקיז/אפור/ירוק",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t191.jpg",
    },
    {
      id: "t192",
      sortOrder: 3530,
      category: "floralTools",
      name: "סל סיגראס ע.15 2181-2M 16*17 174822",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "אפור/לבן",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t192.jpg",
    },
    {
      id: "t193",
      sortOrder: 810,
      category: "floralTools",
      name: 'קרמיקה לונה 20 ס"מ',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "גרניט / אפור בהיר/ כהה",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t193.jpg",
    },
    {
      id: "t194",
      sortOrder: 2210,
      category: "floralTools",
      name: "אגרטל צילינדר 1212",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t194.jpg",
    },
    {
      id: "t195",
      sortOrder: 1880,
      category: "floralTools",
      name: "אגרטל ארובה 1530",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t195.jpg",
    },
    {
      id: "t196",
      sortOrder: 1840,
      category: "floralTools",
      name: 'אגרטל אקווריום אקווה 25 ס"מ',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t196.jpg",
    },
    {
      id: "t197",
      sortOrder: 3730,
      category: "floralTools",
      name: "סל ראטן פולימרי קטן WAT25033B S/3-S D24H54",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t197.jpg",
    },
    {
      id: "t198",
      sortOrder: 3620,
      category: "floralTools",
      name: "סל ראטן פולימרי בינוני D28H56 WAT25033B S/3-M",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t198.jpg",
    },
    {
      id: "t199",
      sortOrder: 3720,
      category: "floralTools",
      name: "סל ראטן פולימרי גדול D34H59 WAT25033B S/3-L",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t199.jpg",
    },
    {
      id: "t200",
      sortOrder: 3750,
      category: "floralTools",
      name: "סלסלת תלייה ראטן פולימרי WAT23184M D26H14",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "אפור בלבד",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t200.jpg",
    },
    {
      id: "t201",
      sortOrder: 5580,
      category: "floralTools",
      name: "אדנית ראטן פולימרי קטנה עם ידיות 38X9X11H 25035-S",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t201.jpg",
    },
    {
      id: "t202",
      sortOrder: 5560,
      category: "floralTools",
      name: "אדנית ראטן פולימרי בינונית עם ידיות 47X13X15H 25035-S",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t202.jpg",
    },
    {
      id: "t203",
      sortOrder: 5570,
      category: "floralTools",
      name: "אדנית ראטן פולימרי גדולה עם ידיות 60X16X16H 25035-S",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t203.jpg",
    },
    {
      id: "t204",
      sortOrder: 3970,
      category: "floralTools",
      name: 'אדנית בטון אובאלית חלקה 28 ס"מ NATURAL נטורל',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t204.jpg",
    },
    {
      id: "t205",
      sortOrder: 690,
      category: "floralTools",
      name: "קרמיקה אלורה ירוק יער ELOURA D16/19/H5.5",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t205.jpg",
    },
    {
      id: "t206",
      sortOrder: 4450,
      category: "floralTools",
      name: 'בקבוק רטרו עם תחתית נשלפת 28 ס"מ',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t206.jpg",
    },
    {
      id: "t207",
      sortOrder: 1810,
      category: "floralTools",
      name: 'אגרטל אקווריום אקווה 10 ס"מ',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t207.jpg",
    },
    {
      id: "t208",
      sortOrder: 300,
      category: "floralTools",
      name: 'טרקוטה מוקה עציץ 13 ס"מ',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t208.jpg",
    },
    {
      id: "t209",
      sortOrder: 310,
      category: "floralTools",
      name: 'טרקוטה מוקה עציץ 17 ס"מ',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t209.jpg",
    },
    {
      id: "t210",
      sortOrder: 1460,
      category: "floralTools",
      name: 'תחתית טרקוטה מוקה 9 ס"מ',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t210.jpg",
    },
    {
      id: "t211",
      sortOrder: 1410,
      category: "floralTools",
      name: 'תחתית טרקוטה מוקה 11 ס"מ',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t211.jpg",
    },
    {
      id: "t212",
      sortOrder: 1420,
      category: "floralTools",
      name: 'תחתית טרקוטה מוקה 13 ס"מ',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "מוצר שמאלי",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t212.jpg",
    },
    {
      id: "t213",
      sortOrder: 1430,
      category: "floralTools",
      name: 'תחתית טרקוטה מוקה 15 ס"מ',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "מוצר ימני",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t213.jpg",
    },
    {
      id: "t214",
      sortOrder: 1440,
      category: "floralTools",
      name: 'תחתית טרקוטה מוקה 19 ס"מ',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t214.jpg",
    },
    {
      id: "t215",
      sortOrder: 1450,
      category: "floralTools",
      name: 'תחתית טרקוטה מוקה 41 ס"מ',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t215.jpg",
    },
    {
      id: "t216",
      sortOrder: 570,
      category: "floralTools",
      name: 'קערה טרקוטה קרם 16.1 ס"מ KUL',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t216.jpg",
    },
    {
      id: "t217",
      sortOrder: 580,
      category: "floralTools",
      name: 'קערה טרקוטה קרם 20.5 ס"מ KUL',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t217.jpg",
    },
    {
      id: "t218",
      sortOrder: 590,
      category: "floralTools",
      name: 'קערה טרקוטה קרם 22.7 ס"מ KUL',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t218.jpg",
    },
    {
      id: "t219",
      sortOrder: 830,
      category: "floralTools",
      name: "קרמיקה לונה 8(לבן ואפור בלבד)",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "לבן/אפור",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t219.jpg",
    },
    {
      id: "t220",
      sortOrder: 2850,
      category: "floralTools",
      name: "זכוכית אובאלית שקופה RC10-20-12",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t220.jpg",
    },
    {
      id: "t221",
      sortOrder: 5470,
      category: "floralTools",
      name: "Bottle Jinan d6.2/11.7xh23.5 בקבוק ג'ינן",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t221.jpg",
    },
    {
      id: "t222",
      sortOrder: 5460,
      category: "floralTools",
      name: "Bottle Hefei d5.3/12xh19.6  בקבוק חפי.",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t222.jpg",
    },
    {
      id: "t223",
      sortOrder: 5480,
      category: "floralTools",
      name: "Vase Norell d5.7/11.8xh16  בקבוק נורל.",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "כלי ימני",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t223.jpg",
    },
    {
      id: "t224",
      sortOrder: 3340,
      category: "floralTools",
      name: "Vase Norell d7.3/15xh21 ואזה נורל",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "כלי שמאלי",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t224.jpg",
    },
    {
      id: "t225",
      sortOrder: 1540,
      category: "floralTools",
      name: "קרמיקה וולורה Vase Velora d13/20.5xh20.",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "חום",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t225.jpg",
    },
    {
      id: "t226",
      sortOrder: 1470,
      category: "floralTools",
      name: "Vase Celesta d13.5/25xh40  קרמיקה סלסטה",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t226.jpg",
    },
    {
      id: "t227",
      sortOrder: 1680,
      category: "floralTools",
      name: "Vase Velora d17/27xh26קרמיקה  וולורה.",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "בהיר/כהה",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t227.jpg",
    },
    {
      id: "t228",
      sortOrder: 5630,
      category: "floralTools",
      name: "בקבוק וויורה Bottle Vivara d7.3/16xh24",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "חום בלבד",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t228.jpg",
    },
    {
      id: "t229",
      sortOrder: 5900,
      category: "floralTools",
      name: "Bottle Vivara d9.5/21.5xh30 בקבוק וויוורה",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "בהיר/כהה",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t229.jpg",
    },
    {
      id: "t230",
      sortOrder: 5740,
      category: "floralTools",
      name: "עששית אבן סולרה Lantern Solara d20/26xh24.5",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "חום/לבן",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t230.jpg",
    },
    {
      id: "t231",
      sortOrder: 5750,
      category: "floralTools",
      name: "עששית אבן Lantern Solara d15/20xh19",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "חום/לבן",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t231.jpg",
    },
    {
      id: "t232",
      sortOrder: 5910,
      category: "floralTools",
      name: "Lantern Natura d12xh10 עששית אבן נטורה",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "חום בלבד",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t232.jpg",
    },
    {
      id: "t233",
      sortOrder: 5640,
      category: "floralTools",
      name: "בקבוק נובל Bottle Novell d4.5/11xh23 (בהיר בלבד)",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "קרם",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t233.jpg",
    },
    {
      id: "t234",
      sortOrder: 5650,
      category: "floralTools",
      name: "בקבוק נובל Bottle Novell d4/9.7xh16.5 (בהיר בלבד)",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "קרם",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t234.jpg",
    },
    {
      id: "t235",
      sortOrder: 5660,
      category: "floralTools",
      name: "בקבוק נובל Bottle Novell d512xh30.5 (בהיר בלבד)",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "קרם",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t235.jpg",
    },
    {
      id: "t236",
      sortOrder: 1500,
      category: "floralTools",
      name: "קרמיקה אלמרה Pot Elmera d13.5/21.5xh22",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t236.jpg",
    },
    {
      id: "t237",
      sortOrder: 1510,
      category: "floralTools",
      name: "קרמיקה אלמרה Pot Elmera d15/25xh28.5",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "צבע פיץ' בלבד",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t237.jpg",
    },
    {
      id: "t238",
      sortOrder: 900,
      category: "floralTools",
      name: "קרמיקה סורינה D9X35.5XH23 740420900",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t238.jpg",
    },
    {
      id: "t239",
      sortOrder: 890,
      category: "floralTools",
      name: "קרמיקה סורינה d18/44xh58.5",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t239.jpg",
    },
    {
      id: "t240",
      sortOrder: 880,
      category: "floralTools",
      name: "קרמיקה סורינה d16.5/40.5xh45",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t240.jpg",
    },
    {
      id: "t241",
      sortOrder: 520,
      category: "floralTools",
      name: "צלחת אסנסיה קרמיקה ירוקה Esencia D20.5X2.5",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t241.jpg",
    },
    {
      id: "t242",
      sortOrder: 2130,
      category: "floralTools",
      name: "אגרטל מלבני ניצב 181806",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "אחורי ימני",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t242.jpg",
    },
    {
      id: "t243",
      sortOrder: 3070,
      category: "floralTools",
      name: "זכוכית מלבנית שקופה 101020",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t243.jpg",
    },
    {
      id: "t244",
      sortOrder: 3010,
      category: "floralTools",
      name: 'זכוכית גביע+מכסה 16XH35 ס"מ 42058',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t244.jpg",
    },
    {
      id: "t245",
      sortOrder: 2990,
      category: "floralTools",
      name: 'זכוכית גביע + מכסה 15XH35 ס"מ 42057',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t245.jpg",
    },
    {
      id: "t246",
      sortOrder: 2980,
      category: "floralTools",
      name: 'זכוכית גביע + מכסה 12XH28 ס"מ 42060',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t246.jpg",
    },
    {
      id: "t247",
      sortOrder: 3000,
      category: "floralTools",
      name: 'זכוכית גביע + מכסה 17XH25 ס"מ 42059',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t247.jpg",
    },
    {
      id: "t248",
      sortOrder: 4170,
      category: "floralTools",
      name: 'אופניים לעציצים 75/75/25 ס"מ 41541',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "בורדו,ירוק בהיר,תכלת,צהוב",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t248.jpg",
    },
    {
      id: "t249",
      sortOrder: 790,
      category: "floralTools",
      name: "קרמיקה חרמון WD2 24X24X24",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t249.jpg",
    },
    {
      id: "t250",
      sortOrder: 780,
      category: "floralTools",
      name: "קרמיקה חרמון WD1 H28X20X18",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t250.jpg",
    },
    {
      id: "t251",
      sortOrder: 800,
      category: "floralTools",
      name: "קרמיקה חרמון WD4 H26X24X24",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t251.jpg",
    },
    {
      id: "t252",
      sortOrder: 4310,
      category: "floralTools",
      name: "בקבוק חרמון WD7 17XH40",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t252.jpg",
    },
    {
      id: "t253",
      sortOrder: 770,
      category: "floralTools",
      name: "קרמיקה חצויה חומה WD30 26X26X26",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t253.jpg",
    },
    {
      id: "t254",
      sortOrder: 510,
      category: "floralTools",
      name: "סיר קרמיקה כבד WD18 24X19X16",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t254.jpg",
    },
    {
      id: "t255",
      sortOrder: 500,
      category: "floralTools",
      name: "סיר קרמיקה כבד WD17 30X23X20",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t255.jpg",
    },
    {
      id: "t256",
      sortOrder: 200,
      category: "floralTools",
      name: 'בקבוק קרמיקה לבן 20 ס"מ 40760',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "מוצר שמאלי",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t256.jpg",
    },
    {
      id: "t257",
      sortOrder: 2120,
      category: "floralTools",
      name: "אגרטל טוליפ 15/25 פס דק 2352-30 2352-28",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t257.jpg",
    },
    {
      id: "t258",
      sortOrder: 2360,
      category: "floralTools",
      name: "אגרטל צילינדר מבחנה  820 (קוד קרטון R803) 720",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t258.jpg",
    },
    {
      id: "t259",
      sortOrder: 1520,
      category: "floralTools",
      name: 'קרמיקה ביצה פסים 18 ס"מ + תחתית 205745 לבן + קרם',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "המוצר השמאלי-ירוק בהיר",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t259.jpg",
    },
    {
      id: "t260",
      sortOrder: 3560,
      category: "floralTools",
      name: "סל סיגראס ע.7 170073",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t260.jpg",
    },
    {
      id: "t261",
      sortOrder: 3820,
      category: "floralTools",
      name: '. מבצע קיץ משפך פח צבעוני (קוטר 7 ס"מ)',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "ירוק/סגול/כתום",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t261.jpg",
    },
    {
      id: "t262",
      sortOrder: 2840,
      category: "floralTools",
      name: 'זכוכית 9 ס"מ לסוקולנט צבעונית 2352',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t262.jpg",
    },
    {
      id: "t263",
      sortOrder: 2730,
      category: "floralTools",
      name: 'ואזה פח לפרחים ל"בסטה" 19/35 ס"מ METAL',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "*תכלת בלבד*",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t263.jpg",
    },
    {
      id: "t264",
      sortOrder: 600,
      category: "floralTools",
      name: 'קערה טרקוטה קרם 27.1 ס"מ KUL',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t264.jpg",
    },
    {
      id: "t265",
      sortOrder: 3960,
      category: "floralTools",
      name: 'אדנית אבן לבנה "גוני" GONI H7W12L40',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t265.jpg",
    },
    {
      id: "t266",
      sortOrder: 180,
      category: "floralTools",
      name: "אדנית קרמיקה מיס חום זהב 62216 D28H14",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t266.jpg",
    },
    {
      id: "t267",
      sortOrder: 3220,
      category: "floralTools",
      name: "פמוט זכוכית בודד H15D8 LK110",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t267.jpg",
    },
    {
      id: "t268",
      sortOrder: 3420,
      category: "floralTools",
      name: 'זכוכית 12 ס"מ לסחלב צבעונית',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "אמבר/כחול/אפור/צהוב\n*ללא לבן וורוד*",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t268.jpg",
    },
    {
      id: "t269",
      sortOrder: 2830,
      category: "floralTools",
      name: 'זכוכית 6 ס"מ לסוקולנט צבעונית 2352-26 2352-24',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t269.jpg",
    },
    {
      id: "t270",
      sortOrder: 5060,
      category: "floralTools",
      name: 'עציץ פלסטיק דמוי בטון 13 ס"מ 90-0091 NOEL נואל',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t270.jpg",
    },
    {
      id: "t271",
      sortOrder: 2930,
      category: "floralTools",
      name: 'זכוכית אקווריום שחור פס זהב 8 ס"מ 40539',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "שחור בלבד",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t271.jpg",
    },
    {
      id: "t272",
      sortOrder: 3210,
      category: "floralTools",
      name: 'סט מעמד לנר זכוכית על רגל 30+40+50 ס"מ',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t272.jpg",
    },
    {
      id: "t273",
      sortOrder: 2620,
      category: "floralTools",
      name: "ואזה בריסל מעויינים H10.5XD10 04566.",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t273.jpg",
    },
    {
      id: "t274",
      sortOrder: 2630,
      category: "floralTools",
      name: "ואזה בריסל מעויינים H18XD10 04567.",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t274.jpg",
    },
    {
      id: "t275",
      sortOrder: 2220,
      category: "floralTools",
      name: "אגרטל צילינדר 1218",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t275.jpg",
    },
    {
      id: "t276",
      sortOrder: 3370,
      category: "floralTools",
      name: "*מבצע! ואזה בת גלים כחולה H9XD16 43690*",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t276.jpg",
    },
    {
      id: "t277",
      sortOrder: 3120,
      category: "floralTools",
      name: "זכוכית צרה מרקש H13D5.5 42120",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "צד ימין",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t277.jpg",
    },
    {
      id: "t278",
      sortOrder: 2870,
      category: "floralTools",
      name: "זכוכית אקו אטלס 41183 H25D14.5.",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t278.jpg",
    },
    {
      id: "t279",
      sortOrder: 5270,
      category: "floralTools",
      name: "קערת קש D31XH13 176867",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t279.jpg",
    },
    {
      id: "t280",
      sortOrder: 4130,
      category: "floralTools",
      name: "אדנית קש טרפז L33X17X18 176865 176866 917180",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t280.jpg",
    },
    {
      id: "t281",
      sortOrder: 4120,
      category: "floralTools",
      name: "אדנית קש טרפז L25X15X13 176865 176866 917166",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t281.jpg",
    },
    {
      id: "t282",
      sortOrder: 4150,
      category: "floralTools",
      name: "אדנית קש S אליפסה גבוהה H15D25",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t282.jpeg",
    },
    {
      id: "t283",
      sortOrder: 4140,
      category: "floralTools",
      name: "אדנית קש L אליפסה גבוהה H18D32  17296",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t283.jpeg",
    },
    {
      id: "t284",
      sortOrder: 4840,
      category: "floralTools",
      name: 'כלי בטון מוקצף C-NIRO 15 ס"מ',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t284.jpg",
    },
    {
      id: "t285",
      sortOrder: 5360,
      category: "floralTools",
      name: "שק יוטה לעציץ גודל 15 1888-52",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t285.jpg",
    },
    {
      id: "t286",
      sortOrder: 650,
      category: "floralTools",
      name: "קרמיקה (קרטון 4 יחידות) מנדלה ע.12 MIX 42035",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t286.jpg",
    },
    {
      id: "t287",
      sortOrder: 5500,
      category: "floralTools",
      name: '*עציץ צמיג פסים 12 ס"מ GX22001*',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "לבן/ורוד/חום בהיר/שחור",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t287.jpg",
    },
    {
      id: "t288",
      sortOrder: 3500,
      category: "floralTools",
      name: "סל ליולדת- בייבי להולדת בת",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t288.jpg",
    },
    {
      id: "t289",
      sortOrder: 150,
      category: "floralTools",
      name: 'אדנית קרמיקה אובאלית 30 ס"מ  OVAL 30',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t289.jpg",
    },
    {
      id: "t290",
      sortOrder: 2570,
      category: "floralTools",
      name: "ברבאבא זכוכית קטן R-CONE 22-10",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t290.jpg",
    },
    {
      id: "t291",
      sortOrder: 2560,
      category: "floralTools",
      name: "ברבאבא זכוכית גדול R-CONE 28-11",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t291.jpg",
    },
    {
      id: "t292",
      sortOrder: 270,
      category: "floralTools",
      name: 'טרקוטה מוקה / חום ליסיה 23 ס"מ',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t292.jpg",
    },
    {
      id: "t293",
      sortOrder: 2300,
      category: "floralTools",
      name: "אגרטל צילינדר 1560",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t293.jpg",
    },
    {
      id: "t294",
      sortOrder: 4800,
      category: "floralTools",
      name: 'כלי אלומיניום לתצוגה 29 ס"מ  ALUMI 29',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t294.jpg",
    },
    {
      id: "t295",
      sortOrder: 4810,
      category: "floralTools",
      name: 'כלי אלומיניום לתצוגה 41 ס"מ  ALUMI 41',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t295.jpg",
    },
    {
      id: "t296",
      sortOrder: 2460,
      category: "floralTools",
      name: "בקבוק זכוכית אמורפי שקוף 60508 D17H30.",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t296.jpg",
    },
    {
      id: "t297",
      sortOrder: 2470,
      category: "floralTools",
      name: "בקבוק זכוכית אמורפי שקוף 60509 D13H35.",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t297.jpg",
    },
    {
      id: "t298",
      sortOrder: 4960,
      category: "floralTools",
      name: "סולם ארבע שלבים מדורג (לבן וטבעי בלבד)",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t298.jpg",
    },
    {
      id: "t299",
      sortOrder: 2440,
      category: "floralTools",
      name: "אגרטל שעון חול רחב 49561 D13H10",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t299.jpg",
    },
    {
      id: "t300",
      sortOrder: 5100,
      category: "floralTools",
      name: 'עששית מתכת זהב + צילינדר הוריקן 25 ס"מ LANTER 25',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t300.jpg",
    },
    {
      id: "t301",
      sortOrder: 3800,
      category: "floralTools",
      name: "משפך 6 ליטר",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t301.jpg",
    },
    {
      id: "t302",
      sortOrder: 3150,
      category: "floralTools",
      name: 'כדור ואזה פיה צרה מגמה D11 "פידריו"',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t302.jpg",
    },
    {
      id: "t303",
      sortOrder: 3160,
      category: "floralTools",
      name: 'כדור ואזה פיה רחבה קונית מגמה H22 "פידריו"',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t303.jpg",
    },
    {
      id: "t304",
      sortOrder: 2820,
      category: "floralTools",
      name: 'ואזה קונבסו מגמה D11 "פידריו"',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t304.jpg",
    },
    {
      id: "t305",
      sortOrder: 2810,
      category: "floralTools",
      name: 'ואזה קונבסו וולקנו D16 "פידריו"',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t305.jpg",
    },
    {
      id: "t306",
      sortOrder: 2610,
      category: "floralTools",
      name: 'ואזה בלום וולקנו H15 "פידריו"',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t306.jpg",
    },
    {
      id: "t307",
      sortOrder: 2740,
      category: "floralTools",
      name: 'ואזה פיגורה וולקנו H20 "פידריו"',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t307.jpg",
    },
    {
      id: "t308",
      sortOrder: 2800,
      category: "floralTools",
      name: "ואזה קונבסו וולקנו D11",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t308.jpg",
    },
    {
      id: "t309",
      sortOrder: 2600,
      category: "floralTools",
      name: 'ואזה בלה שוקו H17D15,5 "פידריו" ST-273-CO',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t309.jpg",
    },
    {
      id: "t310",
      sortOrder: 2790,
      category: "floralTools",
      name: 'ואזה צילינדר שוקו H10D10 "פידריו"',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t310.jpg",
    },
    {
      id: "t311",
      sortOrder: 2660,
      category: "floralTools",
      name: 'ואזה ולנטינה שוקו H11D15 "פידריו"',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t311.jpg",
    },
    {
      id: "t312",
      sortOrder: 2710,
      category: "floralTools",
      name: 'ואזה מרבל שוקו H15D14 "פידריו"',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t312.jpg",
    },
    {
      id: "t313",
      sortOrder: 2650,
      category: "floralTools",
      name: 'ואזה גלוריוזה פייסטה H22 "פידריו"',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t313.jpg",
    },
    {
      id: "t314",
      sortOrder: 2720,
      category: "floralTools",
      name: 'ואזה נואבו פייסטה H18 "פידריו"',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t314.jpg",
    },
    {
      id: "t315",
      sortOrder: 2640,
      category: "floralTools",
      name: 'ואזה גלוב S פייסטה H20 "פידריו"',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t315.jpg",
    },
    {
      id: "t316",
      sortOrder: 4380,
      category: "floralTools",
      name: 'בקבוק פיזה פטאל H18 "פידריו"',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t316.jpg",
    },
    {
      id: "t317",
      sortOrder: 2690,
      category: "floralTools",
      name: 'ואזה טורין S פטאל H15 "פידריו"',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t317.jpg",
    },
    {
      id: "t318",
      sortOrder: 5290,
      category: "floralTools",
      name: 'קרטון מעוצב אובאלי 22 ס"מ EGG BOX',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t318.jpg",
    },
    {
      id: "t319",
      sortOrder: 720,
      category: "floralTools",
      name: "קרמיקה דיאן DIAN20",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t319.jpg",
    },
    {
      id: "t320",
      sortOrder: 730,
      category: "floralTools",
      name: "קרמיקה דיאן DIAN24",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t320.jpg",
    },
    {
      id: "t321",
      sortOrder: 990,
      category: "floralTools",
      name: "קרמיקה פיבר צינור רחב HW-21 קטן",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t321.jpg",
    },
    {
      id: "t322",
      sortOrder: 980,
      category: "floralTools",
      name: "קרמיקה פיבר צינור רחב HW-21 גדול",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t322.jpg",
    },
    {
      id: "t323",
      sortOrder: 1040,
      category: "floralTools",
      name: "קרמיקה צינור פיבר רחב HW-21 בינוני",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t323.jpg",
    },
    {
      id: "t324",
      sortOrder: 4190,
      category: "floralTools",
      name: "ארטסטון קערה D55H23 90-0060",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t324.jpg",
    },
    {
      id: "t325",
      sortOrder: 5610,
      category: "floralTools",
      name: "ארטסטון pot claire d10 h11",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "תכלת",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t325.jpg",
    },
    {
      id: "t326",
      sortOrder: 5590,
      category: "floralTools",
      name: "ארטסטון Pot bola d28 h24",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "חום בהיר/אפור כהה/שחור",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t326.jpg",
    },
    {
      id: "t327",
      sortOrder: 4200,
      category: "floralTools",
      name: "ארטסטון Pot bola d33 h29",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "שחור",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t327.jpg",
    },
    {
      id: "t328",
      sortOrder: 5600,
      category: "floralTools",
      name: "ארטסטון Pot bola oak d55 h45",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "חום",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t328.jpg",
    },
    {
      id: "t329",
      sortOrder: 1560,
      category: "floralTools",
      name: "קרמיקה לונה 12 ללא לבן(לבדוק בדיקת זמינות צבעים)",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "אפור/שחור/ירוק/גרניט",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t329.jpg",
    },
    {
      id: "t330",
      sortOrder: 140,
      category: "floralTools",
      name: 'אגרטל קרמיקה ESRA אסרה 27X50H ס"מ',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "אפור/ירוק כהה",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t330.jpg",
    },
    {
      id: "t331",
      sortOrder: 3810,
      category: "floralTools",
      name: "משפך 8 ליטר",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "מוצג שני מימין",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t331.jpg",
    },
    {
      id: "t332",
      sortOrder: 4680,
      category: "floralTools",
      name: "כד מרקו פולו פלסטיק H47D40 גדול",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t332.png",
    },
    {
      id: "t333",
      sortOrder: 4360,
      category: "floralTools",
      name: 'בקבוק מנופח כחול 25 ס"מ 48325 איזי',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t333.jpg",
    },
    {
      id: "t334",
      sortOrder: 5820,
      category: "floralTools",
      name: "שק יוטה טבעי ע.12",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "טבעי בלבד",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t334.jpg",
    },
    {
      id: "t335",
      sortOrder: 3140,
      category: "floralTools",
      name: 'זכוכית קריסטל קוני עגול שקוף !!! 10H ס"מ 100YX',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t335.jpg",
    },
    {
      id: "t336",
      sortOrder: 2530,
      category: "floralTools",
      name: 'בקבוק זכוכית צר 40 ס"מ חום R-13',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t336.jpg",
    },
    {
      id: "t337",
      sortOrder: 5620,
      category: "floralTools",
      name: "ארטסטון pot claire d22 h20",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "ירוק/אפור כהה",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t337.jpg",
    },
    {
      id: "t338",
      sortOrder: 3170,
      category: "floralTools",
      name: 'מבחנה זכוכית לתליה 19 ס"מ',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t338.jpg",
    },
    {
      id: "t339",
      sortOrder: 3790,
      category: "floralTools",
      name: "משפך 10 ליטר",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "המוצג הימני",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t339.jpg",
    },
    {
      id: "t340",
      sortOrder: 680,
      category: "floralTools",
      name: "קרמיקה אישה יפה ע.15 (רזין)",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "ורוד/שחור",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t340.jpg",
    },
    {
      id: "t341",
      sortOrder: 1990,
      category: "floralTools",
      name: 'אגרטל זכוכית הוריקן 30 ס"מ',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "מוצר שמאלי",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t341.jpg",
    },
    {
      id: "t342",
      sortOrder: 5670,
      category: "floralTools",
      name: 'דלי פח 10 ס"מ',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t342.jpg",
    },
    {
      id: "t343",
      sortOrder: 5680,
      category: "floralTools",
      name: 'דלי פח 25 ס"מ + חבל 43055-2',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "כסוף בלבד",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t343.jpg",
    },
    {
      id: "t344",
      sortOrder: 5000,
      category: "floralTools",
      name: "סט מגירות עץ 3 חלקים(עד 72 שעות הספקה)",
      minQuantity: 4,
      maxQuantity: 196,
      comment: "נמכר כקרטון סגור בלבד,4 סטים בקרטון",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t344.jpg",
    },
    {
      id: "t345",
      sortOrder: 1970,
      category: "floralTools",
      name: 'אגרטל זכוכית הוריקן 15 ס"מ',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t345.jpg",
    },
    {
      id: "t346",
      sortOrder: 1900,
      category: "floralTools",
      name: "אגרטל ארובה 2040",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t346.jpg",
    },
    {
      id: "t347",
      sortOrder: 1870,
      category: "floralTools",
      name: "אגרטל ארובה 1525",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t347.jpg",
    },
    {
      id: "t348",
      sortOrder: 1860,
      category: "floralTools",
      name: "אגרטל ארובה 1520",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t348.jpg",
    },
    {
      id: "t349",
      sortOrder: 2240,
      category: "floralTools",
      name: "אגרטל צילינדר 1225 TC12525",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t349.jpg",
    },
    {
      id: "t350",
      sortOrder: 2280,
      category: "floralTools",
      name: "אגרטל צילינדר 1530",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t350.jpg",
    },
    {
      id: "t351",
      sortOrder: 5780,
      category: "floralTools",
      name: 'קש לעציץ צבעוני 12 ס"מ 51045',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "לבן/חום בהיר/חום כהה",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t351.jpg",
    },
    {
      id: "t352",
      sortOrder: 5790,
      category: "floralTools",
      name: 'קש לעציץ צבעוני 15 ס"מ 9100L',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "חום בהיר/חום כהה/לבן",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t352.jpg",
    },
    {
      id: "t353",
      sortOrder: 5800,
      category: "floralTools",
      name: 'קש לעציץ צבעוני 18 ס"מ 9100XL',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "חום בהיר/חום כהה/לבן/אדום",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t353.jpg",
    },
    {
      id: "t354",
      sortOrder: 5810,
      category: "floralTools",
      name: 'קש לעציץ צבעוני 24 ס"מ 9100XXL',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "חום כהה/חום בהיר/לבן",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t354.jpg",
    },
    {
      id: "t355",
      sortOrder: 5300,
      category: "floralTools",
      name: "קש אדנית עם ידיות 2181-17L (ל3 עציצים)",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t355.jpg",
    },
    {
      id: "t356",
      sortOrder: 3450,
      category: "floralTools",
      name: "זכוכית בומביי קטנה צבעונית 11*13 -(סגול בהיר ואדום בלבד!)",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "אדום/ סגול בהיר",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t356.jpg",
    },
    {
      id: "t357",
      sortOrder: 3130,
      category: "floralTools",
      name: "זכוכית קוני צבעונית 14.2*13",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "אפור ושחור בלבד",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t357.jpg",
    },
    {
      id: "t358",
      sortOrder: 3090,
      category: "floralTools",
      name: "זכוכית עגולה שקופה 10*9",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t358.jpg",
    },
    {
      id: "t359",
      sortOrder: 280,
      category: "floralTools",
      name: 'טרקוטה מוקה ליסיה 27 ס"מ',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t359.jpg",
    },
    {
      id: "t360",
      sortOrder: 2320,
      category: "floralTools",
      name: "אגרטל צילינדר 1850",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t360.jpg",
    },
    {
      id: "t361",
      sortOrder: 2390,
      category: "floralTools",
      name: "אגרטל צילינדר מבחנה 525 (קוד קרטון R1002)",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t361.jpg",
    },
    {
      id: "t362",
      sortOrder: 4630,
      category: "floralTools",
      name: "טרריום כדור 12 (TCDG12)",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t362.jpg",
    },
    {
      id: "t363",
      sortOrder: 4640,
      category: "floralTools",
      name: "טרריום כדור 16 (TCDG16)",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t363.jpg",
    },
    {
      id: "t364",
      sortOrder: 4970,
      category: "floralTools",
      name: "סט ארגז עץ 3 יח ידית נמוכה לבן SFM18-238",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t364.jpg",
    },
    {
      id: "t365",
      sortOrder: 1980,
      category: "floralTools",
      name: 'אגרטל זכוכית הוריקן 20 ס"מ',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t365.jpg",
    },
    {
      id: "t366",
      sortOrder: 2750,
      category: "floralTools",
      name: 'ואזה פלסטיק 25 ס"מ',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "המוצג הימני",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t366.jpg",
    },
    {
      id: "t367",
      sortOrder: 2760,
      category: "floralTools",
      name: 'ואזה פלסטיק 35 ס"מ',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "מוצג שני מימין",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t367.jpg",
    },
    {
      id: "t368",
      sortOrder: 4980,
      category: "floralTools",
      name: 'סט ארגז עץ 5 יחידות לבן #5  28908  40/34/28/24/18 ס"מ',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t368.jpg",
    },
    {
      id: "t369",
      sortOrder: 2770,
      category: "floralTools",
      name: 'ואזה פלסטיק 45 ס"מ',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "מוצר אמצעי(שני מימין)",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t369.jpg",
    },
    {
      id: "t370",
      sortOrder: 2780,
      category: "floralTools",
      name: 'ואזה פלסטיק 50 ס"מ',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "מוצג שני משמאל",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t370.jpg",
    },
    {
      id: "t371",
      sortOrder: 4790,
      category: "floralTools",
      name: "כוס קוניאק קטן (BV1005-1) 42054.",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t371.jpg",
    },
    {
      id: "t372",
      sortOrder: 4880,
      category: "floralTools",
      name: 'כלי קליפה מרובע בינוני 15 ס"מ (עד 72 שעות אספקה)',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t372.jpg",
    },
    {
      id: "t373",
      sortOrder: 2290,
      category: "floralTools",
      name: "אגרטל צילינדר 1535",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t373.jpg",
    },
    {
      id: "t374",
      sortOrder: 3030,
      category: "floralTools",
      name: "זכוכית טיפה קטנה 25*6.5 BB197",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t374.jpg",
    },
    {
      id: "t375",
      sortOrder: 3020,
      category: "floralTools",
      name: "זכוכית טיפה גדולה 8*36",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t375.jpg",
    },
    {
      id: "t376",
      sortOrder: 2940,
      category: "floralTools",
      name: "זכוכית בולוניה 15*28 BB198",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t376.jpg",
    },
    {
      id: "t377",
      sortOrder: 3060,
      category: "floralTools",
      name: "זכוכית מלבנית קטנה 12X6X15",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t377.jpg",
    },
    {
      id: "t378",
      sortOrder: 4390,
      category: "floralTools",
      name: 'בקבוק פינטו שקוף 25 ס"מ DX-23-012-2',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t378.jpg",
    },
    {
      id: "t379",
      sortOrder: 3040,
      category: "floralTools",
      name: "זכוכית מלבנית בינונית 12X5X20",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "קדמי אמצעי",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t379.jpg",
    },
    {
      id: "t380",
      sortOrder: 3050,
      category: "floralTools",
      name: "זכוכית מלבנית גדולה 11X7X25",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "אחורי אמצעי",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t380.jpg",
    },
    {
      id: "t381",
      sortOrder: 4500,
      category: "floralTools",
      name: 'דלי פח מט 13 ס"מ עם ידית וכיתוב 43281-5',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "כתום וסגול בלבד",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t381.jpg",
    },
    {
      id: "t382",
      sortOrder: 2330,
      category: "floralTools",
      name: "אגרטל צילינדר 2020",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t382.jpg",
    },
    {
      id: "t383",
      sortOrder: 2340,
      category: "floralTools",
      name: "אגרטל צילינדר 2030",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t383.jpg",
    },
    {
      id: "t384",
      sortOrder: 4900,
      category: "floralTools",
      name: "מיכל צילינדר מתכת חלודה בינוני 25X17 VJS004",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t384.jpg",
    },
    {
      id: "t385",
      sortOrder: 4910,
      category: "floralTools",
      name: "מיכל צילינדר מתכת חלודה גדול 30X20 VJS004",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t385.jpg",
    },
    {
      id: "t386",
      sortOrder: 3240,
      category: "floralTools",
      name: "צילינדר זכוכית חלודה 8X25 BFR CHO100629",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t386.jpg",
    },
    {
      id: "t387",
      sortOrder: 3250,
      category: "floralTools",
      name: "צילינדר זכוכית חלודה 8X30 BFR CHO100677",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t387.jpg",
    },
    {
      id: "t388",
      sortOrder: 2060,
      category: "floralTools",
      name: "אגרטל זכוכית חלודה U BFR 10X10X11 CM 100689",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t388.jpg",
    },
    {
      id: "t389",
      sortOrder: 2070,
      category: "floralTools",
      name: "אגרטל זכוכית חלודה U BFR 13X13X21 CM 100692",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t389.jpg",
    },
    {
      id: "t390",
      sortOrder: 2020,
      category: "floralTools",
      name: "אגרטל זכוכית חלודה שחור U BFR 13X13X21 CM 100694",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t390.jpg",
    },
    {
      id: "t391",
      sortOrder: 1910,
      category: "floralTools",
      name: "אגרטל ביצה מתכת חלודה שחורה BRF 13X13X11 CM 100697",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t391.jpg",
    },
    {
      id: "t392",
      sortOrder: 2150,
      category: "floralTools",
      name: "אגרטל פיה צרה מתכת חלודה BRF 15X15X16 CM 100701",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t392.jpg",
    },
    {
      id: "t393",
      sortOrder: 2140,
      category: "floralTools",
      name: "אגרטל פיה צרה מתכת חלודה שחורה BRF 15X15X16 CM 100703",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t393.jpg",
    },
    {
      id: "t394",
      sortOrder: 2000,
      category: "floralTools",
      name: "אגרטל זכוכית חלודה יהלום 10X20 BRF 101572",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t394.jpg",
    },
    {
      id: "t395",
      sortOrder: 2030,
      category: "floralTools",
      name: "אגרטל זכוכית חלודה שחורה יהלום 10X20 BRF 101573",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t395.jpg",
    },
    {
      id: "t396",
      sortOrder: 2040,
      category: "floralTools",
      name: "אגרטל זכוכית חלודה שחורה יהלום 10X30 BRF 101575",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t396.jpg",
    },
    {
      id: "t397",
      sortOrder: 2080,
      category: "floralTools",
      name: "אגרטל זכוכית מלון פסים חלודה 15X28 BRF 101576",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t397.jpg",
    },
    {
      id: "t398",
      sortOrder: 2090,
      category: "floralTools",
      name: "אגרטל זכוכית מלון פסים חלודה 16X34 BRF 101578",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t398.jpg",
    },
    {
      id: "t399",
      sortOrder: 2100,
      category: "floralTools",
      name: "אגרטל זכוכית מלון פסים חלודה 18X40 BRF 101580",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t399.jpg",
    },
    {
      id: "t400",
      sortOrder: 2050,
      category: "floralTools",
      name: "אגרטל זכוכית חלודה שכבות BRF 21X23 98792",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t400.jpg",
    },
    {
      id: "t401",
      sortOrder: 2010,
      category: "floralTools",
      name: "אגרטל זכוכית חלודה צוואר 19X39 BRF 98793",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t401.jpg",
    },
    {
      id: "t402",
      sortOrder: 4740,
      category: "floralTools",
      name: 'כדור מתכת לתלייה 27 ס"מ BRF 101471',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t402.jpg",
    },
    {
      id: "t403",
      sortOrder: 4750,
      category: "floralTools",
      name: 'כדור מתכת לתלייה 32 ס"מ BRF 101472',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t403.jpg",
    },
    {
      id: "t404",
      sortOrder: 3830,
      category: "floralTools",
      name: "*דלי מתכת חלודה לנר BRF17X19 100991*",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t404.jpg",
    },
    {
      id: "t405",
      sortOrder: 3840,
      category: "floralTools",
      name: "*דלי מתכת חלודה לנר BRF21X28 100992*",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t405.jpg",
    },
    {
      id: "t406",
      sortOrder: 1770,
      category: "floralTools",
      name: "*אגרטל בראס BRF 9X11 102109*",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t406.jpg",
    },
    {
      id: "t407",
      sortOrder: 1750,
      category: "floralTools",
      name: "*אגרטל בראס BRF 11X14 102110*",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t407.jpg",
    },
    {
      id: "t408",
      sortOrder: 1760,
      category: "floralTools",
      name: "*אגרטל בראס BRF 14X16 102111*",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t408.jpg",
    },
    {
      id: "t409",
      sortOrder: 1920,
      category: "floralTools",
      name: "אגרטל בראס אובאלי 19X13X18 BRF 102126",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t409.jpg",
    },
    {
      id: "t410",
      sortOrder: 1740,
      category: "floralTools",
      name: "*אגרטל בראס אובאלי 23X15X21 BRF 102127*",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t410.jpg",
    },
    {
      id: "t411",
      sortOrder: 5010,
      category: "floralTools",
      name: "סירה בראס BRF 37X12X11 102130",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t411.jpg",
    },
    {
      id: "t412",
      sortOrder: 5020,
      category: "floralTools",
      name: "סירה בראס BRF 44X15X13 102131",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t412.jpg",
    },
    {
      id: "t413",
      sortOrder: 4860,
      category: "floralTools",
      name: 'כלי בראס 8 ס"מ BRF 97891A',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t413.jpg",
    },
    {
      id: "t414",
      sortOrder: 3910,
      category: "floralTools",
      name: "*קערה מתכת שחור/זהב BRF 20X11 102085*",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t414.jpg",
    },
    {
      id: "t415",
      sortOrder: 3920,
      category: "floralTools",
      name: "*קערה מתכת שחור/זהב BRF 26X13 102086*",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t415.jpg",
    },
    {
      id: "t416",
      sortOrder: 3930,
      category: "floralTools",
      name: "*קערה מתכת שחור/זהב BRF 31X16 102087*",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t416.jpg",
    },
    {
      id: "t417",
      sortOrder: 3940,
      category: "floralTools",
      name: "*קערה מתכת שחור/זהב BRF 37X19 102088*",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t417.jpg",
    },
    {
      id: "t418",
      sortOrder: 5180,
      category: "floralTools",
      name: "צילינדר מתכת שחור/זהב BRF 21X26 102091",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t418.jpg",
    },
    {
      id: "t419",
      sortOrder: 5190,
      category: "floralTools",
      name: "צילינדר מתכת שחור/זהב BRF 27X30 102092",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t419.jpg",
    },
    {
      id: "t420",
      sortOrder: 5200,
      category: "floralTools",
      name: "צילינדר מתכת שחור/זהב BRF 31X36 102093",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t420.jpg",
    },
    {
      id: "t421",
      sortOrder: 3850,
      category: "floralTools",
      name: "*כוס קוקטייל בראס על רגל 21X39 BRF 101038*",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t421.jpg",
    },
    {
      id: "t422",
      sortOrder: 3860,
      category: "floralTools",
      name: "*כוס קוקטייל בראס על רגל 28X52 BRF101039*",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t422.jpg",
    },
    {
      id: "t423",
      sortOrder: 3890,
      category: "floralTools",
      name: "*מגש עץ עתיק ידיות ברזל BRF 61X22X11 100914*",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t423.jpg",
    },
    {
      id: "t424",
      sortOrder: 3870,
      category: "floralTools",
      name: "*מגש עץ עגול על רגל BRF 22X22X12 95398*",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t424.jpg",
    },
    {
      id: "t425",
      sortOrder: 3880,
      category: "floralTools",
      name: "*מגש עץ עגול על רגל BRF 32X32X1295401*",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t425.jpg",
    },
    {
      id: "t426",
      sortOrder: 2680,
      category: "floralTools",
      name: "ואזה זכוכית זברה שחורה 40902",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "הואזה הימנית",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t426.jpg",
    },
    {
      id: "t427",
      sortOrder: 2670,
      category: "floralTools",
      name: "ואזה זכוכית זברה שחורה 40901",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "הואזה השמאלית",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t427.jpg",
    },
    {
      id: "t428",
      sortOrder: 3770,
      category: "floralTools",
      name: "כלי עבודה מעדר משולב",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t428.jpg",
    },
    {
      id: "t429",
      sortOrder: 4730,
      category: "floralTools",
      name: "כד רומי D29H24 2409-1F 69128456740",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t429.jpg",
    },
    {
      id: "t430",
      sortOrder: 4920,
      category: "floralTools",
      name: 'מילוי קוקוס עגול 35 ס"מ',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t430.jpg",
    },
    {
      id: "t431",
      sortOrder: 170,
      category: "floralTools",
      name: "אדנית קרמיקה אמורפית 43156 *אספקה 72 שעות*",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t431.jpg",
    },
    {
      id: "t432",
      sortOrder: 160,
      category: "floralTools",
      name: "אדנית קרמיקה אמורפית 43155 *אספקה 72 שעות*",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t432.jpg",
    },
    {
      id: "t433",
      sortOrder: 1570,
      category: "floralTools",
      name: 'קרמיקה צילינדר חלקה + תחתית 18 ס"מ 8082-18',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "לבן/שחור/חום בהיר/ורוד/ירוק/חום כהה",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t433.jpg",
    },
    {
      id: "t434",
      sortOrder: 1580,
      category: "floralTools",
      name: "קרמיקה צילינדר חלקה + תחתית ע.12 8082-12(לוודא צבעים שבמלאי)",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "אפור/לבן/תכלת/ורוד/ירוק בהיר/ירוק כהה",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t434.jpg",
    },
    {
      id: "t435",
      sortOrder: 1120,
      category: "floralTools",
      name: "קרמיקה קערה D12H6.5 חלקה / פסים S מעוגלת 2311/2312",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "שחור/חום בהיר/חום כהה//ירוק בהיר/ירוק כהה",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t435.jpg",
    },
    {
      id: "t436",
      sortOrder: 1130,
      category: "floralTools",
      name: "קרמיקה קערה D17H9 חלקה / פסים M מעוגלת 2311/2312",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "שחור/חום בהיר/חום כהה//ירוק בהיר/ירוק כהה",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t436.jpg",
    },
    {
      id: "t437",
      sortOrder: 4870,
      category: "floralTools",
      name: 'כלי פנימי לפח "בסטה" למניעת נזילות.',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t437.jpg",
    },
    {
      id: "t438",
      sortOrder: 1590,
      category: "floralTools",
      name: "קרמיקה צילינדר חלקה + תחתית ע.15 8080",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "חום בהיר/שחור/ורוד",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t438.jpg",
    },
    {
      id: "t439",
      sortOrder: 3780,
      category: "floralTools",
      name: "כלי עבודה מקלטר",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t439.jpg",
    },
    {
      id: "t440",
      sortOrder: 1010,
      category: "floralTools",
      name: "קרמיקה צילינדר חלקה + תחתית ע.24 8082-24",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "תכלת/לבן /חום בהיר וכהה/צהוב/ירוק בהיר וכהה/שחור/ורוד",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t440.jpg",
    },
    {
      id: "t441",
      sortOrder: 5880,
      category: "floralTools",
      name: 'תחתית פלסטיק שוליים גבוהים 17 ס"מ',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "שחור בלבד",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t441.jpg",
    },
    {
      id: "t442",
      sortOrder: 5430,
      category: "floralTools",
      name: 'תחתית פלסטיק שוליים גבוהים 26 ס"מ',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "אפור/צהוב/ירוק בהיר וכהה/לבן/שמנת",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t442.jpg",
    },
    {
      id: "t443",
      sortOrder: 4040,
      category: "floralTools",
      name: "אדנית פל עם תחתית 30 סמ SETMIMI",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "ירוק בהיר/שחור/חום/אדום",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t443.jpg",
    },
    {
      id: "t444",
      sortOrder: 5710,
      category: "floralTools",
      name: 'עציץ פלסטיק קוניקו 25 ס"מ',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "שחור/שמנת/חום בהיר/ירוק כהה ובהיר/אפור בהיר",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t444.jpg",
    },
    {
      id: "t445",
      sortOrder: 5730,
      category: "floralTools",
      name: 'עציץ קוניקו פלסטיק 30 ס"מ',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "לבן/ירוק בהיר וכהה/אפור בהיר/שחור",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t445.jpg",
    },
    {
      id: "t446",
      sortOrder: 5720,
      category: "floralTools",
      name: 'עציץ פלסטיק קוניקו 40 ס"מ',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "אפור בהיר/ירוק בהיר/חום בהיר/לבן",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t446.jpg",
    },
    {
      id: "t447",
      sortOrder: 4270,
      category: "floralTools",
      name: "בקבוק גיבה פסים /נקודות שקוף J39388 D2.5H8.",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t447.jpg",
    },
    {
      id: "t448",
      sortOrder: 420,
      category: "floralTools",
      name: 'טרקוטה קרם 18 ס"מ (20.7)',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t448.jpg",
    },
    {
      id: "t449",
      sortOrder: 4230,
      category: "floralTools",
      name: 'בית עציץ "קורי" 27 ס"מ CORI',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "אפור/טורקיז/ירוק/תכלת/לבן נק'",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t449.jpg",
    },
    {
      id: "t450",
      sortOrder: 4210,
      category: "floralTools",
      name: 'ביץ עציץ "קורי" 35 ס"מ CORI',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "קרם",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t450.jpg",
    },
    {
      id: "t451",
      sortOrder: 1960,
      category: "floralTools",
      name: "אגרטל גוליית D18XH28 2318-15",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t451.jpg",
    },
    {
      id: "t452",
      sortOrder: 3700,
      category: "floralTools",
      name: "סלסלת קוקוס תליה מרובע !!!",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t452.jpg",
    },
    {
      id: "t453",
      sortOrder: 5070,
      category: "floralTools",
      name: 'עציץ פלסטיק קוניקו 14 ס"מ ינאי',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t453.jpg",
    },
    {
      id: "t454",
      sortOrder: 5450,
      category: "floralTools",
      name: 'תחתית פלסטיק שוליים גבוהים 9 ס"מ',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t454.jpg",
    },
    {
      id: "t455",
      sortOrder: 3440,
      category: "floralTools",
      name: "זכוכית בומבה לבן/מנטה 42285/42284 D5H35",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "נא לציין את הצבע המבוקש מנטה/לבן",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t455.jpg",
    },
    {
      id: "t456",
      sortOrder: 3430,
      category: "floralTools",
      name: "זכוכית בומבה ארוך לבן/מנטה 42291/42292 D4H49",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "נא לציין את הצבע המבוקש לבן/מנטה",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t456.jpg",
    },
    {
      id: "t457",
      sortOrder: 3400,
      category: "floralTools",
      name: "ואזה צמיגים בינוני לבן/מנטה 42310/42309 D9H30",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "נא לציין את הצבע המבוקש לבן/מנטה",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t457.jpg",
    },
    {
      id: "t458",
      sortOrder: 3410,
      category: "floralTools",
      name: "ואזה צמיגים גדול לבן/מנטה 42313/42312 D11H35",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "נא לציין את הצבע המבוקש מנטה/לבן",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t458.jpg",
    },
    {
      id: "t459",
      sortOrder: 5250,
      category: "floralTools",
      name: 'קערת דקורציה מעמד לנר 25 ס"מ 42334',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t459.jpg",
    },
    {
      id: "t460",
      sortOrder: 4670,
      category: "floralTools",
      name: "כד יווני עם ידיות קטן 2409-11 32X24 (לבדוק זמינות צבעים!)",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "לבן מבריק/חום משופשף/לבן משופשף/קרם",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t460.jpg",
    },
    {
      id: "t461",
      sortOrder: 640,
      category: "floralTools",
      name: "קרטון סגור(צבע אחיד!)קרמיקה צילינדר 20029 פסים ע.12 + תחתית (12 יחידות)",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t461.jpg",
    },
    {
      id: "t462",
      sortOrder: 1620,
      category: "floralTools",
      name: "קרמיקה צילינדר פסים ע.8 20029D",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "שחור/ורוד/חום בהיר/חום כהה/לבן",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t462.jpg",
    },
    {
      id: "t463",
      sortOrder: 4220,
      category: "floralTools",
      name: 'ביץ עציץ "קורי" 45 ס"מ CORI',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "אפור כהה בלבד",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t463.jpg",
    },
    {
      id: "t464",
      sortOrder: 710,
      category: "floralTools",
      name: "קרמיקה בודהה 3452 B25.5X24.5X32.5",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t464.jpg",
    },
    {
      id: "t465",
      sortOrder: 700,
      category: "floralTools",
      name: "קרמיקה בודהה 3452 A19X18X24",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t465.jpg",
    },
    {
      id: "t466",
      sortOrder: 4590,
      category: "floralTools",
      name: "חרס חברון כד שמן גדול H31D3",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t466.jpg",
    },
    {
      id: "t467",
      sortOrder: 1020,
      category: "floralTools",
      name: "קרמיקה צילינדר פסים + תחתית ע.24 20029-24",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "צהוב/שחור/חום כהה/ירוק כהה",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t467.jpg",
    },
    {
      id: "t468",
      sortOrder: 1660,
      category: "floralTools",
      name: "קרמיקה קערה פסים GX20030B GX2022B",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "המוצר הפנימי,בצבעים- ירוק בהיר/ירוק כהה/חום בהיר/לבן/ורוד",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t468.jpg",
    },
    {
      id: "t469",
      sortOrder: 1650,
      category: "floralTools",
      name: "קרמיקה קערה פסים GX20030A GX2022A",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "המוצר החיצוני, בצבעים -ירוק בהיר/ירוק כהה/חום בהיר/לבן/ורוד",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t469.jpg",
    },
    {
      id: "t470",
      sortOrder: 1610,
      category: "floralTools",
      name: "קרמיקה צילינדר פסים + תחתית ע.12 20029",
      minQuantity: 1,
      maxQuantity: 199,
      comment:
        "לבן+כחול/לבן/שחור/כחול כהה/חום כהה/ורוד/ירוק בהיר/ירוק כהה/צהוב",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t470.jpg",
    },
    {
      id: "t471",
      sortOrder: 3330,
      category: "floralTools",
      name: "קערה זכוכית שחורה RT15-25",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t471.jpg",
    },
    {
      id: "t472",
      sortOrder: 4780,
      category: "floralTools",
      name: 'כוס חרס חברון 9 ס"מ',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t472.jpg",
    },
    {
      id: "t473",
      sortOrder: 4620,
      category: "floralTools",
      name: "חרס חברון קערה שטוחה H23D42 L",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t473.jpg",
    },
    {
      id: "t474",
      sortOrder: 1950,
      category: "floralTools",
      name: "אגרטל גוליית D15XH22 2318",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t474.jpg",
    },
    {
      id: "t475",
      sortOrder: 4610,
      category: "floralTools",
      name: "חרס חברון קערה שטוחה H17D32 S",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t475.jpg",
    },
    {
      id: "t476",
      sortOrder: 1250,
      category: "floralTools",
      name: "קרמיקה רודוס 4143 A קטן גבוה",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t476.jpg",
    },
    {
      id: "t477",
      sortOrder: 1260,
      category: "floralTools",
      name: "קרמיקה רודוס 4143 B גדול גבוה H72D50",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t477.jpg",
    },
    {
      id: "t478",
      sortOrder: 670,
      category: "floralTools",
      name: "קרמיקה אולימפיה 4 ידיות 38X30 2409-16(אספקה החל מה-18/5)",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t478.jpg",
    },
    {
      id: "t479",
      sortOrder: 620,
      category: "floralTools",
      name: "קרטון אורגינל קרמיקה צילינדר פסים ע.8 20029D (36 יח)",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "שחור, ורוד,חום כהה, חום בהיר",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t479.jpg",
    },
    {
      id: "t480",
      sortOrder: 610,
      category: "floralTools",
      name: "קרטון אורגינל קרמיקה צילינדר חלק ע.8 8082 (36 יח)",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "לבן, שחור, ורוד, חום כהה, חום בהיר,",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t480.jpg",
    },
    {
      id: "t481",
      sortOrder: 760,
      category: "floralTools",
      name: "קרמיקה חבית יוליוס 45X50 2409-5",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t481.jpg",
    },
    {
      id: "t482",
      sortOrder: 630,
      category: "floralTools",
      name: "קרטון סגור(צבע אחיד!) קרמיקה צילינדר 8080 חלקה ע.12 + תחתית (12 יחידות)",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t482.jpg",
    },
    {
      id: "t483",
      sortOrder: 1230,
      category: "floralTools",
      name: "קרמיקה רודוס 4142 A קטן חלק H60D35",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t483.jpg",
    },
    {
      id: "t484",
      sortOrder: 1240,
      category: "floralTools",
      name: "קרמיקה רודוס 4142 B גדול חלק H82D48",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t484.jpg",
    },
    {
      id: "t485",
      sortOrder: 1270,
      category: "floralTools",
      name: "קרמיקה רודוס 4146 A קטן H48D32",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t485.jpg",
    },
    {
      id: "t486",
      sortOrder: 1280,
      category: "floralTools",
      name: "קרמיקה רודוס 4146 B גדול H75D50",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t486.jpg",
    },
    {
      id: "t487",
      sortOrder: 3610,
      category: "floralTools",
      name: 'סל קש פומלה ידיות עור 34 ס"מ 40045 / 40040',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t487.jpg",
    },
    {
      id: "t488",
      sortOrder: 3600,
      category: "floralTools",
      name: 'סל קש פומלה ידיות עור 28 ס"מ 40045 / 40040',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t488.jpg",
    },
    {
      id: "t489",
      sortOrder: 3590,
      category: "floralTools",
      name: 'סל קש פומלה ידיות עור 25 ס"מ 40045 / 40040',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t489.jpg",
    },
    {
      id: "t490",
      sortOrder: 3480,
      category: "floralTools",
      name: "סט 3 סלסלת קרמבולה 24/21/17",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t490.jpg",
    },
    {
      id: "t491",
      sortOrder: 4760,
      category: "floralTools",
      name: 'כוס אמייל 6 ס"מ 42397',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t491.jpg",
    },
    {
      id: "t492",
      sortOrder: 2490,
      category: "floralTools",
      name: "בקבוק זכוכית ליקר ירוק H20W10 PDL",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t492.png",
    },
    {
      id: "t493",
      sortOrder: 5080,
      category: "floralTools",
      name: 'עציץ פלסטיק קוניקו 50 ס"מ',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "אפור בהיר/ירוק בהיר/שחור/לבן/שמנת",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t493.jpg",
    },
    {
      id: "t494",
      sortOrder: 5440,
      category: "floralTools",
      name: 'תחתית פלסטיק שוליים גבוהים 34 ס"מ',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "לבן/ירוק בהיר/ירוק כהה/חום בהיר/שמנת/אפור",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t494.jpg",
    },
    {
      id: "t495",
      sortOrder: 2110,
      category: "floralTools",
      name: "אגרטל טוליפ 14/16 פס דק 2352-31",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t495.jpg",
    },
    {
      id: "t496",
      sortOrder: 260,
      category: "floralTools",
      name: 'טרקוטה טוסקנה שוליים רחבים 47 ס"מ',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t496.jpg",
    },
    {
      id: "t497",
      sortOrder: 3380,
      category: "floralTools",
      name: "אגרטל פיה צרה CAD 20-12 ללא ורוד וירוק!",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "לבן/שחור/שקוף",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t497.jpg",
    },
    {
      id: "t498",
      sortOrder: 4470,
      category: "floralTools",
      name: "גביע מתכת זהב חלודה זאוס 50308 D11H10",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t498.jpg",
    },
    {
      id: "t499",
      sortOrder: 1100,
      category: "floralTools",
      name: "קרמיקה קערה רודוס קונית 1051 גדול H26D47",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t499.jpeg",
    },
    {
      id: "t500",
      sortOrder: 1110,
      category: "floralTools",
      name: "קרמיקה קערה רודוס קונית 1051 קטן D30H17",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t500.jpeg",
    },
    {
      id: "t501",
      sortOrder: 3710,
      category: "floralTools",
      name: "סל העמק פלסטיק L34W14H31",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t501.jpg",
    },
    {
      id: "t502",
      sortOrder: 3580,
      category: "floralTools",
      name: "סל פלסקט",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t502.jpg",
    },
    {
      id: "t503",
      sortOrder: 3740,
      category: "floralTools",
      name: "סל תיק פלסטיק L29W12H29",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t503.jpg",
    },
    {
      id: "t504",
      sortOrder: 3570,
      category: "floralTools",
      name: "סל פלסטיק ביג BIG",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t504.jpg",
    },
    {
      id: "t505",
      sortOrder: 4050,
      category: "floralTools",
      name: "אדנית פל עם תחתית 40 סמ",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "לבן",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t505.jpg",
    },
    {
      id: "t506",
      sortOrder: 5420,
      category: "floralTools",
      name: 'תחתית פלסטיק שוליים גבוהים 19 ס"מ',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "ירוק/שחור בלבד",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t506.jpg",
    },
    {
      id: "t507",
      sortOrder: 5690,
      category: "floralTools",
      name: "כד חלב METAL 15/7 15/6",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "ירוק/ורוד",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t507.jpg",
    },
    {
      id: "t508",
      sortOrder: 4560,
      category: "floralTools",
      name: "חצי טרריום בוב H20D23 J35222.",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t508.jpg",
    },
    {
      id: "t509",
      sortOrder: 4550,
      category: "floralTools",
      name: "חצי טרריום בוב H10D12.5 J42090.",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t509.jpg",
    },
    {
      id: "t510",
      sortOrder: 4570,
      category: "floralTools",
      name: "חצי טרריום בוב J42111 H12D13.",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t510.jpg",
    },
    {
      id: "t511",
      sortOrder: 2910,
      category: "floralTools",
      name: "זכוכית אקו נובל H8D16 J43190",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t511.jpg",
    },
    {
      id: "t512",
      sortOrder: 2920,
      category: "floralTools",
      name: "זכוכית אקו נובל H8D19 J43191",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t512.jpg",
    },
    {
      id: "t513",
      sortOrder: 3080,
      category: "floralTools",
      name: "זכוכית מליסה H15D18 J42211.",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t513.jpg",
    },
    {
      id: "t514",
      sortOrder: 220,
      category: "floralTools",
      name: "בקבוק קרמיקה פרחים HY-09 H20W11",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t514.jpg",
    },
    {
      id: "t515",
      sortOrder: 210,
      category: "floralTools",
      name: "בקבוק קרמיקה פרחים HY-08 H16W9",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t515.jpg",
    },
    {
      id: "t516",
      sortOrder: 4650,
      category: "floralTools",
      name: "כד חלב כסף 18/9 41340",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t516.jpg",
    },
    {
      id: "t517",
      sortOrder: 910,
      category: "floralTools",
      name: 'קרמיקה עין הוד 12 ס"מ GUY',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "מוצר ימני לבן /אין טורקיז",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t517.jpg",
    },
    {
      id: "t518",
      sortOrder: 230,
      category: "floralTools",
      name: 'טרקוטה 21 ס"מ XL חום',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t518.jpg",
    },
    {
      id: "t519",
      sortOrder: 240,
      category: "floralTools",
      name: 'טרקוטה 25 ס"מ XL חום',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t519.jpg",
    },
    {
      id: "t520",
      sortOrder: 5050,
      category: "floralTools",
      name: "עציץ פלסטיק אווה EVA 54X59",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t520.jpg",
    },
    {
      id: "t521",
      sortOrder: 5040,
      category: "floralTools",
      name: "עציץ פלסטיק אווה EVA 43X45",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t521.jpg",
    },
    {
      id: "t522",
      sortOrder: 5030,
      category: "floralTools",
      name: "עציץ פלסטיק אווה EVA 32X35",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t522.jpg",
    },
    {
      id: "t523",
      sortOrder: 3950,
      category: "floralTools",
      name: 'אדנית + תחתית פלסטיק ארטסון 90-0068 36 ס"מ',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t523.jpg",
    },
    {
      id: "t524",
      sortOrder: 4820,
      category: "floralTools",
      name: 'כלי בטון 13 ס"מ C-NATURAL נטורל',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t524.jpg",
    },
    {
      id: "t525",
      sortOrder: 4830,
      category: "floralTools",
      name: 'כלי בטון 16 ס"מ C-NATURAL נטורל',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t525.jpg",
    },
    {
      id: "t526",
      sortOrder: 5700,
      category: "floralTools",
      name: 'עציץ פלסטיק קוניקו 17 ס"מ',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "אפור בהיר/ירוק כהה ובהיר/שחור/חום בהיר/לבן/שמנת",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t526.jpg",
    },
    {
      id: "t527",
      sortOrder: 5410,
      category: "floralTools",
      name: 'תחתית פלסטיק שוליים גבוהים 12 ס"מ',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "לבן/צהוב/חום בהיר/ירוק כהה ובהיר/שחור/שמנת",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t527.jpg",
    },
    {
      id: "t528",
      sortOrder: 5140,
      category: "floralTools",
      name: 'פלייסמט חבל עגול 25 ס"מ 40070 41488',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "מוצר ימני",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t528.jpg",
    },
    {
      id: "t529",
      sortOrder: 5130,
      category: "floralTools",
      name: "פלייסמט חבל אובלי 55/40 40031 41478",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t529.jpg",
    },
    {
      id: "t530",
      sortOrder: 5120,
      category: "floralTools",
      name: "פלייסמט חבל אובלי 42/26 40030 41786",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t530.jpg",
    },
    {
      id: "t531",
      sortOrder: 5160,
      category: "floralTools",
      name: 'פמוט קריסטל 16.5 ס"מ',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t531.jpg",
    },
    {
      id: "t532",
      sortOrder: 5150,
      category: "floralTools",
      name: 'פמוט קריסטל 14 ס"מ',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t532.jpg",
    },
    {
      id: "t533",
      sortOrder: 3110,
      category: "floralTools",
      name: 'זכוכית פרימיום 10 ס"מ VAZA',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "שקוף/ורוד/לבן",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t533.jpg",
    },
    {
      id: "t534",
      sortOrder: 3460,
      category: "floralTools",
      name: 'זכוכית פרימיום 12 ס"מ VAZA',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "ורוד/שקוף/שחור/לבן",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t534.jpg",
    },
    {
      id: "t535",
      sortOrder: 3470,
      category: "floralTools",
      name: 'זכוכית פרימיום 15 ס"מ VAZA',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "ורוד/שקוף/שחור",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t535.jpg",
    },
    {
      id: "t536",
      sortOrder: 4480,
      category: "floralTools",
      name: "גביע מתכת כסף פרחוני זאוס 50305 D10H12",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t536.jpg",
    },
    {
      id: "t537",
      sortOrder: 4240,
      category: "floralTools",
      name: "בקבוק אינקי קארו 7 שקוף J42382 D2H10W7.",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t537.jpg",
    },
    {
      id: "t538",
      sortOrder: 5930,
      category: "floralTools",
      name: "*מבצע! בקבוק פסים שקוף D14.5H31 43430*",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t538.jpg",
    },
    {
      id: "t539",
      sortOrder: 5940,
      category: "floralTools",
      name: "*מבצע! בקבוק פסים שקוף D9.5H21 43429*",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t539.jpg",
    },
    {
      id: "t540",
      sortOrder: 2900,
      category: "floralTools",
      name: "זכוכית אקו גיגי H20D19 35240.",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t540.jpg",
    },
    {
      id: "t541",
      sortOrder: 2880,
      category: "floralTools",
      name: "זכוכית אקו אטלס H15D14 80090.",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t541.jpg",
    },
    {
      id: "t542",
      sortOrder: 2890,
      category: "floralTools",
      name: "זכוכית אקו ברווז H24D26 J41553.",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t542.jpg",
    },
    {
      id: "t543",
      sortOrder: 4370,
      category: "floralTools",
      name: "בקבוק עם פקק שעם H30D18 J40354.",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t543.jpg",
    },
    {
      id: "t544",
      sortOrder: 4250,
      category: "floralTools",
      name: "בקבוק אקו טרריום H25D24 J37655.",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t544.jpg",
    },
    {
      id: "t545",
      sortOrder: 4260,
      category: "floralTools",
      name: "בקבוק אקו טרריום H35D34 J37656.",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t545.jpg",
    },
    {
      id: "t546",
      sortOrder: 4930,
      category: "floralTools",
      name: "מכסה שעם D14 J43111.",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t546.jpg",
    },
    {
      id: "t547",
      sortOrder: 4100,
      category: "floralTools",
      name: "אדנית קקטוס 12-30 REC לבנה בלבד",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "לבן",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t547.jpg",
    },
    {
      id: "t548",
      sortOrder: 4090,
      category: "floralTools",
      name: "אדנית קקטוס 10-41 REC- לבנה בלבד",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "לבן",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t548.jpg",
    },
    {
      id: "t549",
      sortOrder: 3490,
      category: "floralTools",
      name: 'סל בזיליקום ידיות טבעי 38 ס"מ פס לבן (תואם לדלי 15 ליטר)',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t549.jpg",
    },
    {
      id: "t550",
      sortOrder: 1780,
      category: "floralTools",
      name: 'אגרטל אמיליה מגורען 20 ס"מ 19582 16810',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t550.jpg",
    },
    {
      id: "t551",
      sortOrder: 5390,
      category: "floralTools",
      name: "שקית עטיפת נייר עציץ 12",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t551.jpg",
    },
    {
      id: "t552",
      sortOrder: 5760,
      category: "floralTools",
      name: "קערה שטוחה מעוגלת 1304 ST-24",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "לבן",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t552.jpg",
    },
    {
      id: "t553",
      sortOrder: 3630,
      category: "floralTools",
      name: 'סל רימון ידיות טבעי 38 ס"מ 2181-16 (תואם לדלי 15 ליטר)',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t553.jpg",
    },
    {
      id: "t554",
      sortOrder: 1050,
      category: "floralTools",
      name: 'קרמיקה קוביה 7.5 ס"מ 40679 דו צבע',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t554.jpg",
    },
    {
      id: "t555",
      sortOrder: 5770,
      category: "floralTools",
      name: 'קערת פלסטיק 25 ס"מ טקסס TEXAS',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "שמנת/לבן/שחור",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t555.jpg",
    },
    {
      id: "t556",
      sortOrder: 5110,
      category: "floralTools",
      name: 'פלייסמט בננה עגול 50 ס"מ 2181-11XL',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t556.jpg",
    },
    {
      id: "t557",
      sortOrder: 3300,
      category: "floralTools",
      name: 'קערה זכוכית אוולית 28 ס"מ 39542',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t557.jpg",
    },
    {
      id: "t558",
      sortOrder: 5230,
      category: "floralTools",
      name: "קערה בטון 8-16 NATURAL נטורל 42099-1",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t558.jpg",
    },
    {
      id: "t559",
      sortOrder: 5220,
      category: "floralTools",
      name: "קערה בטון 12-30 NATURAL נטורל",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t559.jpg",
    },
    {
      id: "t560",
      sortOrder: 2420,
      category: "floralTools",
      name: 'אגרטל קרמי דקורטבעי 38 ס"מ 40840',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t560.jpg",
    },
    {
      id: "t561",
      sortOrder: 3390,
      category: "floralTools",
      name: 'אגרטל קרמי דקורטבעי 34 ס"מ 40841',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t561.jpg",
    },
    {
      id: "t562",
      sortOrder: 2430,
      category: "floralTools",
      name: 'אגרטל קרמי דקורטבעי 40 ס"מ 40843',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t562.jpg",
    },
    {
      id: "t563",
      sortOrder: 2410,
      category: "floralTools",
      name: 'אגרטל קרמי דקורטבעי 33 ס"מ 40844',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t563.jpg",
    },
    {
      id: "t564",
      sortOrder: 4440,
      category: "floralTools",
      name: "בקבוק קארו טנגו פסים קטן שקוף D2.5/6.2XH10 J39387.",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "שקוף",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t564.jpg",
    },
    {
      id: "t565",
      sortOrder: 4890,
      category: "floralTools",
      name: 'מגש עץ טיק קצר 28 ס"מ',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t565.jpg",
    },
    {
      id: "t566",
      sortOrder: 4460,
      category: "floralTools",
      name: "גביע זהב פתח רחב זאוס 50306 D20H15",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t566.jpg",
    },
    {
      id: "t567",
      sortOrder: 4490,
      category: "floralTools",
      name: "גביע קערה זהב חורים זאוס 50307 D16H15",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t567.jpg",
    },
    {
      id: "t568",
      sortOrder: 5170,
      category: "floralTools",
      name: 'פרוסות עץ 8 ס"מ (מארז 6 יח)',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t568.jpg",
    },
    {
      id: "t569",
      sortOrder: 5540,
      category: "floralTools",
      name: 'אדנית פל עם תחתית 50 ס"מ קולורדו',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "שחור/לבן/אפור/ירוק כהה",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t569.jpg",
    },
    {
      id: "t570",
      sortOrder: 5550,
      category: "floralTools",
      name: 'אדנית פל עם תחתית 60 ס"מ קולורדו',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "לבן/ירוק בהיר/חום בהיר/אפור",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t570.jpg",
    },
    {
      id: "t571",
      sortOrder: 4320,
      category: "floralTools",
      name: "בקבוק טיפת גשם 11/9 41918 42691",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t571.jpg",
    },
    {
      id: "t572",
      sortOrder: 4330,
      category: "floralTools",
      name: "בקבוק טיפת גשם 12/9 419119",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t572.jpg",
    },
    {
      id: "t573",
      sortOrder: 4340,
      category: "floralTools",
      name: "בקבוק טיפת גשם 12/9 419120 50133",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t573.jpg",
    },
    {
      id: "t574",
      sortOrder: 3900,
      category: "floralTools",
      name: "*סט עששית עיגול ברזל גדול BRF 99035 Q20/Q25/Q30*",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t574.jpg",
    },
    {
      id: "t575",
      sortOrder: 470,
      category: "floralTools",
      name: "כלי איזי ענתיק טרקוטה לבן עם אוזניים MA300 40X20",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "מוצר ימני",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t575.jpg",
    },
    {
      id: "t576",
      sortOrder: 460,
      category: "floralTools",
      name: "כלי איזי ענתיק טרקוטה לבן עם אוזניים 60X25 MA301",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "מוצר שמאלי",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t576.jpg",
    },
    {
      id: "t577",
      sortOrder: 4060,
      category: "floralTools",
      name: "אדנית פלסטיק מעוצבת 20X20X60 BRN",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "לבן",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t577.jpg",
    },
    {
      id: "t578",
      sortOrder: 4070,
      category: "floralTools",
      name: "אדנית פלסטיק מעוצבת 30X30X80 BRN",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "שחור/כחול כהה",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t578.jpg",
    },
    {
      id: "t579",
      sortOrder: 4080,
      category: "floralTools",
      name: "אדנית פלסטיק מעוצבת 40X40X100 BRN",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "כחול כהה/שחור",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t579.jpg",
    },
    {
      id: "t580",
      sortOrder: 4660,
      category: "floralTools",
      name: "כד יווני עם ידיות גדול H50D48 42595 2409-10 (לבדוק זמינות צבעים!)",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "לבן/חום משופשף/לבן משופשף/אפור בטון",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t580.jpg",
    },
    {
      id: "t581",
      sortOrder: 1670,
      category: "floralTools",
      name: "קרמיקה קתרגו גדול H31XD28 GX23037A",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t581.jpg",
    },
    {
      id: "t582",
      sortOrder: 1200,
      category: "floralTools",
      name: "קרמיקה קתרגו קטן H24XD22 GX23037B",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "*קרם אין במלאי*",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t582.jpg",
    },
    {
      id: "t583",
      sortOrder: 1220,
      category: "floralTools",
      name: "קרמיקה קתרגו H22.5XD21.5XW22.5 GX23038A",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "ירוק / צהוב / אדום / חום / לבן",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t583.jpg",
    },
    {
      id: "t584",
      sortOrder: 1210,
      category: "floralTools",
      name: "קרמיקה קתרגו H21XD17XW21 קרמיקה קתרגו GX23038B (ללא לבן)",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "ירוק / צהוב / אדום / חום",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t584.jpg",
    },
    {
      id: "t585",
      sortOrder: 660,
      category: "floralTools",
      name: "קרמיקה אגרטל קתרגו  H29D15 GX23039A",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t585.jpg",
    },
    {
      id: "t586",
      sortOrder: 1190,
      category: "floralTools",
      name: "קרמיקה קתרגו על בסיס ע.15 GX23040A",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "*אין קרם במלאי*",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t586.jpg",
    },
    {
      id: "t587",
      sortOrder: 1180,
      category: "floralTools",
      name: "קרמיקה קתרגו על בסיס ע.12 GX23040B",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "ירוק / צהוב / אדום / חום / לבן",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t587.jpg",
    },
    {
      id: "t588",
      sortOrder: 1170,
      category: "floralTools",
      name: "קרמיקה קתרגו על בסיס ע.10 GX23040C",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t588.jpg",
    },
    {
      id: "t589",
      sortOrder: 1160,
      category: "floralTools",
      name: "קרמיקה קתרגו ע.14 GX25067A",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "ירוק / צהוב / אדום / חום / לבן",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t589.jpg",
    },
    {
      id: "t590",
      sortOrder: 1150,
      category: "floralTools",
      name: "קרמיקה קתרגו ע.12 GX25067B",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "ירוק/צהוב/אדום/חום/לבן",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t590.jpg",
    },
    {
      id: "t591",
      sortOrder: 1140,
      category: "floralTools",
      name: "קרמיקה קתרגו ע.10 GX25067C",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "צבע מנטה בלבד",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t591.jpg",
    },
    {
      id: "t592",
      sortOrder: 480,
      category: "floralTools",
      name: "מארז קרטון 3 בקבוקי קרמיקה מרובעים גווני ניוד 021051A",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t592.jpg",
    },
    {
      id: "t593",
      sortOrder: 2450,
      category: "floralTools",
      name: "אגרטל NANU H32W22D5 021115A.",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t593.jpg",
    },
    {
      id: "t594",
      sortOrder: 4530,
      category: "floralTools",
      name: "חבית NANU 021030A D20H28.",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t594.jpg",
    },
    {
      id: "t595",
      sortOrder: 840,
      category: "floralTools",
      name: "קרמיקה מידבר 6000 + תחתית 26X26X20",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t595.jpg",
    },
    {
      id: "t596",
      sortOrder: 850,
      category: "floralTools",
      name: "קרמיקה מידבר 6000 + תחתית 37X37X28",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t596.jpg",
    },
    {
      id: "t597",
      sortOrder: 860,
      category: "floralTools",
      name: "קרמיקה מידבר 6000 + תחתית 46X46X36",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t597.jpg",
    },
    {
      id: "t598",
      sortOrder: 5980,
      category: "floralTools",
      name: 'טרקוטה עציץ 43 ס"מ',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t598.jpg",
    },
    {
      id: "t599",
      sortOrder: 5990,
      category: "floralTools",
      name: "שק קליפות אורן 70 ליטר",
      minQuantity: 1,
      maxQuantity: 199,
      comment:
        "בהזמנה מעל 5 שקים תחוייב הובלה של 300 שקל אוטומטית בלי הודעה ללקוח",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t599.jpg",
    },
    {
      id: "t600",
      sortOrder: 6000,
      category: "floralTools",
      name: 'קערה צילינדר 15 ס"מ 704016 2362-1',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t600.jpg",
    },
    {
      id: "t601",
      sortOrder: 6010,
      category: "floralTools",
      name: "מרקו פולו זכוכית שולחני H15XD8 2574 2550-4",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t601.jpg",
    },
    {
      id: "t602",
      sortOrder: 6020,
      category: "floralTools",
      name: "מתלה ברזל מודולרי לאדנית  2163-40 (מתלה בודד)",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t602.jpg",
    },
    {
      id: "t603",
      sortOrder: 6030,
      category: "floralTools",
      name: 'קרמיקה ביצה חלקה 18 ס"מ + תחתית 24008',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "קרם/ירוק זוהר",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t603.jpg",
    },
    {
      id: "t604",
      sortOrder: 6040,
      category: "floralTools",
      name: 'טרקוטה מוקה עציץ 15 ס"מ',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t604.jpg",
    },
    {
      id: "t605",
      sortOrder: 6050,
      category: "floralTools",
      name: "בקבוק אפור פתח 7 גובה 16 2352-50",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t605.jpg",
    },
    {
      id: "t606",
      sortOrder: 6060,
      category: "floralTools",
      name: 'מלאי מוגבל! כלי אלומיניום דקורטיבי 12 ס"מ',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t606.jpg",
    },
    {
      id: "t607",
      sortOrder: 6070,
      category: "floralTools",
      name: 'מלאי מוגבל! כלי אלומיניום דקורטיבי 15 ס"מ',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t607.jpg",
    },
    {
      id: "t608",
      sortOrder: 6080,
      category: "floralTools",
      name: 'מלאי מוגבל! כלי אלומיניום דקורטיבי 18 ס"מ',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t608.jpg",
    },
    {
      id: "t609",
      sortOrder: 6090,
      category: "floralTools",
      name: 'מלאי מוגבל! כלי אלומיניום דקורטיבי 24 ס"מ',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t609.jpg",
    },
    {
      id: "t610",
      sortOrder: 6100,
      category: "floralTools",
      name: "זכוכית לבן 9.5/13 2352-58",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t610.jpg",
    },
    {
      id: "t611",
      sortOrder: 6110,
      category: "floralTools",
      name: "צלוחית מישל לפרח בודד 2352-57",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t611.jpg",
    },
    {
      id: "t612",
      sortOrder: 6120,
      category: "floralTools",
      name: "קרמיקה עין הוד אדנית אובאלית 8-25-13 MOR (לבן//ירוק)",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "לבן/ירוק/טורקיז",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t612.jpg",
    },
    {
      id: "t613",
      sortOrder: 6130,
      category: "floralTools",
      name: "סל בינוני שזור ידיות ברזל 14511 H49D43",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t613.jpg",
    },
    {
      id: "t614",
      sortOrder: 6140,
      category: "floralTools",
      name: 'טרקוטה מוקה עציץ 19 ס"מ',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t614.jpg",
    },
    {
      id: "t615",
      sortOrder: 6150,
      category: "floralTools",
      name: 'טרקוטה מוקה עציץ 23 ס"מ',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t615.jpg",
    },
    {
      id: "t616",
      sortOrder: 6160,
      category: "floralTools",
      name: 'קרמיקה ביצה פסים 14 ס"מ + תחתית 205900',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "המוצר הימני",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t616.jpg",
    },
    {
      id: "t617",
      sortOrder: 6170,
      category: "floralTools",
      name: 'עציץ צמיג חלק ע.12 ס"מ 19030',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t617.jpg",
    },
    {
      id: "t618",
      sortOrder: 6180,
      category: "floralTools",
      name: "קרמיקה חרוצה ע.15 ST-01",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t618.jpg",
    },
    {
      id: "t619",
      sortOrder: 6190,
      category: "floralTools",
      name: "ואזה אורגני 430/9585 H30 אגוז",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t619.jpg",
    },
    {
      id: "t620",
      sortOrder: 6200,
      category: "floralTools",
      name: "ואזה בלום H30 430/9584 אגוז",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t620.jpg",
    },
    {
      id: "t621",
      sortOrder: 6210,
      category: "floralTools",
      name: "ואזה אובל H40 430/9577 אגוז",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t621.jpg",
    },
    {
      id: "t622",
      sortOrder: 6220,
      category: "floralTools",
      name: "ענף תפוחים אדומים/ירוקים מלאכותי",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t622.jpg",
    },
    {
      id: "t623",
      sortOrder: 6230,
      category: "floralTools",
      name: "ענף רימונים אדומים מלאכותי",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t623.jpg",
    },
    {
      id: "t624",
      sortOrder: 6240,
      category: "floralTools",
      name: 'בקבוק מנופח שקוף 25 ס"מ (בומבה קטנה) 42239 42070',
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t624.jpg",
    },
    {
      id: "t625",
      sortOrder: 6250,
      category: "floralTools",
      name: "כד חלב פח גדול 0289-7 H28D15",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t625.jpg",
    },
    {
      id: "t626",
      sortOrder: 6260,
      category: "floralTools",
      name: "חצי טרריום בוב J42111 H12D13.(אספקה עד 72 שעות!!!)",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t626.jpg",
    },
    {
      id: "t627",
      sortOrder: 6270,
      category: "floralTools",
      name: "מבצע קרמיקה קתרגו גדול H31XD28 GX23037A",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: true,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t627.jpg",
    },
    {
      id: "t628",
      sortOrder: 6280,
      category: "floralTools",
      name: "מבצע קרמיקה קתרגו H22.5XD21.5XW22.5 GX23038A",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t628.jpg",
    },
    {
      id: "t629",
      sortOrder: 6290,
      category: "floralTools",
      name: "קרמיקה אגרטל קתרגו H21D12 GX23039B",
      minQuantity: 1,
      maxQuantity: 199,
      comment: "",
      needsCommentAnswer: false,
      userCommentAnswer: "",
      imageURL: "/products/floralTools/t629.jpg",
    },
  ],
};

const productsSlice = createSlice({
  name: "products",
  initialState,
  reducers: {},
});

export const selectProducts = (state) =>
  [...state.products.products].sort(
    (first, second) =>
      (first.sortOrder ?? Number(first.id.slice(1)) * 10) -
      (second.sortOrder ?? Number(second.id.slice(1)) * 10),
  );
export default productsSlice.reducer;
